<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            v-if="
              !editMode ||
              trainingEvent == null ||
              trainingEvent.training == null
            "
            style="
              background: url('/static/img/graph_pen.jpg');
              background-position: top !important;
            "
          ></div>
          <div
            class="kachelimage header-image zoom-image"
            v-else
            :style="{
              background:
                'url(\'/files/images/' +
                trainingEvent.training.category.image +
                '\'); background-position: top !important;',
            }"
          ></div>
          <div v-if="!editMode" class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("create_trainingEvent") }}
              </div>
            </div>
          </div>
          <div v-else class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{
                  $user != null && $user.booker
                    ? $t("book_to_event")
                    : $t("edit_trainingEvent")
                }}
                <img
                  class="ml-2"
                  src="../assets/img/arrow_right.svg"
                  height="18px"
                /><img
                  class="mr-2"
                  src="../assets/img/arrow_right.svg"
                  height="18px"
                />
                {{
                  trainingEvent.eventNumber != null
                    ? trainingEvent.eventNumber
                    : trainingEvent.training != null
                    ? trainingEvent.training.designationsMap[$locale]
                    : null
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb v-else :trainingNameEdit="trainingEvent.eventNumber" />
    <div>
      <div class="pt-8">
        <div class="row disablerow justify-content-between align-items-start">
          <!-- Tabs -->
          <v-tabs
            v-model="trainingEventTab"
            align-with-title
            touchless
            class="col-md-12 col-xl-9 pb-0 LanguageselectTabgroup lstg_new pt-md-4 pt-lg-0 pl-md-8 pl-4"
          >
            <v-tabs-slider color="indigo"></v-tabs-slider>

            <v-tab
              class="LanguageselectTab"
              :disabled="
                !$rights.includes('CREATE_TRAINING_EVENT') &&
                !$rights.includes('VIEW_OTHERS_APPOINTMENTS')
              "
              :hidden="
                !$rights.includes('CREATE_TRAINING_EVENT') &&
                !$rights.includes('VIEW_OTHERS_APPOINTMENTS')
              "
            >
              {{ $t("edit_trainingEvent") }}
            </v-tab>

            <v-tab class="LanguageselectTab">
              {{
                $rights.includes("CREATE_TRAINING_EVENT")
                  ? $t("preview")
                  : $t("details")
              }}
            </v-tab>
            <v-tab
              class="LanguageselectTab"
              :disabled="
                !editMode ||
                eventStatus === 'drafted' ||
                ($user && $user.onlySalesPerson)
              "
            >
              <span>{{ $t("participants") }}</span>
            </v-tab>
            <v-tab
              class="LanguageselectTab"
              :disabled="
                !editMode ||
                !$rights.includes('CREATE_BOOKING') ||
                eventStatus === 'drafted'
              "
              :hidden="!$rights.includes('CREATE_BOOKING') || $user == null"
            >
              {{ $t("add_participants") }}
            </v-tab>
            <v-tab
              class="LanguageselectTab"
              :disabled="
                !editMode ||
                eventStatus === 'drafted' ||
                !$rights.includes('VIEW_ONLINE_FEEDBACK_FORM')
              "
              :hidden="
                !$rights.includes('CREATE_TRAINING_EVENT') &&
                !$rights.includes('VIEW_OTHERS_APPOINTMENTS')
              "
            >
              {{ $t("onlineFeedbackForms") }}
            </v-tab>

            <v-tab
              class="LanguageselectTab"
              :disabled="
                !editMode ||
                eventStatus === 'drafted' ||
                !$rights.includes('VIEW_MANNUAL_FEEDBACK_FORM')
              "
              :hidden="
                !$rights.includes('CREATE_TRAINING_EVENT') &&
                !$rights.includes('VIEW_OTHERS_APPOINTMENTS')
              "
            >
              {{ $t("manualFeedbackForms") }}
            </v-tab>

            <v-tab
              class="LanguageselectTab"
              :disabled="
                !editMode ||
                !$rights.includes('CREATE_TRAINING_EVENT') ||
                !$rights.includes('SEAT_SHARE') ||
                eventStatus === 'drafted' ||
                this.trainingEvent.status === 'BOOKABLE'
              "
              :hidden="
                !$rights.includes('CREATE_TRAINING_EVENT') || $user == null
              "
            >
              {{ $t("seatShare") }}
            </v-tab>
          </v-tabs>
          <div class="col-xl-9 px-8 pr-3 pl-3 pb-5 pt-0 innercreatetraining">
            <!-- Put Content here -->
            <v-tabs-items v-model="trainingEventTab" touchless>
              <!-- Tab for Editing Training Event -->
              <v-tab-item>
                <div class="col-sm-6 col-md-6 mt-2 mt-5">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('eventNumber') + '*'"
                    v-model="trainingEvent.eventNumber"
                    :disabled="
                      ($user != null &&
                        $user.trainer &&
                        !$rights.includes(
                          'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                        )) ||
                      disableEventNumber
                    "
                  ></v-text-field>
                </div>
                <div
                  class="row disablerow justify-content-between training-event-left-form"
                >
                  <div class="col-md-6 row disablerow">
                    <div class="col-md-12 pt-0">
                      <div class="headlinecolor text-h6">
                        {{ $t("general") }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="selectableExamTypes"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('examType') + '*'"
                        v-model="trainingEvent.examType"
                        @change="setDateTimeColumns"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-select>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="$selectableLanguages"
                        item-value="key"
                        item-text="translatedName"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('language') + '*'"
                        v-model="trainingEvent.language"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-select>
                    </div>

                    <div>
                      <div class="col-md-12 pt-0" v-if="TH_1 || TH_2 || TH_3">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }}
                        </div>
                      </div>
                      <div class="date-time-block pt-4" v-if="TH_1">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 1 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_TH_1,
                              trainingEvent.endDate_TH_1
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_TH_1"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_TH_1"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_TH_1"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_TH_1"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_TH_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_TH_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- trainer end -->
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_TH_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                            a
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_TH_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_TH_1',
                                'trainingEvent.roomId_TH_1'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_TH_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_TH_1"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_TH_1"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="date-time-block pt-4" v-if="TH_2">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 2 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_TH_2,
                              trainingEvent.endDate_TH_2
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_TH_2"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_TH_2"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_TH_2"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_TH_2"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_TH_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_TH_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- triner end -->

                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_TH_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_TH_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_TH_2',
                                'trainingEvent.roomId_TH_2'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_TH_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_TH_2"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_TH_2"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="date-time-block pt-4" v-if="TH_3">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 3 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_TH_3,
                              trainingEvent.endDate_TH_3
                            )
                          }}
                        </div>

                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_TH_3"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_TH_3"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_TH_3"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_TH_3"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_TH_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_TH_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>

                        <!-- triner end -->
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_TH_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_TH_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_TH_3',
                                'trainingEvent.roomId_TH_3'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_TH_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_TH_3"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_TH_3"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="date-time-block pt-4" v-if="PR_ST">
                        <div class="headlinecolor text-h6">
                          {{ selectedExamTypeText }} :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate,
                              trainingEvent.endDate
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainer2Id"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- trainer end -->
                        <div class="col-12 col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms',
                                'trainingEvent.roomId'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              (editMode &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              (editMode &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlineLink"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>

                        <!-- end -->
                      </div>

                      <div class="col-md-12 pt-0" v-if="PR_1 || PR_2 || PR_3">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }}
                        </div>
                      </div>

                      <div class="date-time-block pt-4" v-if="PR_1">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 1 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_PR_1,
                              trainingEvent.endDate_PR_1
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_PR_1"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_PR_1"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                            clearable
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_PR_1"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_PR_1"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_PR_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_PR_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- trainer end -->
                        <div class="col-12 col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_PR_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_PR_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_PR_1',
                                'trainingEvent.roomId_PR_1'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_PR_1"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_PR_1"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_PR_1"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>

                        <!-- end -->
                      </div>

                      <div class="date-time-block pt-4" v-if="PR_2">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 2 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_PR_2,
                              trainingEvent.endDate_PR_2
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_PR_2"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_PR_2"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_PR_2"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_PR_2"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_PR_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_PR_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- trainer end -->
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_PR_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_PR_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_PR_2',
                                'trainingEvent.roomId_PR_2'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-sm-6 col-md-6 pb-1">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_PR_2"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_PR_2"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_PR_2"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <!-- end -->
                      </div>

                      <div class="date-time-block pt-4" v-if="PR_3">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 3 :
                          {{
                            calculateDateDifference(
                              trainingEvent.startDate_PR_3,
                              trainingEvent.endDate_PR_3
                            )
                          }}
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.startDate_PR_3"
                            clearable
                            :label="$t('begin_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('begin_time_format') + '*'"
                            v-model="trainingEvent.startTime_PR_3"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <DatePicker
                            v-model="trainingEvent.endDate_PR_3"
                            clearable
                            :label="$t('end_date') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('end_time_format') + '*'"
                            v-model="trainingEvent.endTime_PR_3"
                            clearable
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId_PR_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            :label="$t('first_trainer') + '*'"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.trainerId2_PR_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="trainers"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('second_trainer')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                          </v-autocomplete>
                        </div>
                        <!-- triner end -->
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.translatorId_PR_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="translators"
                            item-text="fullname"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            :label="$t('translator')"
                            :disabled="
                              $user != null &&
                              $user.trainer &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          >
                            <template v-slot:item="data">
                              <span v-if="data != null && data.item != null">{{
                                data.item.fullname
                              }}</span>
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                            <template v-slot:selection="data">
                              <span
                                v-if="data != null && data.item != null"
                                style="color: black"
                                >{{ data.item.fullname }}</span
                              >
                              <img
                                v-for="language in data.item.languages"
                                :key="language"
                                class="ml-2"
                                style="
                                  width: 26px;
                                  height: 17px;
                                  vertical-align: unset;
                                "
                                :src="'/files/flags/' + language.flag"
                              />
                            </template>
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0">
                          <v-autocomplete
                            v-model="trainingEvent.selectedLocationId_PR_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="locations"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            @change="
                              fetchRooms(
                                $event,
                                true,
                                'rooms_PR_3',
                                'trainingEvent.roomId_PR_3'
                              )
                            "
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('location') + '*'"
                          >
                          </v-autocomplete>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <v-autocomplete
                            v-model="trainingEvent.roomId_PR_3"
                            hide-details="auto"
                            class="datainput justify-content-end searchbar align-self-center pb-1"
                            :items="rooms_PR_3"
                            item-text="designation"
                            item-value="id"
                            style="padding-right: 2px"
                            :disabled="
                              locationAndRoomDisabled ||
                              ($user != null &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            dense
                            outlined
                            clearable
                            :label="$t('room') + '*'"
                          >
                          </v-autocomplete>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 pl-sm-0 pb-1">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('onlineLink')"
                            v-model="trainingEvent.onlinelink_PR_3"
                            :disabled="
                              $user != null &&
                              !$rights.includes(
                                'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                              )
                            "
                          ></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-12 mt-8">
                      <v-select
                        hide-details="auto"
                        :items="selectableStatus"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('status') + '*'"
                        v-model="trainingEvent.status"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-select>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        type="number"
                        :min="1"
                        :label="$t('minParticipants') + '*'"
                        v-model="trainingEvent.minParticipants"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-text-field>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        type="number"
                        :min="1"
                        :label="$t('maxParticipants') + '*'"
                        v-model="trainingEvent.maxParticipants"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-text-field>
                    </div>

                    <div class="col-sm-12 col-md-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('serviceOrderNumber')"
                        v-model="trainingEvent.serviceOrderNumber"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="col-md-6 disablerow">
                    <div class="col-md-12 pt-0">
                      <div class="headlinecolor text-h6">
                        {{ $t("trainingEvent_details") }}
                      </div>
                    </div>
                    <div class="col-md-12">
                      <v-autocomplete
                        v-model="trainingEvent.eventTrainingCategoryId"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="trainingEventCategories1"
                        item-text="text"
                        item-value="value"
                        style="padding-right: 2px"
                        dense
                        outlined
                        clearable
                        @change="disableTraining()"
                        :label="$t('training_event_category')"
                        :disabled="
                          trainingCategoryDisabled ||
                          ($user != null &&
                            $user.trainer &&
                            !$rights.includes(
                              'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                            ))
                        "
                      >
                      </v-autocomplete>
                    </div>
                    <div v-if="filteredCategories" class="col-md-12">
                      <p class="training-category-lebel">
                        {{ $t("category") }}
                      </p>
                      <div class="list-component list-componant-wrapper">
                        <v-list class="v-list-flex v-list_custom">
                          <v-list-item
                            class="v-list-item-wrap"
                            v-for="cat in filteredCategories"
                            :key="cat.value"
                          >
                            <v-list-item-content>
                              {{ cat.text }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </div>
                    <!--    <div class="col-md-12">
                      <v-autocomplete
                        v-model="trainingEvent.trainingId"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="trainings"
                        item-text="text"
                        item-value="id"
                        style="padding-right: 2px"
                        dense
                        outlined
                        :label="$t('training')"
                      >
                      </v-autocomplete>
                    </div>    -->

                    <div class="col-12">
                      <v-tooltip slot="append" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-autocomplete
                            v-model="trainingEvent.trainingId"
                            hide-details="auto"
                            class="datainput mb-6 justify-content-end searchbar align-self-center pb-1"
                            :items="sortedTrainings"
                            item-text="text"
                            item-value="id"
                            style="padding-right: 2px"
                            dense
                            outlined
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            :label="$t('training')"
                            :disabled="
                              trainingDisabled ||
                              ($user != null &&
                                $user.trainer &&
                                !$rights.includes(
                                  'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                                ))
                            "
                            @change="disableTrainingEventCategory()"
                          >
                          </v-autocomplete>
                        </template>
                      </v-tooltip>
                      <div
                        class="mb-6"
                        v-if="
                          trainingEvent.eventTrainingCategoryId ||
                          trainingEvent.trainingId
                        "
                      >
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('vehicleType')"
                          v-model="trainingEvent.vehicleType"
                        ></v-text-field>
                      </div>
                      <div>
                        <v-select
                          hide-details="auto"
                          dense
                          outlined
                          class="datainput"
                          :items="types"
                          :label="$t('training_event_type') + '*'"
                          item-text="text"
                          item-value="value"
                          v-model="trainingEvent.eventType"
                          :disabled="
                            $user != null &&
                            $user.trainer &&
                            !$rights.includes(
                              'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                            )
                          "
                          clearable
                        ></v-select>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('project')"
                        v-model="trainingEvent.project"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-text-field>
                    </div>

                    <div class="col-md-12 pb-1">
                      <v-autocomplete
                        v-model="trainingEvent.customerId"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="customers"
                        item-text="name"
                        item-value="id"
                        style="padding-right: 2px"
                        dense
                        outlined
                        clearable
                        :label="
                          this.trainingEvent.status === 'BOOKABLE'
                            ? $t('customer')
                            : $t('customer') + '*'
                        "
                        :disabled="
                          ($user != null &&
                            $user.trainer &&
                            !$rights.includes(
                              'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                            )) ||
                          customerDisabled
                        "
                      >
                      </v-autocomplete>
                    </div>

                    <div class="col-md-12 pt-0">
                      <v-checkbox
                        v-model="trainingEvent.withPSA"
                        class="no-margin-top"
                        :label="$t('employment_protection_needed')"
                        :disabled="
                          $user != null &&
                          $user.trainer &&
                          !$rights.includes(
                            'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                          )
                        "
                      ></v-checkbox>
                    </div>
                    <div class="col-md-12">
                      <div class="headlinecolor text-h6">
                        {{ $t("upload") }}
                      </div>
                      <div class="uf_note_text">
                        <img
                          class=""
                          src="../assets/img/note.svg"
                          height="12px"
                        /><span>{{ $t("file_upload_note") }}</span>
                      </div>
                      <Upload
                        v-model="trainingEvent.documents"
                        class="uf_note"
                        multiple
                        allowOtherFileTypes
                      />

                      <div class="upload-limit-text mb-4">
                        {{ $t("max_size_1000mb") }}
                      </div>
                      <br />
                      <Upload
                        v-if="$user != null && !$user.isonlyBooker"
                        v-model="trainingEvent.internalDocuments"
                        multiple
                        allowOtherFileTypes
                        internalFiles
                      />
                      <div class="upload-limit-text">
                        {{ $t("max_size_1000mb") }}
                      </div>
                      <v-label
                        v-if="
                          trainingEvent.training != null &&
                          trainingEvent.training.documents != null &&
                          trainingEvent.training.documents.length > 0
                        "
                      >
                        {{ trainingEvent.training.documents.length }}&nbsp;
                        <span
                          v-show="trainingEvent.training.documents.length == 1"
                          >{{ $t("document_from_training") }}</span
                        >
                        <span
                          v-show="trainingEvent.training.documents.length > 1"
                          >{{ $t("documents_from_training") }}</span
                        > </v-label
                      ><br />
                    </div>
                    <div class="col-md-12 mt-1 text-area-create-event">
                      <v-textarea
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('comment')"
                        v-model="trainingEvent.comment"
                        @input="updateCharacterCountComments"
                      ></v-textarea>
                      <span
                        :style="{
                          color:
                            characterCountComments > 6000 ? 'red' : 'inherit',
                        }"
                      >
                        {{ characterCountComments }}</span
                      >
                      /{{ 6000 }} {{ $t("characters") }}
                      <div
                        v-if="characterCountComments > 6000"
                        style="color: red"
                      >
                        {{ $t("characterExceeded") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 text-right">
                  <v-label> * {{ $t("mandatory_fields") }} </v-label>
                </div>
              </v-tab-item>

              <!-- Tab for Preview or Details -->
              <v-tab-item>
                <div
                  class="headlinecolor text-h6 col-md-6 ml-3 border border-np mt-5"
                >
                  <b>{{ $t("eventNumber") }}:</b>
                  <span class="text-dark pl-2">{{
                    trainingEvent.eventNumber
                  }}</span>
                </div>
                <div
                  class="mx-0 pa-0 text-content row disablerow justify-content-between align-items-start dv_space"
                >
                  <div class="col-md-6 px-0">
                    <div class="col-md-12 pt-0">
                      <div class="headlinecolor text-h6">
                        {{ $t("general") }}
                      </div>
                    </div>

                    <div
                      class="col-md-12"
                      v-if="trainingEvent.training_event_category != null"
                    >
                      <b>{{ $t("training_event_category") }}:</b>
                      {{
                        trainingEvent.training_event_category.designationsMap[
                          $locale
                        ]
                      }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="
                        trainingEvent.training_event_category == null &&
                        trainingEvent.eventTrainingCategoryId != null
                      "
                    >
                      <b>{{ $t("training_event_category") }}:</b>
                      {{
                        getArrayElementById(
                          "trainingEventCategories",
                          trainingEvent.eventTrainingCategoryId
                        ) &&
                        getArrayElementById(
                          "trainingEventCategories",
                          trainingEvent.eventTrainingCategoryId
                        ).designationsMap
                          ? getArrayElementById(
                              "trainingEventCategories",
                              trainingEvent.eventTrainingCategoryId
                            ).designationsMap[$locale]
                          : ""
                      }}
                    </div>

                    <div
                      class="col-md-12"
                      v-if="trainingEvent.training != null"
                    >
                      <b>{{ $t("training") }}:</b>
                      {{
                        trainingEvent.training.designationsMap[$locale]
                          ? trainingEvent.training.designationsMap[$locale]
                          : ""
                      }}
                    </div>
                    <div class="col-md-12" v-if="trainingEvent.project != null">
                      <b>{{ $t("project") }}:</b>
                      {{ trainingEvent.project }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="
                        trainingEvent.training == null &&
                        trainingEvent.trainingId != null
                      "
                    >
                      <b>{{ $t("training") }}:</b>
                      {{
                        getArrayElementById(
                          "trainings",
                          trainingEvent.trainingId
                        ) &&
                        getArrayElementById(
                          "trainings",
                          trainingEvent.trainingId
                        ).designationsMap
                          ? getArrayElementById(
                              "trainings",
                              trainingEvent.trainingId
                            ).designationsMap[$locale]
                          : ""
                      }}
                    </div>

                    <div
                      class="col-md-12"
                      v-if="
                        trainingEvent.serviceOrderNumber != null &&
                        trainingEvent.serviceOrderNumber != ''
                      "
                    >
                      <b>{{ $t("serviceOrderNumber") }}:</b>
                      {{ trainingEvent.serviceOrderNumber }}
                    </div>
                    <div class="col-md-12" v-if="PR_ST">
                      <b>{{ $t("date") }}:</b>
                      {{ trainingEvent.startDateFormatted }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="trainingEvent.timesFormatted && PR_ST"
                    >
                      <b>{{ $t("time") }}:</b>
                      {{ trainingEvent.timesFormatted }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="trainingEvent.training != null"
                    >
                      <b>{{ $t("training_type") }}:</b>
                      {{ $t(trainingEvent.training.type) }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="trainingEvent.eventType != null"
                    >
                      <b>{{ $t("training_event_type") }}:</b>
                      {{ $t(trainingEvent.eventType) }}
                    </div>

                    <div
                      class="col-md-12"
                      v-if="
                        trainingEvent.training == null &&
                        trainingEvent.trainingId != null
                      "
                    >
                      <b>{{ $t("training_type") }}:</b>
                      {{
                        $t(
                          getArrayElementById(
                            "trainings",
                            trainingEvent.trainingId
                          )
                            ? getArrayElementById(
                                "trainings",
                                trainingEvent.trainingId
                              ).type
                            : ""
                        )
                      }}
                    </div>
                    <div class="col-md-12">
                      <b>{{ $t("language") }}:</b>
                      {{ $t(trainingEvent.language) }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="selectedUsers.trainer != null && PR_ST"
                    >
                      <b>{{ $t("trainer") }}:</b>
                      {{ selectedUsers.trainer.fullname }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="selectedUsers.trainer2 != null && PR_ST"
                    >
                      <b>{{ $t("second_trainer") }}:</b>
                      {{ selectedUsers.trainer2.fullname }}
                    </div>
                    <div class="col-md-12">
                      <b>{{ $t("translator") }}:</b>
                      {{ trainingEvent.hasTranslator ? $t("yes") : $t("no") }}
                    </div>
                    <div
                      class="col-md-12"
                      v-if="selectedUsers.translator != null && PR_ST"
                    >
                      <b>{{ $t("translator") }}:</b>
                      {{ selectedUsers.translator.fullname }}
                    </div>
                    <div class="col-md-12">
                      <b>{{ $t("examType") }}:</b>
                      {{ selectedExamTypeText }}
                    </div>
                    <div class="col-md-12">
                      <b>{{ $t("employment_protection_needed") }}:</b>
                      {{ trainingEvent.withPSA ? $t("yes") : $t("no") }}
                    </div>
                    <div class="col-md-12" v-if="trainingEvent.status != null">
                      <b>{{ $t("status") }}:</b> {{ $t(trainingEvent.status) }}
                    </div>
                  </div>
                  <div class="col-md-6 px-0">
                    <div class="col-md-12 pt-0">
                      <div class="headlinecolor text-h6">
                        {{ $t("location") }}
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="trainingEvent.locationFormatted"
                    >
                      <b>{{ $t("address") }}:</b><br />{{
                        trainingEvent.locationFormatted
                      }}
                    </div>
                    <div class="col-md-12" v-if="trainingEvent.roomFormatted">
                      <b>{{ $t("room") }}:</b> {{ trainingEvent.roomFormatted }}
                    </div>

                    <div
                      class="col-md-12 pt-0"
                      v-show="
                        trainingEvent.onlineLink != null ||
                        (trainingEvent.documents != null &&
                          trainingEvent.documents.length > 0) ||
                        (trainingEvent.internalDocuments != null &&
                          trainingEvent.internalDocuments.length > 0)
                      "
                    >
                      <div class="headlinecolor text-h6">
                        {{ $t("further_information") }}
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="trainingEvent.customerId != null"
                    >
                      <b>{{ $t("customer") }}:</b>
                      {{
                        getArrayElementById(
                          "customers",
                          trainingEvent.customerId
                        ).name
                      }}
                    </div>
                    <div class="col-md-12">
                      <b>{{ $t("sharedSeatsWithBelowCompanies") }}</b>
                      <div class="list-component">
                        <v-list class="v-list-flex v-list_custom">
                          <v-list-item
                            v-for="(item, index) in seatShare"
                            :key="index"
                          >
                            <v-list-item-content>
                              {{ displaySeatShare(item) }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <b> {{ $t("availableSeats") }}</b
                      >{{ trainingEvent.freeSpaces - seatOccupied || "" }}
                    </div>
                    <div
                      class="col-md-12"
                      v-show="trainingEvent.onlinelink != null"
                    >
                      <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                        :href="clickableOnlineLink"
                        target="_blank"
                        >{{ trainingEvent.onlinelink }}</a
                      >
                    </div>
                    <div
                      class="col-md-12"
                      v-if="
                        trainingEvent.documents != null &&
                        trainingEvent.documents.length > 0
                      "
                    >
                      <b>{{ $t("documents_for_download") }}:</b><br /><br />
                      <Upload
                        v-model="trainingEvent.documents"
                        multiple
                        allowOtherFileTypes
                        onlyDisplay
                      />
                    </div>
                    <div
                      class="col-md-12"
                      v-if="
                        $user &&
                        !$user.isonlyBooker &&
                        trainingEvent.internalDocuments != null &&
                        trainingEvent.internalDocuments.length > 0
                      "
                    >
                      <b>{{ $t("internal_documents_for_download") }}:</b
                      ><br /><br />
                      <Upload
                        v-model="trainingEvent.internalDocuments"
                        multiple
                        allowOtherFileTypes
                        onlyDisplay
                        internalFiles
                      />
                    </div>
                  </div>
                  <!-- <div class="row align-items-start">
              </div> -->

                  <!-- th start -->
                  <div class="col-md-6" v-if="TH_1 || TH_2 || TH_3">
                    <div v-if="TH_1">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 1
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_TH_1"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_TH_1 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_TH_1"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_TH_1 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_TH_1 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_TH_1.fullname }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_TH_1 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_TH_1.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_TH_1
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_TH_1 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_TH_1.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_TH_1"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_TH_1 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_TH_1 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_TH_1 }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                    <div v-if="TH_2">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 2
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_TH_2"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_TH_2 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_TH_2"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_TH_2 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_TH_2 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_TH_2.fullname }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_TH_2 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_TH_2.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_TH_2
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_TH_2 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_TH_2.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_TH_2"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_TH_2 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_TH_2 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_TH_2 }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                    <div v-if="TH_3">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("therotical_training") }} 3
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_TH_3"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_TH_3 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_TH_3"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_TH_3 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_TH_3 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_TH_3.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_TH_3 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_TH_3.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_TH_3
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_TH_3 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_TH_3.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_TH_3"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_TH_3 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_TH_3 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_TH_3 }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- th end -->
                  <div class="col-md-6" v-if="PR_1 || PR_2 || PR_3">
                    <div v-if="PR_1">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 1
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_PR_1"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_PR_1 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_PR_1"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_PR_1 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_PR_1 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_PR_1.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_PR_1 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_PR_1.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_PR_1
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_PR_1 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_PR_1.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_PR_1"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_PR_1 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_PR_1 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_PR_1 }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                    <div v-if="PR_2">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 2
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_PR_2"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_PR_2 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_PR_2"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_PR_2 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_PR_2 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_PR_2.fullname }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_PR_2 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_PR_2.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_PR_2
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_PR_2 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_PR_2.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_PR_2"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_PR_2 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_PR_2 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_PR_2 }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                    <div v-if="PR_3">
                      <div class="dv_border">
                        <div class="headlinecolor text-h6">
                          {{ $t("practical_training") }} 3
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.startDateFormatted_PR_3"
                        >
                          <b>{{ $t("date") }}:</b>
                          {{ trainingEvent.startDateFormatted_PR_3 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="trainingEvent.timesFormatted_PR_3"
                        >
                          <b>{{ $t("time") }}:</b>
                          {{ trainingEvent.timesFormatted_PR_3 }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer_PR_3 != null"
                        >
                          <b>{{ $t("trainer") }}:</b>
                          {{ selectedUsers.trainer_PR_3.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="selectedUsers.trainer2_PR_3 != null"
                        >
                          <b>{{ $t("second_trainer") }}:</b>
                          {{ selectedUsers.trainer2_PR_3.fullname }}
                        </div>
                        <div class="col-md-12">
                          <b>{{ $t("translator") }}:</b>
                          {{
                            trainingEvent.hasTranslator_PR_3
                              ? $t("yes")
                              : $t("no")
                          }}
                        </div>
                        <div
                          class="col-md-12"
                          v-if="selectedUsers.translator_PR_3 != null"
                        >
                          <b>{{ $t("translator") }}:</b>
                          {{ selectedUsers.translator_PR_3.fullname }}
                        </div>

                        <div
                          class="col-md-12"
                          v-if="trainingEvent.roomFormatted_PR_3"
                        >
                          <b>{{ $t("room") }}:</b>
                          {{ trainingEvent.roomFormatted_PR_3 }}
                        </div>

                        <div
                          class="col-md-12"
                          v-show="trainingEvent.onlinelink_PR_3 != null"
                        >
                          <b>{{ $t("onlineLink") }}:</b>&nbsp;<a
                            :href="clickableOnlineLink"
                            target="_blank"
                            >{{ trainingEvent.onlinelink_PR_3 }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-tab-item>

              <!-- Tab for Participants -->
              <v-tab-item>
                <div
                  class="px-md-4 pl-4 mx-0 pa-0 text-content row disablerow justify-content-between"
                >
                  <v-simple-table
                    class="trainingstable tn_table"
                    style="width: 100%"
                    hide-default-footer
                  >
                    <thead>
                      <tr>
                        <th
                          @click="
                            (participants_sort = 'participant.lastname'),
                              (participants_order = !participants_order),
                              (participants_page = 1),
                              fetchBookings()
                          "
                          class="text-uppercase align-bottom name-wrap"
                        >
                          {{ $t("name") }}
                          <v-icon
                            v-show="
                              participants_sort == 'participant.lastname' &&
                              participants_order
                            "
                            >fas fa-chevron-down</v-icon
                          ><v-icon
                            v-show="
                              participants_sort == 'participant.lastname' &&
                              !participants_order
                            "
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <!-- <th @click="participants_sort = 'participant.personnelnumber', participants_order = !participants_order,participants_page = 1, fetchBookings()" class="text-uppercase align-bottom">
                      {{$t("persnumber")}} <v-icon v-show="participants_sort == 'participant.personnelnumber' && participants_order" >fas fa-chevron-down</v-icon><v-icon v-show="participants_sort == 'participant.personnelnumber' && !participants_order" >fas fa-chevron-up</v-icon>
                    </th> -->
                        <th
                          v-show="$user != null && $user.external"
                          @click="
                            (participants_sort = 'participant.location'),
                              (participants_order = !participants_order),
                              (participants_page = 1),
                              fetchBookings()
                          "
                          class="text-uppercase align-bottom name-wrap"
                        >
                          {{ $t("location") }}
                          <v-icon
                            v-show="
                              participants_sort == 'participant.location' &&
                              participants_order
                            "
                            >fas fa-chevron-down</v-icon
                          ><v-icon
                            v-show="
                              participants_sort == 'participant.location' &&
                              !participants_order
                            "
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th
                          v-show="$user != null && !$user.external"
                          @click="
                            (participants_sort = 'participant.company'),
                              (participants_order = !participants_order),
                              (participants_page = 1),
                              fetchBookings()
                          "
                          class="text-uppercase align-bottom name-wrap"
                        >
                          {{ $t("company") }}
                          <v-icon
                            v-show="
                              participants_sort == 'participant.company' &&
                              participants_order
                            "
                            >fas fa-chevron-down</v-icon
                          ><v-icon
                            v-show="
                              participants_sort == 'participant.company' &&
                              !participants_order
                            "
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th
                          @click="
                            (participants_sort = 'bookingDate'),
                              (participants_order = !participants_order),
                              (participants_page = 1),
                              fetchBookings()
                          "
                          class="text-uppercase align-bottom name-wrap"
                        >
                          {{ $t("booking_date") }}
                          <v-icon
                            v-show="
                              participants_sort == 'bookingDate' &&
                              participants_order
                            "
                            >fas fa-chevron-down</v-icon
                          ><v-icon
                            v-show="
                              participants_sort == 'bookingDate' &&
                              !participants_order
                            "
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th class="actions-wrapper text-uppercase align-bottom">
                          {{ $t("actions") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="booking in bookings" :key="booking.id">
                        <td
                          class="pb-0 participant-name text-uppercase align-center"
                        >
                          {{ booking.participant.lastname }},
                          {{ booking.participant.firstname }}
                        </td>
                        <!-- <td class="pb-0 text-uppercase align-center">{{ booking.participant.personnelnumber }}</td> -->
                        <td
                          v-show="$user != null && $user.external"
                          class="pb-0 text-uppercase align-center"
                        >
                          {{ booking.participant.location }}
                        </td>
                        <td
                          v-show="$user != null && !$user.external"
                          class="pb-0 text-uppercase align-center"
                        >
                          {{ booking.participant.company }}
                        </td>
                        <td class="pb-0 text-uppercase align-center">
                          {{ $formatDate(booking.bookingDate) }}
                        </td>
                        <td class="pb-0 actions-wrapper">
                          <div class="action-wrapper_inner">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="
                                    $user != null &&
                                    $rights.includes('CREATE_CERTIFICATE')
                                  "
                                  @click="showCertificate(booking.id)"
                                  color="transparent"
                                  class="tablebutton"
                                  depressed
                                  tile
                                  v-bind="attrs"
                                  v-on="on"
                                  ><img
                                    class=""
                                    src="../assets/img/show_certiicate.svg"
                                    height="25px"
                                /></v-btn>
                              </template>
                              <span>{{ $t("show_certificate") }}</span>
                            </v-tooltip>
                            <v-tooltip
                              bottom
                              v-show="$rights.includes('SEND_INVITATION')"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="
                                    $rights.includes('SEND_INVITATION') &&
                                    $user != null
                                  "
                                  :disabled="!booking.participant.email"
                                  @click="sendMail(booking)"
                                  color="transparent"
                                  class="tablebutton"
                                  depressed
                                  tile
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-badge
                                    :value="true"
                                    color="primary"
                                    overlap
                                  >
                                    <div slot="badge">
                                      <span
                                        v-show="
                                          booking.invitationSendingLoading
                                        "
                                        ><v-icon
                                          color="#fff"
                                          class="spinner-badge"
                                          >fas fa-spinner</v-icon
                                        ></span
                                      >
                                      <span
                                        v-show="
                                          !booking.invitationSendingLoading
                                        "
                                        >{{ booking.invitationsSent }}</span
                                      >
                                    </div>
                                    <img
                                      class=""
                                      src="../assets/img/send_invitation.svg"
                                      height="25px"
                                    />
                                  </v-badge>
                                </v-btn>
                              </template>
                              <span>{{ $t("send_invitation_mail") }}</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="
                                    $rights.includes('SEND_BOOKING_FEEDBACK') &&
                                    $user != null
                                  "
                                  :disabled="!booking.participant.email"
                                  @click="sendOnlineFeedBack(booking)"
                                  color="transparent"
                                  class="tablebutton"
                                  depressed
                                  tile
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-badge
                                    :value="true"
                                    color="primary"
                                    overlap
                                  >
                                    <div slot="badge">
                                      <span
                                        v-show="booking.feedBackSendingLoading"
                                        ><v-icon
                                          color="#fff"
                                          class="spinner-badge"
                                          >fas fa-spinner</v-icon
                                        ></span
                                      >
                                      <span
                                        v-show="!booking.feedBackSendingLoading"
                                        >{{ booking.feedbackSent }}</span
                                      >
                                    </div>
                                    <img
                                      class=""
                                      src="../assets/img/send_feedback.svg"
                                      height="25px"
                                    />
                                  </v-badge>
                                </v-btn>
                              </template>
                              <span>{{ $t("feedback_form") }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="
                                    $rights.includes('EDIT_BOOKING') ||
                                    $rights.includes('EDIT_CERTIFICATE')
                                  "
                                  @click="beforeOpenModal(booking)"
                                  color="transparent"
                                  class="tablebutton"
                                  depressed
                                  tile
                                  v-bind="attrs"
                                  v-on="on"
                                  ><img
                                    class=""
                                    src="../assets/img/edit_participant.svg"
                                    height="25px"
                                /></v-btn>
                              </template>
                              <span>{{ $t("edit_booking") }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="
                                    $rights.includes('DELETE_BOOKING') &&
                                    $user != null
                                  "
                                  @click="deleteBooking1(booking)"
                                  color="transparent"
                                  class="tablebutton last_btn"
                                  depressed
                                  tile
                                  v-bind="attrs"
                                  v-on="on"
                                  ><img
                                    class=""
                                    src="../assets/img/delete_booking.svg"
                                    height="25px"
                                /></v-btn>
                              </template>
                              <span>{{ $t("delete_booking") }}</span>
                            </v-tooltip>
                          </div>
                          <div class="text-center">
                            <v-dialog
                              :retain-focus="false"
                              v-model="openDeleteDialogBooking"
                              width="500"
                            >
                              <h4>{{ $t("confirm_delete_participant") }}</h4>
                              <v-card-actions class="align_center">
                                <v-btn
                                  @click="openDeleteDialogBooking = false"
                                  outlined
                                  depressed
                                  tile
                                  class="cancelBtn mr-2 mb-2"
                                >
                                  {{ $t("cancel") }}</v-btn
                                >
                                <v-btn
                                  @click="confirmDeleteBooking()"
                                  outlined
                                  depressed
                                  tile
                                  class="deletebutton cancelBtn mb-2"
                                >
                                  <v-icon color="#444">mdi-delete</v-icon>
                                  {{ $t("delete") }}</v-btn
                                >
                              </v-card-actions>
                            </v-dialog>
                          </div>
                        </td>
                      </tr>
                      <tr v-show="bookings.length == 0">
                        <td
                          class="pb-1 text-uppercase align-bottom"
                          colspan="6"
                        >
                          {{ $t("no_participants") }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <pagination
                    v-show="$rights.includes('VIEW_BOOKINGS')"
                    class="my-2"
                    :current-page="participants_page"
                    :total-pages="participants_totalPages"
                    :show-previous-page="participants_previousPage"
                    :show-next-page="participants_nextPage"
                  ></pagination>
                </div>
              </v-tab-item>

              <!-- Tab for Adding New Participants -->
              <v-tab-item>
                <div class="mx-0 pa-0 text-content">
                  <div class="row disablerow">
                    <div class="col-12 col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        id="add_participant_firstname"
                        :label="$t('firstname') + '*'"
                        v-model="adduser.firstname"
                        @keypress.enter="addParticipant()"
                      ></v-text-field>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('lastname') + '*'"
                        v-model="adduser.lastname"
                        @keypress.enter="addParticipant()"
                      ></v-text-field>
                    </div>
                    <!-- <div class="col-12 col-sm-6 col-md-6">
                    <v-text-field  
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('personnelnumber') + '*'"
                    v-model="adduser.personnelnumber"
                    @keypress.enter="addParticipant()"
                    ></v-text-field>
                </div> -->
                    <div
                      class="col-12 col-sm-6 col-md-6"
                      v-show="$user != null && !$user.external"
                    >
                      <v-autocomplete
                        v-model="adduser.tenantId"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="customers"
                        item-text="name"
                        item-value="id"
                        style="padding-right: 2px"
                        dense
                        outlined
                        clearable
                        :label="
                          this.trainingEvent.status === 'BOOKABLE'
                            ? $t('customer')
                            : $t('customer') + '*'
                        "
                      >
                      </v-autocomplete>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('email')"
                        v-model="adduser.email"
                        @keypress.enter="addParticipant()"
                      ></v-text-field>
                    </div>
                    <div
                      class="col-sm-6 col-md-6"
                      v-show="$user != null && !$user.external"
                    >
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('company')"
                        v-model="adduser.company"
                        @keypress.enter="addParticipant()"
                      ></v-text-field>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('location')"
                        v-model="adduser.location"
                        @keypress.enter="addParticipant()"
                      ></v-text-field>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <v-autocomplete
                        hide-details="auto"
                        :items="$selectableLanguages"
                        item-text="translatedName"
                        item-value="key"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('language')"
                        v-model="adduser.language"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="text-right mr-4">
                    <v-label> * {{ $t("mandatory_fields") }} </v-label>
                  </div>
                </div>
              </v-tab-item>

              <!-- Tab for Online FeedBack Forms -->
              <v-tab-item>
                <div
                  class="col-xl-12 right-side-block test"
                  v-show="trainingEventTab == 4"
                >
                  <v-simple-table
                    class="trainingstable tn_table"
                    style="width: 100%"
                    hide-default-footer
                  >
                    <thead v-if="feedBacks.length > 0">
                      <tr>
                        <th class="mmf_1">#</th>
                        <th class="mmf_2">
                          {{ $t("submitted_feedback") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="mmf_tbody">
                      <tr
                        v-if="feedBacks.length > 0"
                        v-for="(feedback, i) in feedBacks"
                        :key="feedback.id"
                      >
                        <td>
                          {{ i + 1 }}
                        </td>
                        <td>
                          <a
                            style=""
                            class=""
                            @click="
                              $router.push(
                                '/feedback-form?feedbackId=' +
                                  feedback.id +
                                  '&trainingEventId=' +
                                  trainingEvent.id
                              )
                            "
                          >
                            <img
                              src="/static/img/feedback-list-icon.svg"
                              class=""
                            />
                            {{ $t("Feedback") }} {{ i + 1 }}</a
                          >
                        </td>
                      </tr>

                      <tr v-if="feedBacks.length == 0">
                        <td class="nfb_massage">
                          {{ $t("noFeedBack") }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </v-tab-item>

              <!-- Tab for Manual FeedBack Forms -->
              <v-tab-item>
                <div
                  class="col-xl-12 right-side-block"
                  v-show="trainingEventTab == 5"
                >
                  <v-simple-table
                    class="trainingstable tn_table"
                    style="width: 100%"
                    hide-default-footer
                  >
                    <thead v-if="manualfeedBacks.length > 0">
                      <tr>
                        <th class="mmf_1">#</th>
                        <th class="mmf_2">
                          {{ $t("submitted_feedback") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="mmf_tbody">
                      <tr
                        v-if="manualfeedBacks.length > 0"
                        v-for="(feedback, i) in manualfeedBacks"
                        :key="feedback.id"
                      >
                        <td>
                          {{ i + 1 }}
                        </td>
                        <td>
                          <a
                            style=""
                            class=""
                            @click="
                              $router.push(
                                '/feedback-form?feedbackId=' +
                                  feedback.id +
                                  '&trainingEventId=' +
                                  trainingEvent.id +
                                  '&addmanual=true'
                              )
                            "
                          >
                            <img
                              src="/static/img/feedback-list-icon.svg"
                              class=""
                            />
                            {{ $t("Feedback") }}{{ i + 1 }}
                          </a>
                        </td>
                      </tr>

                      <tr v-if="manualfeedBacks.length == 0">
                        <td class="nfb_massage">
                          {{ $t("noFeedBack") }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </v-tab-item>

              <!-- Tab for Seat Share -->
              <v-tab-item v-show="$rights.includes('CREATE_TRAINING_EVENT')">
                <div class="headlinecolor text-h6 col-md-6">
                  <b>{{ $t("customerName") }}</b>
                  <span
                    class="text-dark pl-2"
                    v-if="trainingEvent.tenant && trainingEvent.tenant.name"
                    >{{ trainingEvent.tenant.name }}</span
                  >
                </div>

                <div class="headlinecolor col-md-6">
                  {{ $t("availableSeats")
                  }}{{ trainingEvent.freeSpaces - seatOccupied }}
                </div>
                <div
                  class="right-side-block d-flex"
                  v-show="trainingEventTab == 6"
                >
                  <div class="col-sm-6 col-md-6">
                    <v-autocomplete
                      v-model="seatTenant"
                      hide-details="auto"
                      class="datainput justify-content-end searchbar align-self-center pb-1"
                      :items="seatShareCustomers"
                      item-text="name"
                      item-value="id"
                      style="padding-right: 2px"
                      dense
                      outlined
                      :label="$t('shareSeatsWith') + '*'"
                    />
                  </div>

                  <div class="col-sm-4 col-md-4">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('enterSeats') + '*'"
                      :min="1"
                      type="number"
                      v-model="seatNumber"
                      :value="0"
                    ></v-text-field>
                  </div>

                  <div class="col-sm-4 col-md-4">
                    <v-btn
                      :disabled="seatNumber === null || seatTenant === null"
                      @click="addSeatShare()"
                      outlined
                      depressed
                      tile
                      class="savebutton colorWhite"
                    >
                      {{ $t("add") }} <v-icon>mdi-plus</v-icon></v-btn
                    >
                  </div>
                </div>

                <div class="col-sm-12 col-md-12" v-if="seatShare.length > 0">
                  <template>
                    <p class="mb-2">
                      {{ $t("sharedSeatsWithBelowCompanies") }}
                    </p>
                    <div class="list-component">
                      <v-list class="v-list-flex v-list_custom">
                        <v-list-item
                          v-for="(item, index) in seatShare"
                          :key="index"
                        >
                          <v-list-item-content>
                            {{ displaySeatShare(item) }}
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon @click="remove(index)">mdi-close</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </div>
                  </template>
                </div>
              </v-tab-item>

              <div
                class="col-md-12 lastBtnSubmit mr-2 ml-2 widAuto"
                v-show="trainingEventTab == 0"
              >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="backbutton mr-2 mb-2"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  v-if="!editMode"
                  v-show="$user && $rights.includes('CREATE_TRAINING_EVENT')"
                  @click="saveTrainingEvent()"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  v-else
                  v-show="$user && $rights.includes('UPDATE_TRAINING_EVENT')"
                  @click="saveTrainingEvent()"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'normal'"
                  @click="activeOrInactiveTrainingEvent('2')"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>{{ $t("draft") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'cancelled'"
                  @click="activeOrInactiveTrainingEvent('2')"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>{{ $t("draft") }}</v-btn
                >
                <!-- <v-btn
                  v-show="$rights.includes('CREATE_TRAINING_EVENT') || $user.trainer"
                  v-if="eventStatus === 'drafted'"
                  @click="activeOrInactiveTrainingEvent('1')"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                  ><v-icon dark left>mdi-minus-circle</v-icon
                  >{{ $t("cancelEvent") }}</v-btn
                > -->
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'cancelled'"
                  @click="activeOrInactiveTrainingEvent('0')"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                >
                  {{ $t("activate") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'drafted'"
                  @click="activeOrInactiveTrainingEvent('0')"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                >
                  {{ $t("undraft") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'normal' || eventStatus === 'drafted'"
                  @click="openCancelledDialog = true"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                  ><v-icon dark left>mdi-minus-circle</v-icon
                  >{{ $t("cancelEvent") }}</v-btn
                >
                <v-btn
                  v-show="editMode && $rights.includes('DELETE_TRAINING_EVENT')"
                  @click="openDeleteDialog = true"
                  outlined
                  depressed
                  tile
                  class="mr-2 deletebutton cancelBtn mb-2"
                >
                  <v-icon>mdi-delete</v-icon> {{ $t("delete") }}</v-btn
                >
              </div>

              <div
                class="col-md-12 lastBtnSubmit mr-4 ml-4 widAuto"
                v-if="$user != null"
                v-show="trainingEventTab == 3"
              >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="backbutton mr-2 mb-2"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  @click="addParticipant()"
                  v-show="$rights.includes('CREATE_BOOKING')"
                  outlined
                  depressed
                  tile
                  class="savebutton mb-2"
                  >{{ $t("add_participant") }}</v-btn
                >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                  >{{ $t("cancel") }}</v-btn
                >
              </div>

              <div
                class="col-md-12 lastBtnSubmit mr-2 ml-4 widAuto"
                v-if="$user != null"
                v-show="trainingEventTab == 6 && $rights.includes('SEAT_SHARE')"
              >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="backbutton mr-2 mb-2"
                >
                  <v-icon>mdi-chevron-left</v-icon>{{ $t("back") }}</v-btn
                >
                <v-btn
                  v-show="$rights.includes('SEAT_SHARE')"
                  @click="seatShareSave()"
                  outlined
                  depressed
                  tile
                  class="savebutton mb-2"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                  >{{ $t("cancel") }}</v-btn
                >
              </div>
            </v-tabs-items>
          </div>
          <div>
            <b-modal v-model="showModal" centered class="innercreatetraining">
              <template v-slot:modal-header>
                <h5 class="text-dark">{{ $t("editParticipants") }}</h5>
              </template>
              <b-form>
                <b-row class="mb-0 mt-0">
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      id="edit_participant_firstname"
                      :label="$t('firstname') + '*'"
                      v-model="edituser.firstname"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                    ></v-text-field>
                  </b-col>
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('lastname') + '*'"
                      v-model="edituser.lastname"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row class="mb-0 mt-0">
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('email')"
                      v-model="edituser.email"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                    ></v-text-field>
                  </b-col>
                  <b-col v-if="$user && !$user.isonlyBooker">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('company')"
                      v-model="edituser.company"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                      v-if="$user && !$user.isonlyBooker"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row class="mb-0 mt-0">
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('location')"
                      v-model="edituser.location"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                    ></v-text-field>
                  </b-col>
                  <b-col>
                    <v-autocomplete
                      hide-details="auto"
                      :items="$selectableLanguages"
                      item-text="translatedName"
                      item-value="key"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('language')"
                      v-model="edituser.language"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                      :close-on-click="false"
                      ref="autocompleteLanaguge"
                      @blur="handleBlurLanguage"
                    ></v-autocomplete>
                  </b-col>
                </b-row>
                <b-row class="mb-0 mt-0">
                  <b-col v-if="$user && !$user.isonlyBooker">
                    <v-autocomplete
                      v-model="edituser.tenantId"
                      v-if="$user && !$user.isonlyBooker"
                      hide-details="auto"
                      class="datainput justify-content-end searchbar align-self-center pb-1"
                      :items="customers"
                      item-text="name"
                      item-value="id"
                      style="padding-right: 2px"
                      dense
                      outlined
                      clearable
                      :label="
                        this.trainingEvent.status === 'BOOKABLE'
                          ? $t('customer')
                          : $t('customer') + '*'
                      "
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                      :close-on-click="false"
                      ref="autocomplete"
                      @blur="handleBlur"
                    >
                    </v-autocomplete>
                  </b-col>
                  <b-col class="pb-0" v-show="$user && !$user.isonlyBooker">
                    <v-autocomplete
                      dense
                      outlined
                      class="datainput justify-content-end align-self-center pb-1"
                      v-model="edituser.selectedStatus"
                      :items="statusOptions"
                      :label="$t('status')"
                      :disabled="!$rights.includes('EDIT_BOOKING')"
                      :close-on-click="false"
                      ref="autocompleteStatus"
                      @blur="handleBlurStatus"
                    ></v-autocomplete>
                  </b-col>
                  <div class="w-100 text-right mr-3">
                    <v-label> * {{ $t("mandatory_fields") }} </v-label>
                  </div>
                </b-row>
                <b-row class="mb-0 mt-0" v-show="$user && !$user.isonlyBooker">
                  <div class="d-block w-100 ml-3">
                    <v-label>
                      <h5 class="text-dark">{{ $t("editCertificate") }}</h5>
                      <span
                        class="text-dark"
                        v-if="
                          edituser.display === false ||
                          edituser.display === null
                        "
                        >{{
                          edituser.eventStatus === "0"
                            ? $t("activeEvent")
                            : edituser.eventStatus === "1"
                            ? $t("cancelledEvent")
                            : edituser.eventStatus === "2"
                            ? $t("draftedEvent")
                            : ""
                        }}</span
                      >
                    </v-label>
                  </div>
                  <br />
                </b-row>

                <b-row
                  v-if="edituser.display === false || edituser.display === null"
                  v-show="$user && !$user.isonlyBooker"
                >
                  <b-col v-if="trainingEvent.training">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('trainingName')"
                      v-model="edituser.certificateTrainingName"
                      @keypress.enter="editParticipant()"
                      :disabled="true"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row
                  v-if="trainingEvent.training"
                  v-show="$user && !$user.isonlyBooker"
                >
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-4">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("descriptionOfTraining") }}
                      </label>
                      <vue-editor
                        v-model="edituser.certificateTrainingDescription"
                        :editor-toolbar="customToolbar"
                        @input="handleInput"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      />
                    </div>
                    <div>
                      {{ $t("characterCount") }}:
                      <span
                        :style="{
                          color:
                            characterCount > maxCharacterCount
                              ? 'red'
                              : 'inherit',
                        }"
                      >
                        {{ characterCount }}</span
                      >
                      /{{ maxCharacterCount }}
                      <div
                        v-if="characterCount > maxCharacterCount"
                        style="color: red"
                      >
                        {{ $t("characterExceeded") }}
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-row
                  v-show="$user && !$user.isonlyBooker"
                  v-if="edituser.display === false || edituser.display === null"
                >
                  <b-col v-if="trainingEvent.trainingEventCategory">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('training_event_category')"
                      v-model="edituser.certificateEventTrainingCategoryName"
                      @keypress.enter="editParticipant()"
                      :disabled="true"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row
                  v-if="trainingEvent.trainingEventCategory"
                  v-show="$user && !$user.isonlyBooker"
                >
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-4">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("training_event_category_description") }}
                      </label>
                      <vue-editor
                        v-model="
                          edituser.certificateEventTrainingCategoryDescription
                        "
                        :editor-toolbar="customToolbar"
                        @input="handleInput2"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      />
                    </div>
                    <div>
                      {{ $t("characterCount") }}:
                      <span
                        :style="{
                          color:
                            characterCount2 > maxCharacterCount
                              ? 'red'
                              : 'inherit',
                        }"
                      >
                        {{ characterCount2 }}</span
                      >
                      /{{ maxCharacterCount }}
                      <div
                        v-if="characterCount2 > maxCharacterCount"
                        style="color: red"
                      >
                        {{ $t("characterExceeded") }}
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-row
                  v-show="$user && !$user.isonlyBooker"
                  class="mb-0 mt-0"
                  v-if="edituser.display === false || edituser.display === null"
                >
                  <b-col>
                    <DatePicker
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      v-if="edituser.certificateStartDate"
                      :label="$t('startDate') + ' (dd-mm-yyyy)'"
                      v-model="edituser.certificateStartDate"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                    ></DatePicker>
                  </b-col>
                  <b-col>
                    <DatePicker
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      v-if="edituser.certificateEndDate"
                      :label="$t('endDate') + ' (dd-mm-yyyy)'"
                      v-model="edituser.certificateEndDate"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                    ></DatePicker>
                  </b-col>
                </b-row>
                <b-row
                  v-show="$user && !$user.isonlyBooker"
                  class="mb-0 mt-0"
                  v-if="edituser.display === false || edituser.display === null"
                >
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      v-if="edituser.certificateEventLocation"
                      :label="$t('certificateLocation')"
                      v-model="edituser.certificateEventLocation"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row v-show="$user && !$user.isonlyBooker" class="mb-0 mt-0">
                  <b-col class="pt-0">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('certificateEventNumber')"
                      v-if="edituser.certificateEventNumber"
                      v-model="edituser.certificateEventNumber"
                      @keypress.enter="editParticipant()"
                      :disabled="true"
                    ></v-text-field>
                  </b-col>
                </b-row>

                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_TH_1 ||
                      edituser.certificateEndDate_TH_1 ||
                      edituser.certificateTrainer_TH_1 ||
                      edituser.certificateTrainer2_TH_1 ||
                      edituser.certificateEventLocation_TH_1)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_TH_1
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_TH_1"
                        :label="$t('startDate_TH_1') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_TH_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_TH_1"
                        :label="$t('endDate_TH_1') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_TH_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_TH_1
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_TH_1')"
                        v-model="edituser.certificateTrainer_TH_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_TH_1')"
                        v-model="edituser.certificateTrainer2_TH_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="edituser.certificateEventLocation_TH_1"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_TH_1"
                        :label="$t('certificateLocation_TH_1')"
                        v-model="edituser.certificateEventLocation_TH_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_TH_1"
                    class="no-margin-top"
                    :label="$t('show_th_1')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>

                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_TH_2 ||
                      edituser.certificateEndDate_TH_2 ||
                      edituser.certificateTrainer_TH_2 ||
                      edituser.certificateTrainer2_TH_2 ||
                      edituser.certificateEventLocation_TH_2)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_TH_2
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_TH_2"
                        :label="$t('startDate_TH_2') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_TH_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_TH_2"
                        :label="$t('endDate_TH_2') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_TH_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_TH_2
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_TH_2')"
                        v-model="edituser.certificateTrainer_TH_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_TH_2')"
                        v-model="edituser.certificateTrainer2_TH_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="edituser.certificateEventLocation_TH_2"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_TH_2"
                        :label="$t('certificateLocation_TH_2')"
                        v-model="edituser.certificateEventLocation_TH_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_TH_2"
                    class="no-margin-top"
                    :label="$t('show_th_2')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>

                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_TH_3 ||
                      edituser.certificateEndDate_TH_3 ||
                      edituser.certificateTrainer_TH_3 ||
                      edituser.certificateTrainer2_TH_3 ||
                      edituser.certificateEventLocation_TH_3)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_TH_3
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_TH_3"
                        :label="$t('startDate_TH_3') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_TH_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_TH_3"
                        :label="$t('endDate_TH_3') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_TH_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_TH_3
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_TH_3')"
                        v-model="edituser.certificateTrainer_TH_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_TH_3')"
                        v-model="edituser.certificateTrainer2_TH_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="edituser.certificateEventLocation_TH_3"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_TH_3"
                        :label="$t('certificateLocation_TH_3')"
                        v-model="edituser.certificateEventLocation_TH_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_TH_3"
                    class="no-margin-top"
                    :label="$t('show_th_3')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>

                <!-- PR 1 -->
                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_PR_1 ||
                      edituser.certificateEndDate_PR_1 ||
                      edituser.certificateTrainer_PR_1 ||
                      edituser.certificateTrainer2_PR_1 ||
                      edituser.certificateEventLocation_PR_1)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_PR_1
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_PR_1"
                        :label="$t('startDate_PR_1') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_PR_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_PR_1"
                        :label="$t('endDate_PR_1') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_PR_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_PR_1
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_PR_1')"
                        v-model="edituser.certificateTrainer_PR_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_PR_1')"
                        v-model="edituser.certificateTrainer2_PR_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="edituser.certificateEventLocation_PR_1"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_PR_1"
                        :label="$t('certificateLocation_PR_1')"
                        v-model="edituser.certificateEventLocation_PR_1"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_PR_1"
                    class="no-margin-top"
                    :label="$t('show_pr_1')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>
                <!-- PR 1 end -->

                <!-- PR 2 -->
                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_PR_2 ||
                      edituser.certificateEndDate_PR_2 ||
                      edituser.certificateTrainer_PR_2 ||
                      edituser.certificateTrainer2_PR_2 ||
                      edituser.certificateEventLocation_PR_2)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_PR_2
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_PR_2"
                        :label="$t('startDate_PR_2') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_PR_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_PR_2"
                        :label="$t('endDate_PR_2') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_PR_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_PR_2
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_PR_2')"
                        v-model="edituser.certificateTrainer_PR_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_PR_2')"
                        v-model="edituser.certificateTrainer2_PR_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="edituser.certificateEventLocation_PR_2"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_PR_2"
                        :label="$t('certificateLocation_PR_2')"
                        v-model="edituser.certificateEventLocation_PR_2"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_PR_2"
                    class="no-margin-top"
                    :label="$t('show_pr_2')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>
                <!-- PR 2 end -->

                <!-- PR 3 -->
                <div
                  class="sp_space"
                  v-show="$user && !$user.isonlyBooker"
                  v-if="
                    edituser &&
                    (edituser.certificateStartDate_PR_3 ||
                      edituser.certificateEndDate_PR_3 ||
                      edituser.certificateTrainer_PR_3 ||
                      edituser.certificateTrainer2_PR_3 ||
                      edituser.certificateEventLocation_PR_3)
                  "
                >
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateStartDate_PR_3
                    "
                  >
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateStartDate_PR_3"
                        :label="$t('startDate_PR_3') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateStartDate_PR_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                    <b-col>
                      <DatePicker
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEndDate_PR_3"
                        :label="$t('endDate_PR_3') + ' (dd-mm-yyyy)'"
                        v-model="edituser.certificateEndDate_PR_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></DatePicker>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0"
                    v-if="
                      (edituser.display === false ||
                        edituser.display === null) &&
                      edituser.certificateTrainer_PR_3
                    "
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer1_PR_3')"
                        v-model="edituser.certificateTrainer_PR_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('trainer2_PR_3')"
                        v-model="edituser.certificateTrainer2_PR_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-0 mt-0 pr-3"
                    v-if="edituser.certificateEventLocation_PR_3"
                  >
                    <b-col>
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        v-if="edituser.certificateEventLocation_PR_3"
                        :label="$t('certificateLocation_PR_3')"
                        v-model="edituser.certificateEventLocation_PR_3"
                        @keypress.enter="editParticipant()"
                        :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                      ></v-text-field>
                    </b-col>
                  </b-row>
                  <v-checkbox
                    v-model="edituser.display_PR_3"
                    class="no-margin-top"
                    :label="$t('show_pr_3')"
                    :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                  ></v-checkbox>
                </div>
                <!-- PR 3 end -->

                <!-- PR 1 end -->

                <b-row
                  v-show="$user && !$user.isonlyBooker"
                  class="mb-0 mt-0"
                  v-if="
                    (edituser.display === false || edituser.display === null) &&
                    edituser.certificateTrainer
                  "
                >
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('trainer1')"
                      v-model="edituser.certificateTrainer"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                    ></v-text-field>
                  </b-col>
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('trainer2')"
                      v-model="edituser.certificateTrainer2"
                      @keypress.enter="editParticipant()"
                      :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                    ></v-text-field>
                  </b-col>
                </b-row>

                <b-row
                  class="mb-0 mt-0"
                  v-if="edituser.display === true"
                  v-show="$user && !$user.isonlyBooker"
                >
                  <b-col>
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('certificateEventNumber')"
                      v-model="edituser.certificateEventNumber"
                      @keypress.enter="editParticipant()"
                      :disabled="true"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <div
                  class="row"
                  v-if="edituser.display === true"
                  v-show="$user && !$user.isonlyBooker"
                >
                  <div class="col-md-6">
                    <div class="border rounded border-dark p-3">
                      <h5>
                        {{ $t("theory_event") }}
                        {{
                          edituser.eventStatus === "0"
                            ? $t("activeEvent")
                            : edituser.eventStatus === "1"
                            ? $t("cancelledEvent")
                            : edituser.eventStatus === "2"
                            ? $t("draftedEvent")
                            : ""
                        }}
                      </h5>

                      <!-- First section content here -->
                      <b-row class="mb-0 mt-0">
                        <b-col v-if="trainingEvent.training">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainingName')"
                            v-model="edituser.certificateTrainingName"
                            @keypress.enter="editParticipant()"
                            :disabled="true"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col v-if="trainingEvent.trainingEventCategory">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('training_event_category')"
                            v-model="
                              edituser.certificateEventTrainingCategoryName
                            "
                            @keypress.enter="editParticipant()"
                            :disabled="true"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('certificateLocation')"
                            v-model="edituser.certificateEventLocation"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <DatePicker
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('startDate') + ' (dd-mm-yyyy)'"
                            v-model="edituser.certificateStartDate"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></DatePicker>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <DatePicker
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('endDate') + ' (dd-mm-yyyy)'"
                            v-model="edituser.certificateEndDate"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></DatePicker>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainer1')"
                            v-model="edituser.certificateTrainer"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainer2')"
                            v-model="edituser.certificateTrainer2"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded border-dark p-3">
                      <h5>
                        {{ $t("practical_event") }}
                        {{
                          edituser.eventStatusOther === "0"
                            ? $t("activeEvent")
                            : edituser.eventStatusOther === "1"
                            ? $t("cancelledEvent")
                            : edituser.eventStatusOther === "2"
                            ? $t("draftedEvent")
                            : ""
                        }}
                      </h5>
                      <!-- Second section content here -->
                      <b-row class="mb-0 mt-0">
                        <b-col v-if="trainingEvent.training">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainingName')"
                            v-model="edituser.certificateTrainingNameOther"
                            @keypress.enter="editParticipant()"
                            :disabled="true"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col v-if="trainingEvent.trainingEventCategory">
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('training_event_category')"
                            v-model="
                              edituser.certificateEventTrainingCategoryNameOther
                            "
                            @keypress.enter="editParticipant()"
                            :disabled="true"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('certificateLocation')"
                            v-model="edituser.certificateEventLocationOther"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <DatePicker
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('startDate') + ' (dd-mm-yyyy)'"
                            v-model="edituser.certificateStartDateOther"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></DatePicker>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <DatePicker
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('endDate') + ' (dd-mm-yyyy)'"
                            v-model="edituser.certificateEndDateOther"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></DatePicker>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainer1')"
                            v-model="edituser.certificateTrainerOther"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                      <b-row class="mb-0 mt-0">
                        <b-col>
                          <v-text-field
                            hide-details="auto"
                            class="datainput justify-content-end align-self-center pb-1"
                            dense
                            outlined
                            :label="$t('trainer2')"
                            v-model="edituser.certificateTrainer2Other"
                            @keypress.enter="editParticipant()"
                            :disabled="!$rights.includes('EDIT_CERTIFICATE')"
                          ></v-text-field>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </b-form>
              <template v-slot:modal-footer>
                <v-btn
                  v-show="
                    $rights.includes('EDIT_BOOKING') ||
                    !$rights.includes('EDIT_CERTIFICATE')
                  "
                  @click="editParticipant()"
                  outlined
                  depressed
                  tile
                  :disabled="
                    characterCount > maxCharacterCount ||
                    characterCount2 > maxCharacterCount
                  "
                  class="savebutton mb-2 mr-2"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  @click="editParticipantForAll()"
                  v-show="
                    $rights.includes('EDIT_BOOKING') ||
                    !$rights.includes('EDIT_CERTIFICATE')
                  "
                  v-if="$user && !$user.isonlyBooker"
                  outlined
                  depressed
                  tile
                  :disabled="
                    characterCount > maxCharacterCount ||
                    characterCount2 > maxCharacterCount
                  "
                  class="savebutton mb-2"
                  >{{ $t("saveAll") }}</v-btn
                >
                <v-btn
                  @click="afterCloseModal()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn ml-2 mb-2"
                >
                  {{ $t("cancel") }}</v-btn
                >
              </template>
            </b-modal>
          </div>
          <div class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row onlyContact">
            <!-- Actions for first and second Tab -->
            <div
              class="col-xl-12 right-side-block hide"
              v-show="trainingEventTab == 0 || trainingEventTab == 1"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <div class="d-flex g-space-15">
                <v-btn
                  v-show="editMode && $rights.includes('DELETE_TRAINING_EVENT')"
                  @click="openDeleteDialog = true"
                  outlined
                  depressed
                  tile
                  class="deletebutton cancelBtn"
                >
                  <v-icon color="#444">mdi-delete</v-icon>
                  {{ $t("delete") }}</v-btn
                >
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="backbutton"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  v-show="$rights.includes('CREATE_TRAINING_EVENT')"
                  @click="saveTrainingEvent()"
                  outlined
                  depressed
                  tile
                  class="save"
                  >{{ $t("save") }}</v-btn
                >

                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'normal'"
                  @click="activeOrInactiveTrainingEvent('2')"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                >
                  <v-icon>mdi-pencil-outline</v-icon>{{ $t("draft") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'cancelled'"
                  @click="activeOrInactiveTrainingEvent('0')"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                >
                  {{ $t("activate") }}</v-btn
                >
                <v-btn
                  v-show="
                    $rights.includes('UPDATE_TRAINING_EVENT') &&
                    $rights.includes(
                      'UPDATE_TRAINING_EVENT_COMMENT_AND_DOCUMENT'
                    )
                  "
                  v-if="eventStatus === 'drafted'"
                  @click="activeOrInactiveTrainingEvent('0')"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                >
                  {{ $t("undraft") }}</v-btn
                >
              </div>
            </div>

            <!-- Actions for third Tab -->
            <div
              class="col-xl-12 right-side-block"
              v-show="trainingEventTab == 2"
              v-if="$user && !$user.isonlyBooker"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <div class="d-flex g-space-15">
                <!-- <v-btn v-show="editMode && $rights.includes('CREATE_TRAINING_EVENT')" @click="openDeleteDialog= true" outlined depressed tile class="mr-2 deletebutton mb-2">{{ $t("delete") }}</v-btn> -->
                <v-btn
                  @click="$routerBack()"
                  outlined
                  depressed
                  tile
                  class="backbutton"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  v-show="
                    $user != null &&
                    $rights.includes('VIEW_BOOKINGS') &&
                    !this.$user.external
                  "
                  @click="createParticipantsList()"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                  >{{ $t("create_participant_list") }}</v-btn
                >
                <v-btn
                  v-show="$user != null && $rights.includes('SEND_INVITATION')"
                  outlined
                  depressed
                  tile
                  @click="openSendMailCustomDialog = true"
                  class="deletebutton cancelBtn"
                  >{{ $t("email") }}</v-btn
                >
                <v-btn
                  v-show="
                    $user != null &&
                    $rights.includes('VIEW_BOOKINGS') &&
                    !this.$user.external
                  "
                  @click="showPreview()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn"
                  ><img src="/static/img/union.svg" class="mr-sm" />{{
                    $t("preview_certificate")
                  }}</v-btn
                >

                <v-btn
                  v-show="
                    $user != null &&
                    documentChangeDisplay &&
                    !$user.isonlyBooker &&
                    bookings.length > 0
                  "
                  @click="openDialogDocumentChange = true"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                  >{{ $t("senddocumentchangemail") }}</v-btn
                >
              </div>
            </div>

            <!-- Actions for fourth Tab -->
            <div
              class="col-xl-12 right-side-block hide"
              v-if="$user != null"
              v-show="trainingEventTab == 3"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="backbutton mr-2 mb-2"
              >
                <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
              >
              <v-btn
                @click="addParticipant()"
                v-show="$rights.includes('CREATE_BOOKING')"
                outlined
                depressed
                tile
                class="savebutton mb-2"
                >{{ $t("add_participant") }}</v-btn
              >
            </div>
            <!-- Actions for fourth Tab -->
            <!-- <div
              class="col-xl-12 right-side-block"
              v-if="$user != null"
              v-show="trainingEventTab == 4"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancelFeedBack") }}</v-btn
              >
            </div> -->

            <!-- Actions for Fifth Tab -->
            <div
              class="col-xl-12 right-side-block"
              v-if="$user != null"
              v-show="trainingEventTab == 5"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="backbutton mr-2 mb-2"
              >
                <v-icon>mdi-chevron-left</v-icon>{{ $t("back") }}</v-btn
              >
              <v-btn
                v-show="$rights.includes('ADD_MANNUAL_FEEDBACK_FORM')"
                @click="
                  $router.push(
                    '/feedback-form?trainingEventId=' +
                      trainingEventId +
                      '&addmanual=true'
                  )
                "
                outlined
                depressed
                tile
                class="savebutton mb-2 mr-2"
                >{{ $t("add") }}</v-btn
              >
              <!-- <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancelFeedBack") }}</v-btn
              > -->
            </div>

            <!-- Actions for Sixth Tab -->
            <div
              class="col-xl-12 right-side-block hide"
              v-if="$user != null"
              v-show="trainingEventTab == 6"
            >
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="backbutton mr-2 mb-2"
              >
                <v-icon>mdi-chevron-left</v-icon>{{ $t("back") }}</v-btn
              >
              <v-btn
                @click="seatShareSave()"
                outlined
                depressed
                tile
                class="savebutton mb-2"
                >{{ $t("save") }}</v-btn
              >
            </div>

            <!-- Search for Participants (Third Tab) -->
            <div
              class="col-xl-12 right-side-block"
              v-show="trainingEventTab == 2"
            >
              <h3 class="text-uppercase">{{ $t("search") }}</h3>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-text-field
                hide-details="auto"
                class="justify-content-end searchbar align-self-center pb-1"
                style="padding-right: 2px"
                dense
                outlined
                v-model="participants_search"
                @keypress.enter="fetchBookings()"
                :label="$t('search_participant')"
                ><template v-slot:append>
                  <v-icon color="#003A60">fas fa-search</v-icon>
                </template></v-text-field
              >
            </div>

            <div
              class="col-xl-12 right-side-block"
              v-show="trainingEventTab == 0 || trainingEventTab == 1"
              v-if="
                trainingEvent.salesListId &&
                editMode &&
                $rights.includes('UPDATE_SALESLIST')
              "
            >
              <h3 class="text-uppercase">{{ $t("actions") }}</h3>
              <div class="right-side divider"></div>
              <div class="mt-6">
                <p class="mb-5">
                  {{ $t("message_to_cant_change_event_traning_category") }}
                </p>
              </div>
              <v-btn
                v-show="editMode && $rights.includes('UPDATE_SALESLIST')"
                @click="salesList(trainingEvent.salesListId)"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
              >
                {{ $t("view-sales-list") }}</v-btn
              >
            </div>

            <Contact />
            <Share
              :headline="$t('share_training')"
              :mailSubject="
                $t('share_mail_subject', {
                  name:
                    trainingEvent.training == null
                      ? ''
                      : trainingEvent.training.designationsMap[$locale],
                })
              "
              :mailText="getShareMailText()"
            />
          </div>

          <!-- Dialogs -->
          <v-dialog v-model="openSendMailAgainDialog" width="500">
            <h3 v-if="firstTimeInvitation">
              {{ $t("send_invitation_mail_question") }}
            </h3>
            <h3 v-else>{{ $t("send_invitation_mail_again_question") }}</h3>
            <v-card-actions class="align_center">
              <v-btn
                @click="sendMailToParticipant(sendMailAgainBooking)"
                outlined
                depressed
                tile
                class="savebutton mb-2"
                >{{ $t("send_invitation_mail") }}</v-btn
              >
              <v-btn
                @click="openSendMailAgainDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancel") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>

          <div class="text-center">
            <v-dialog v-model="openDeleteDialog" width="500">
              <h4>{{ $t("confirm_delete_event") }}</h4>
              <v-card-actions class="align_center">
                <v-btn
                  @click="openDeleteDialog = false"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                >
                  {{ $t("cancel") }}</v-btn
                >
                <v-btn
                  @click="deleteTrainingEvent()"
                  outlined
                  depressed
                  tile
                  class="deletebutton cancelBtn mb-2"
                >
                  <v-icon color="#444">mdi-delete</v-icon>
                  {{ $t("delete") }}</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </div>
          <div class="text-center">
            <v-dialog v-model="openCancelledDialog" width="500">
              <h4>{{ $t("confirm_cancelled_event") }}</h4>
              <v-card-actions class="align_center">
                <v-btn
                  v-show="$rights.includes('CREATE_TRAINING_EVENT')"
                  v-if="eventStatus === 'normal' || eventStatus === 'drafted'"
                  @click="activeOrInactiveTrainingEvent('1')"
                  outlined
                  depressed
                  tile
                  class="savebutton mb-2"
                >
                  <v-icon color="#444"></v-icon>
                  {{ $t("cancelEvent") }}</v-btn
                >
                <v-btn
                  v-show="$rights.includes('CREATE_TRAINING_EVENT')"
                  @click="openCancelledDialog = false"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                >
                  {{ $t("cancel") }}</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </div>
          <div class="text-center">
            <v-dialog v-model="openSendMailCustomDialog" width="500">
              <h4>{{ $t("send_invitation_mail") }}</h4>
              <br />
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('email')"
                v-model="customEmail"
              ></v-text-field>
              <v-card-actions class="px-0 align_center">
                <v-btn
                  @click="openSendMailCustomDialog = false"
                  outlined
                  depressed
                  tile
                  class="backbutton mr-2 mb-2"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  @click="sendBlankMail()"
                  outlined
                  depressed
                  tile
                  class="savebutton mb-2"
                  >{{ $t("send") }}</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </div>

          <!-- Dialogs -->
          <v-dialog v-model="openSendMailAgainFeedBackDialog" width="500">
            <h3 v-if="firstTimeFeedback">
              {{ $t("send_feedback_mail_question") }}
            </h3>
            <h3 v-else>{{ $t("send_feedback_mail_again_question") }}</h3>
            <v-card-actions class="align_center">
              <v-btn
                @click="
                  sendMailToParticipantForOnlineFeedBack(
                    sendMailAgainFeedBackBooking
                  )
                "
                outlined
                depressed
                tile
                class="savebutton mb-2"
                >{{ $t("send_feedback_mail") }}</v-btn
              >
              <v-btn
                @click="openSendMailAgainFeedBackDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancel") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>

          <div class="text-center">
            <v-dialog v-model="openSendMailCustomDialogFeedBack" width="500">
              <h4>{{ $t("send_feedback_mail") }}</h4>
              <br />
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('email')"
                v-model="customEmail"
              ></v-text-field>
              <v-card-actions class="px-0 align_center">
                <v-spacer></v-spacer>
                <v-btn
                  @click="openSendMailCustomDialogFeedBack = false"
                  outlined
                  depressed
                  tile
                  class="backbutton mr-2 mb-2"
                >
                  <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
                >
                <v-btn
                  @click="sendBlankMail()"
                  outlined
                  depressed
                  tile
                  class="savebutton mb-2"
                  >{{ $t("send") }}</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </div>
          <div class="text-center">
            <v-dialog
              v-model="openDialogDocumentChange"
              width="500"
              height="1000"
              content-class="ndc_dialog"
            >
              <img
                src="/static/img/newsletter_v_arrow.svg"
                alt="arraow"
                class="newsletter_v_arrow"
              />
              <div>
                <p class="inner_p">{{ $t("send_document_change_mail") }}</p>
              </div>
                  <v-card-actions class="align_center">
<multiselect
  v-model="selected"
  :options="participantOptions"
  :multiple="true"
  label="name"
  track-by="id"
  :placeholder="$t('select_participant')"
  :append-to-body="true"
  open-direction="bottom"
  :close-on-select="false"
  :select-label="$t('enter_to_select')"
  :deselect-label="$t('enter_to_remove')"
  :selected-label="$t('selected')"
>
  <!-- "Select All" with checkbox -->
  <template #beforeList>
    <li class="multiselect__element">
      <div
        @mousedown.prevent="toggleSelectAll"
        style="cursor: pointer; font-weight: bold; display: flex; align-items: center;"
      >
        <input type="checkbox" :checked="allSelected" readonly />
        <span style="margin-left: 8px">
         {{ allSelected ? $t('deselect_all') : $t('select_all') }}
        </span>
      </div>
    </li>
  </template>

  <!-- Custom option with checkbox -->
  <template #option="{ option, select, remove }">
    <li
      class="multiselect__element"
      @mousedown.prevent="isOptionSelected(option) ? remove(option) : select(option)"
      style="cursor: pointer; display: flex; align-items: center;"
    >
      <input type="checkbox" :checked="isOptionSelected(option)" readonly />
      <span style="margin-left: 8px;">{{ option.name }}</span>
    </li>
  </template>
</multiselect>
   <div class="d-flex g-space-15 mt-9">
                  <v-btn
                    @click="senddocumentchangemail()"
                    outlined
                    depressed
                    tile
                    class="savebutton"
                  >
                    <!--<v-icon color="#444">mdi-delete</v-icon>-->
                    {{ $t("send") }}</v-btn
                  >
                  <v-btn
                    @click="openDialogDocumentChange = false"
                    outlined
                    depressed
                    tile
                    class="cancelBtn"
                  >
                    {{ $t("cancel") }}</v-btn
                  >
                </div>
              </v-card-actions>



            </v-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Card,
    pagination,
    Breadcrumb,
    Multiselect 
  },

  props: {
    trainingEventId: Number,
    trainingRequestId: Number,
  },

  data() {
    return {
       selected: [],
      trainers: [],
      firstTimeFeedback: false,
      firstTimeFeedback: false,
      firstTimeInvitation: false,
      openDialogDocumentChange: false,
      documentChangeDisplay: false,
      disableEventNumber: false,
      customerDisabled: false,
      characterCountComments: 0,
      bookingToDelete: null,
      participants_search: null,
      counter: 0,
      characterCount: 0,
      characterCount2: 0,
      maxCharacterCount: 1050,
      seatOccupied: 0,
      seatTenant: null,
      seatNumber: null,
      seatShare: [],
      eventStatus: "normal",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      currentBookingID: "",
      showModal: false,
      scrollPositionX: 0,
      scrollPositionY: 0,
      edituser: {
        firstname: null,
        lastname: null,
        personnelnumber: null,
        location: null,
        company: null,
        email: null,
        language: null,
        tenantId: null,
        selectedStatus: null,
        certificateStartDate: null,
        certificateEndDate: null,
        certificateEventLocation: null,
        certificateEventNumber: null,
        certificateTrainer: null,
        certificateTrainer2: null,
        certificateStartDateOther: null,
        certificateEndDateOther: null,
        display: null,
        certificateEventLocationOther: null,
        certificateEventNumberOther: null,
        certificateTrainerOther: null,
        certificateTrainer2Other: null,
        certificateEventTrainingCategoryNameEnglish: null,
        certificateEventTrainingCategoryNameGerman: null,
        certificateEventTrainingCategoryNamePolish: null,
        certificateEventTrainingCategoryNameFrench: null,
        certificateEventTrainingCategoryNameHungarian: null,
        certificateEventTrainingCategoryNameSpanish: null,
        certificateEventTrainingCategoryNameRussian: null,
        certificateEventTrainingCategoryNameKazak: null,
        certificateEventTrainingCategoryNameItalian: null,
        certificateEventTrainingCategoryNameChina: null,
        certificateTrainingNameEnglish: null,
        certificateTrainingNameGerman: null,
        certificateTrainingNamePolish: null,
        certificateTrainingNameFrench: null,
        certificateTrainingNameHungarian: null,
        certificateTrainingNameSpanish: null,
        certificateTrainingNameRussian: null,
        certificateTrainingNameKazak: null,
        certificateTrainingNameItalian: null,
        certificateTrainingNameChina: null,
        certificateEventTrainingCategoryNameOtherEnglish: null,
        certificateEventTrainingCategoryNameOtherGerman: null,
        certificateEventTrainingCategoryNameOtherPolish: null,
        certificateEventTrainingCategoryNameOtherFrench: null,
        certificateEventTrainingCategoryNameOtherHungarian: null,
        certificateEventTrainingCategoryNameOtherSpanish: null,
        certificateEventTrainingCategoryNameOtherRussian: null,
        certificateEventTrainingCategoryNameOtherKazak: null,
        certificateEventTrainingCategoryNameOtherItalian: null,
        certificateEventTrainingCategoryNameOtherChina: null,
        certificateTrainingNameOtherEnglish: null,
        certificateTrainingNameOtherGerman: null,
        certificateTrainingNameOtherPolish: null,
        certificateTrainingNameOtherFrench: null,
        certificateTrainingNameOtherHungarian: null,
        certificateTrainingNameOtherSpanish: null,
        certificateTrainingNameOtherRussian: null,
        certificateTrainingNameOtherKazak: null,
        certificateTrainingNameOtherItalian: null,
        certificateTrainingNameOtherChina: null,

        certificateTrainingName: null,
        certificateTrainingNameOther: null,
        certificateTrainingDescription: null,
        certificateEventTrainingCategoryName: null,
        certificateEventTrainingCategoryNameOther: null,
        certificateEventTrainingCategoryDescription: null,
        certificateEventTrainingCategoryName: null,
        certificateEventTrainingCategoryNameOther: null,
        certificateEventTrainingCategoryDescription: null,
        certificateEventTrainingCategoryDescriptionEnglish: null,
        certificateEventTrainingCategoryDescriptionGerman: null,
        certificateEventTrainingCategoryDescriptionPolish: null,
        certificateEventTrainingCategoryDescriptionFrench: null,
        certificateEventTrainingCategoryDescriptionHungarian: null,
        certificateEventTrainingCategoryDescriptionSpanish: null,
        certificateEventTrainingCategoryDescriptionRussian: null,
        certificateEventTrainingCategoryDescriptionKazak: null,
        certificateEventTrainingCategoryDescriptionItalian: null,
        certificateEventTrainingCategoryDescriptionChina: null,

        certificateTrainingDescriptionEnglish: null,
        certificateTrainingDescriptionGerman: null,
        certificateTrainingDescriptionPolish: null,
        certificateTrainingDescriptionFrench: null,
        certificateTrainingDescriptionHungarian: null,
        certificateTrainingDescriptionSpanish: null,
        certificateTrainingDescriptionRussian: null,
        certificateTrainingDescriptionKazak: null,
        certificateTrainingDescriptionItalian: null,
        certificateTrainingDescriptionChina: null,
      },
      editMode: false,
      // trainers: [],
      translators: [],
      rooms: [],
      locations: [],
      trainings: [],
      trainingEventCategories: [],
      bookings: [],
      customers: [],
      seatShareCustomers: [],
      users: [],
      feedBacks: [],
      manualfeedBacks: [],
      selectedLocationId: null,
      eventTrainingCategory: [],
      customEmail: null,
      trainingEventTab: null,
      openSendMailCustomDialog: false,
      openSendMailAgainDialog: false,
      sendMailAgainBooking: null,
      openSendMailCustomDialogFeedBack: false,
      openSendMailAgainFeedBackDialog: false,
      sendMailAgainFeedBackBooking: null,
      openSendMailAgainFeedBackDialog: false,
      sendMailAgainFeedBackBooking: null,
      openDeleteDialog: false,
      openDeleteDialogBooking: false,
      openCancelledDialog: false,
      editHeadline: this.$t("edit_trainingEvent"),
      startDateMenu: false,
      trainingEvent: {
        trainingRequestId: null,
        designations: {},
        descriptions: {},
        onlineDescriptions: {},
        streets: {},
        hnr: null,
        zip: null,
        cities: {},
        region: null,
        country: null,
        descriptionsMap: {},
        onlineDescriptionsMap: {},
        image: null,
        status: "BOOKABLE",
        examType: "ORAL",
        trainingId: null,
        vehicleType: null,
        project: null,
        eventTrainingCategoryId: null,
        customerId: null,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        comment: null,
        documents: [],
        internalDocuments: [],
        salesListId: null,
        customerNumber: null,
        selectedLocationId_PR_1: null,
        selectedLocationId_PR_2: null,
        selectedLocationId_PR_3: null,
        selectedLocationId_TH_1: null,
        selectedLocationId_TH_2: null,
        selectedLocationId_TH_3: null,
        startDate_PR_1: null,
        startDate_PR_2: null,
        startDate_PR_3: null,
        startDate_TH_1: null,
        startDate_TH_2: null,
        startDate_TH_3: null,
        endDate_PR_1: null,
        endDate_PR_2: null,
        endDate_PR_3: null,
        endDate_TH_1: null,
        endDate_TH_2: null,
        endDate_TH_3: null,
        onlinelink_PR_1: null,
        onlinelink_PR_2: null,
        onlinelink_PR_3: null,
        onlinelink_TH_1: null,
        onlinelink_TH_2: null,
        onlinelink_TH_3: null,
        startTime_PR_1: null,
        startTime_PR_2: null,
        startTime_PR_3: null,
        startTime_TH_1: null,
        startTime_TH_2: null,
        startTime_TH_3: null,
        endTime_PR_1: null,
        endTime_PR_2: null,
        endTime_PR_3: null,
        endTime_TH_1: null,
        endTime_TH_2: null,
        endTime_TH_3: null,
        trainerId_PR_1: null,
        trainerId_PR_2: null,
        trainerId_PR_3: null,
        trainerId_TH_1: null,
        trainerId_TH_2: null,
        trainerId_TH_3: null,
        trainerId2_PR_1: null,
        trainerId2_PR_2: null,
        trainerId2_PR_3: null,
        trainerId2_TH_1: null,
        trainerId2_TH_2: null,
        trainerId2_TH_3: null,
        translatorId_PR_1: null,
        translatorId_PR_2: null,
        translatorId_PR_3: null,
        translatorId_TH_1: null,
        translatorId_TH_2: null,
        translatorId_TH_3: null,
        roomId_PR_1: null,
        roomId_PR_2: null,
        roomId_PR_3: null,
        roomId_TH_1: null,
        roomId_TH_2: null,
        roomId_TH_3: null,
        maxParticipants: null,
      },

      adduser: {
        firstname: null,
        lastname: null,
        personnelnumber: null,
        location: null,
        company: null,
        email: null,
        language: null,
        tenantId: null,
      },
      activator: null,
      attach: null,
      search: "",
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      editingIndex: -1,
      participants_page: 1,
      participants_totalPages: 1,
      participants_ElementPerPage: 50,
      participants_sort: null,
      participants_order: true,
      users_page: 1,
      users_totalPages: 1,
      users_ElementPerPage: 50,
      users_sort: null,
      users_order: true,
      // statusOptions: ["Participated", "Successfully Passed the Exam", "Failed"],
      isLoad: false,
      PR_1: false,
      PR_2: false,
      PR_3: false,
      TH_1: false,
      TH_2: false,
      TH_3: false,
      PR_ST: true,
      rooms_PR_1: [],
      rooms_PR_2: [],
      rooms_PR_3: [],
      rooms_TH_1: [],
      rooms_TH_2: [],
      rooms_TH_3: [],
      trainingCategoryDisabled: false,
      trainingDisabled: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.handleStorageChange);
  },
  updated() {
    let _this = this;
    let language = _this.$locale;
    //   if(_this.trainingEvent.eventNumber){
    //              if (language === "en") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "GB_"); // UK
    // } else if (language === "pl") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "PL_"); // Poland
    // } else if (language === "fr") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "FRA_"); // France
    // } else if (language === "hu") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "HU_"); // Hungary
    // } else if (language === "es") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "ES_"); // Spain
    // } else if (language === "ru") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "RU_"); // Russia
    // } else if (language === "kk") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "KZ_"); // Kazakhstan
    // } else if (language === "it") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "IT_"); // Italy
    // } else if (language === "de") {
    //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "DEU_"); // Germany
    // }

    //   }
  },
  mounted() {
    window.addEventListener("storage", this.handleStorageChange);

    if (this.$route.query.salesListId != null) {
      this.salesListId = parseInt(this.$route.query.salesListId);
      this.getSalesList();
    }
    if (this.trainingEventId != null) {
      this.editMode = true;
      this.fetchEditingTrainingEvent();
    } else {
      this.fetchTrainers();
    }
    if (
      this.isLoad != true &&
      !this.editMode &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;

      console.log("here====1");

      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    } else if (
      this.isLoad != true &&
      this.editMode &&
      !window.location.href.includes("&lang=")
    ) {
      window.location.href =
        window.location.href + "&lang=" + this.$locale.toUpperCase();
    }

    if (this.$route.query.eventStatus === "cancelled") {
      this.eventStatus = "cancelled";
    } else if (this.$route.query.eventStatus === "drafted") {
      this.eventStatus = "drafted";
    } else {
      this.eventStatus = "normal";
    }

    this.fetchTranslators();
    this.fetchLocations();
    this.fetchTrainings();
    this.fetchCategory();

    if (this.trainingRequestId != null) {
      this.fetchTrainingRequest();
    }

    if (
      !this.$rights.includes("VIEW_BOOKINGS") &&
      this.trainingEventId != null
    ) {
      this.trainingEventTab = 1;
    } else {
      this.trainingEventTab = 0;
    }

    this.fetchOnlineFeedBacks();
    this.fetchManualFeedBacks();
    this.fetchCustomers();
    if (
      !this.trainingEvent.eventNumber ||
      this.trainingEvent.eventNumber.trim() === ""
    ) {
      this.getEventNumber();
    }
  },

  watch: {
    $user() {
      if (this.$user == null || !this.$user.external) return;
      this.adduser.company = this.$user.company;
    },
    trainingEventTab() {
      this.adduser.language =
        this.$language != null ? this.$language.language : null;
    },
    trainingEvent: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
  },
  watch: {
    filteredCategories: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
    request: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
  },
  computed: {
    allSelected() {
    const allIds = this.participantOptions.map((p) => p.id);
    return (
      this.selected.length === allIds.length &&
      allIds.every((id) => this.selected.some((s) => s.id === id))
    );
  },
     participantOptions() {
    return this.bookings.map(b => ({
      id: b.id,
      name: b.participant.lastname +", "+ b.participant.firstname
          }));
  },
    statusOptions() {
      return [
        { value: "Participated", text: this.$t("participated") },
        {
          value: "Successfully Passed the Exam",
          text: this.$t("successfully_passed_the_exam"),
        },
        { value: "Failed", text: this.$t("failed") },
      ];
    },
    selectedExamTypeText() {
      const selectedExamType = this.selectableExamTypes.find(
        (type) => type.value === this.trainingEvent.examType
      );
      return selectedExamType ? selectedExamType.text : "";
    },
    filteredCategories() {
      if (this.trainingEvent.eventTrainingCategoryId) {
        const filteredCategories = [];
        for (const catGroup of this.trainingEventCategories) {
          if (catGroup.id === this.trainingEvent.eventTrainingCategoryId) {
            for (const cat of catGroup.category) {
              if (
                cat.designationMap[this.$locale] != null ||
                cat.designationMap[this.$locale] != ""
              ) {
                filteredCategories.push({
                  value: cat.id,
                  text: cat.designationMap[this.$locale],
                });
              }
            }
          }
        }
        return filteredCategories;
      }
    },
    trainingEventCategories1() {
      const trainingEventCategories = Array.isArray(
        this.trainingEventCategories
      )
        ? this.trainingEventCategories
            .filter((trainingEventCategory) => {
              // Ensure both designationsMap and locale-specific designation are valid (not null or undefined)
              const designationMap = trainingEventCategory.designationsMap;
              const localeDesignation = designationMap?.[this.$locale];
              // Keep only if both designationsMap and locale-specific designation exist
              return designationMap && localeDesignation;
            })
            .map((trainingEventCategory) => ({
              value: trainingEventCategory.id,
              text: trainingEventCategory.designationsMap[this.$locale],
            }))
            .sort((a, b) => {
              const textA = a.text ? a.text.trim().toLowerCase() : "";
              const textB = b.text ? b.text.trim().toLowerCase() : "";
              return textA.localeCompare(textB, this.$locale, {
                sensitivity: "base",
              });
            })
        : [];
      return trainingEventCategories;
    },

    selectableStatus() {
      return [
        { value: "BOOKABLE", text: this.$t("bookable_event") },
        { value: "CLOSED", text: this.$t("closed_event") },
      ];
    },

    selectableExamTypes() {
      return [
        { value: "ORAL", text: this.$t("practical_exam") },
        { value: "THEORETICAL", text: this.$t("theoretical_exam") },
        {
          value: "ORAL_AND_THEORETICAL",
          text: this.$t("practical_and_theoretical_exam"),
        },
        {
          value: "ORAL_THEORETICAL",
          text: this.$t("practical_theoretical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL",
          text: this.$t("theoretical_and_theoretical_exam"),
        },
        { value: "ORAL_ORAL", text: this.$t("practical_and_practical_exam") },
        {
          value: "ORAL_ORAL_AND_THEORETICAL",
          text: this.$t("practical_practical_and_theoretical_exam"),
        },
        {
          value: "ORAL_ORAL_AND_ORAL",
          text: this.$t("practical_practical_and_practical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL_AND_ORAL",
          text: this.$t("theoretical_theoretical_and_practical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL_AND_THEROTICAL",
          text: this.$t("theoretical_theoretical_and_theoretical_exam"),
        },
      ];
    },

    types() {
      return [
        { value: "PRESENCE", text: this.$t("PRESENCE") },
        { value: "VIDEO", text: this.$t("VIDEO") },
        { value: "VIRTUAL", text: this.$t("VIRTUAL") },
        {
          value: "PRESENCE_AND_VIRTUAL",
          text: this.$t("PRESENCE_AND_VIRTUAL"),
        },
      ];
    },
    clickableOnlineLink: {
      get() {
        if (this.trainingEvent == null || this.trainingEvent.onlinelink == null)
          return null;
        if (
          this.trainingEvent.onlineLink.startsWith("http://") ||
          this.trainingEvent.onlineLink.startsWith("https://")
        )
          return this.trainingEvent.onlineLink;
        return "https://" + this.trainingEvent.onlineLink;
      },
    },
    selectedUsers: {
      get() {
        return {
          trainer: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId
          ),
          trainer2: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainer2Id
          ),
          translator: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId
          ),

          trainer_PR_1: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_PR_1
          ),
          trainer2_PR_1: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_PR_1
          ),
          translator_PR_1: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_PR_1
          ),

          trainer_PR_2: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_PR_2
          ),
          trainer2_PR_2: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_PR_2
          ),
          translator_PR_2: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_PR_2
          ),

          trainer_PR_3: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_PR_3
          ),
          trainer2_PR_3: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_PR_3
          ),
          translator_PR_3: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_PR_3
          ),

          trainer_TH_1: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_TH_1
          ),
          trainer2_TH_1: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_TH_1
          ),
          translator_TH_1: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_TH_1
          ),

          trainer_TH_2: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_TH_2
          ),
          trainer2_TH_2: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_TH_2
          ),
          translator_TH_2: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_TH_2
          ),

          trainer_TH_3: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId_TH_3
          ),
          trainer2_TH_3: this.getArrayElementById(
            "trainers",
            this.trainingEvent.trainerId2_TH_3
          ),
          translator_TH_3: this.getArrayElementById(
            "translators",
            this.trainingEvent.translatorId_TH_3
          ),
        };
      },
    },
    locationAndRoomDisabled: {
      get() {
        if (
          this.trainingEvent.eventType === "VIDEO" ||
          this.trainingEvent.eventType === "VIRTUAL"
        ) {
          this.trainingEvent.roomId = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.roomId_PR_1 = null;
          this.trainingEvent.selectedLocationId_PR_1 = null;
          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.roomId_TH_1 = null;
          this.trainingEvent.selectedLocationId_TH_1 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;
          return true;
        } else {
          return false;
        }
      },
    },
    sortedTrainings() {
      return this.trainings.sort((a, b) => {
        const textA = a.text ? a.text.trim().toLowerCase() : "";
        const textB = b.text ? b.text.trim().toLowerCase() : "";
        return textA.localeCompare(textB, this.$locale, {
          sensitivity: "base",
        });
      });
    },
  },

  methods: {
 isOptionSelected(option) {
    return this.selected.some((s) => s.id === option.id);
  },
  toggleSelectAll() {
    if (this.allSelected) {
      this.selected = [];
    } else {
      this.selected = [...this.participantOptions];
    }
  },
    isValidTime(time) {
      const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
      return regex.test(time);
    },
    senddocumentchangemail() {
      let _this = this;
      if (
        !this.selected ||
        this.selected.length === 0
      ) {
        _this.$noty.error(
          _this.$t("at_least_one_participant_must_be_selected")
        );
        return false;
      }
      progressIndicator.hidden = false;
      _this.openDialogDocumentChange = false;
      showLoadingCircle(true);
      this.$axios
        .post(
          `/api/training/event/send-document-change-mail/${_this.trainingEventId}`,

          _this.selected.map(p => p.id)
        )
        .then(function (response) {
          _this.fetchBookings();
          _this.$noty.success(_this.$t("documentChangeEmail"));
          _this.documentChangeDisplay = false;
          _this.selected=[];
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    handleBlurLanguage() {
      const autocompleteMenu = this.$refs.autocompleteLanaguge.$refs.menu;
      if (autocompleteMenu) {
        autocompleteMenu.isActive = false;
      }
    },
    handleBlurStatus() {
      const autocompleteMenu = this.$refs.autocompleteStatus.$refs.menu;
      if (autocompleteMenu) {
        autocompleteMenu.isActive = false;
      }
    },
    handleBlur() {
      const autocompleteMenu = this.$refs.autocomplete.$refs.menu;
      if (autocompleteMenu) {
        autocompleteMenu.isActive = false;
      }
    },
    salesList(salesListId) {
      if (salesListId) {
        this.$router.push("/sales-request?salesListId=" + salesListId);
        return;
      }
    },
    updateCharacterCountComments() {
      this.characterCountComments = this.trainingEvent.comment.length;
    },
    deleteBooking1(booking) {
      this.bookingToDelete = booking;
      this.openDeleteDialogBooking = true;
    },
    confirmDeleteBooking() {
      if (this.bookingToDelete) {
        this.deleteBooking(this.bookingToDelete);
        this.openDeleteDialogBooking = false;
        this.bookingToDelete = null;
      }
    },
    getEventNumber() {
      var _this = this;
      this.$axios.get("/api/training/event/eventNo").then(function (response) {
        if (
          !_this.trainingEvent.eventNumber ||
          _this.trainingEvent.eventNumber.trim() === ""
        ) {
          _this.trainingEvent.eventNumber = response.data;
          _this.$set(_this.trainingEvent, "eventNumber", response.data);
          _this["trainingEvent.eventNumber"] = [...response.data];
          let language = _this.$locale;
          //             if(_this.trainingEvent.eventNumber){
          //                         if (language === "en") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "GB_"); // UK
          // } else if (language === "pl") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "PL_"); // Poland
          // } else if (language === "fr") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "FRA_"); // France
          // } else if (language === "hu") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "HU_"); // Hungary
          // } else if (language === "es") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "ES_"); // Spain
          // } else if (language === "ru") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "RU_"); // Russia
          // } else if (language === "kk") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "KZ_"); // Kazakhstan
          // } else if (language === "it") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "IT_"); // Italy
          // } else if (language === "de") {
          //     _this.trainingEvent.eventNumber = _this.trainingEvent.eventNumber.replace("Vorg_", "DEU_"); // Germany
          // }

          //             }

          _this.$forceUpdate();
        }
      });
    },

    fetchCategory() {
      var _this = this;
      this.$axios
        .get("/api/eventTrainingCategory")
        .then(function (response) {
          _this.trainingEventCategories = response.data.content;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    incrementCounter(type) {
      const randomNumber = Math.floor(Math.random() * 99999) + 1; // Generates a random number between 1 and 99999
      localStorage.setItem("counterValue", type + "-" + randomNumber);
    },
    handleStorageChange(event) {
      if (event.key === "counterValue") {
        this.counter = parseInt(event.newValue);
      }
    },
    displaySeatShare(share) {
      return `${share.company} : ${share.seatAlloted} ${this.$t("Seats")}`;
    },
    handleInput() {
      this.characterCount = this.edituser.certificateTrainingDescription.length;
    },
    handleInput2() {
      this.characterCount2 =
        this.edituser.certificateEventTrainingCategoryDescription.length;
    },
    seatShareSave() {
      let _this = this;
      _this.trainingEvent.seatShare = _this.seatShare;

      if (this.editMode) {
        // Edit Training
        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .put(
            "/api/training/event/seatShare/" + _this.trainingEventId,
            _this.seatShare
          )
          .then(function (response) {
            _this.$noty.success(
              _this.$t("seatShared", { name: response.data.designation })
            );
            _this.seatNumber = null;
            _this.seatTenant = null;
            // _this.$router.push("/training-events");
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },

    remove(index) {
      let _this = this;
      for (let i = 0; i < _this.bookings.length; i++) {
        const booking = this.bookings[i];
        if (booking.participant.tenantId === _this.seatShare[index].tenant.id) {
          _this.$noty.error(
            this.$t("removeParticipantsFromTenant", {
              name: this.$t("language"),
            })
          );
          return;
        }
      }
      let removedTenantId = this.seatShare[index].tenant.id;
      _this.customers.forEach((customer) => {
        if (customer.id === removedTenantId) {
          _this.seatShareCustomers.push(customer);
        }
      });

      this.seatOccupied -= parseInt(this.seatShare[index].seatAlloted);
      this.seatShare.splice(index, 1);
    },

    addSeatShare() {
      let _this = this;
      if (_this.seatNumber <= 0) {
        this.$noty.error(
          this.$t("seatAllocationZeroError", { name: this.$t("language") })
        );
        return;
      }
      if (
        _this.trainingEvent.freeSpaces - _this.seatOccupied - _this.seatNumber <
        0
      ) {
        this.$noty.error(
          this.$t("seatAllocationError", { name: this.$t("language") })
        );
        return;
      }
      let customer;
      customer = _this.customers.find(function (customer) {
        if (customer.id === _this.seatTenant) {
          return customer;
        }
      });

      let existingItemIndex = this.seatShare.findIndex(function (item) {
        return item.tenant.id === _this.seatTenant;
      });

      if (existingItemIndex === -1) {
        this.seatShare.push({
          tenant: customer,
          seatAlloted: parseInt(_this.seatNumber),
          company: customer.name,
        });

        _this.seatShareCustomers = _this.seatShareCustomers.filter(
          (custome) => custome.id !== customer.id
        );

        this.seatOccupied += parseInt(_this.seatNumber);
      }
    },
    fetchOnlineFeedBacks() {
      var _this = this;
      if (_this.editMode) {
        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .get("/api/training/event/" + this.trainingEventId + "/feedbacks")
          .then(function (response) {
            for (let i = 0; i < response.data.length; i++) {
              _this.feedBacks.push(response.data[i]);
            }
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },

    fetchManualFeedBacks() {
      var _this = this;
      if (_this.editMode) {
        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .get(
            "/api/training/event/" +
              _this.trainingEventId +
              "/retrieveManualFeedbacks"
          )
          .then(function (response) {
            for (let i = 0; i < response.data.length; i++) {
              _this.manualfeedBacks.push(response.data[i]);
            }
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },
    sendOnlineFeedBack(booking) {
      this.sendMailForOnlineFeedBack(booking);
    },
    beforeOpenModal(booking) {
      this.currentBookingID = booking.id;
      this.scrollPositionX = window.scrollX;
      this.scrollPositionY = window.scrollY;
      var _this = this;
      _this.edituser = {
        firstname: null,
        lastname: null,
        personnelnumber: null,
        location: null,
        company: null,
        email: null,
        tenantId: null,
        certificateStartDate: null,
        certificateEndDate: null,
        certificateEventLocation: null,
        certificateEventNumber: null,
        certificateTrainer: null,
        certificateTrainer2: null,
        eventStatus: null,
        eventStatusOther: null,
        certificateStartDateOther: null,
        certificateEndDateOther: null,
        display: null,
        certificateEventLocationOther: null,
        certificateTrainerOther: null,
        certificateTrainer2Other: null,
        certificateEventTrainingCategoryNameEnglish: null,
        certificateEventTrainingCategoryNameGerman: null,
        certificateEventTrainingCategoryNamePolish: null,
        certificateEventTrainingCategoryNameFrench: null,
        certificateEventTrainingCategoryNameHungarian: null,
        certificateEventTrainingCategoryNameSpanish: null,
        certificateEventTrainingCategoryNameRussian: null,
        certificateEventTrainingCategoryNameKazak: null,
        certificateEventTrainingCategoryNameItalian: null,
        certificateEventTrainingCategoryNameChina: null,
        certificateTrainingNameEnglish: null,
        certificateTrainingNameGerman: null,
        certificateTrainingNamePolish: null,
        certificateTrainingNameFrench: null,
        certificateTrainingNameHungarian: null,
        certificateTrainingNameSpanish: null,
        certificateTrainingNameRussian: null,
        certificateTrainingNameKazak: null,
        certificateTrainingNameItalian: null,
        certificateTrainingNameChina: null,
        certificateEventTrainingCategoryNameOtherEnglish: null,
        certificateEventTrainingCategoryNameOtherGerman: null,
        certificateEventTrainingCategoryNameOtherPolish: null,
        certificateEventTrainingCategoryNameOtherFrench: null,
        certificateEventTrainingCategoryNameOtherHungarian: null,
        certificateEventTrainingCategoryNameOtherSpanish: null,
        certificateEventTrainingCategoryNameOtherRussian: null,
        certificateEventTrainingCategoryNameOtherKazak: null,
        certificateEventTrainingCategoryNameOtherItalian: null,
        certificateEventTrainingCategoryNameOtherChina: null,
        certificateTrainingNameOtherEnglish: null,
        certificateTrainingNameOtherGerman: null,
        certificateTrainingNameOtherPolish: null,
        certificateTrainingNameOtherFrench: null,
        certificateTrainingNameOtherHungarian: null,
        certificateTrainingNameOtherSpanish: null,
        certificateTrainingNameOtherRussian: null,
        certificateTrainingNameOtherKazak: null,
        certificateTrainingNameOtherItalian: null,
        certificateTrainingNameOtherChina: null,
        certificateEventTrainingCategoryName: null,
        certificateEventTrainingCategoryNameOther: null,
        certificateEventTrainingCategoryDescription: null,
        certificateTrainingName: null,
        certificateTrainingNameOther: null,
        certificateTrainingDescription: null,
        certificateEventTrainingCategoryDescriptionEnglish: null,
        certificateEventTrainingCategoryDescriptionGerman: null,
        certificateEventTrainingCategoryDescriptionPolish: null,
        certificateEventTrainingCategoryDescriptionFrench: null,
        certificateEventTrainingCategoryDescriptionHungarian: null,
        certificateEventTrainingCategoryDescriptionSpanish: null,
        certificateEventTrainingCategoryDescriptionRussian: null,
        certificateEventTrainingCategoryDescriptionKazak: null,
        certificateEventTrainingCategoryDescriptionItalian: null,
        certificateEventTrainingCategoryDescriptionChina: null,

        certificateTrainingDescriptionEnglish: null,
        certificateTrainingDescriptionGerman: null,
        certificateTrainingDescriptionPolish: null,
        certificateTrainingDescriptionFrench: null,
        certificateTrainingDescriptionHungarian: null,
        certificateTrainingDescriptionSpanish: null,
        certificateTrainingDescriptionRussian: null,
        certificateTrainingDescriptionKazak: null,
        certificateTrainingDescriptionItalian: null,
        certificateTrainingDescriptionChina: null,

        certificateStartDate_PR_1: null,
        certificateStartDate_PR_2: null,
        certificateStartDate_PR_3: null,
        certificateStartDate_TH_1: null,
        certificateStartDate_TH_2: null,
        certificateStartDate_TH_3: null,
        certificateEndDate_PR_1: null,
        certificateEndDate_PR_2: null,
        certificateEndDate_PR_3: null,
        certificateEndDate_TH_1: null,
        certificateEndDate_TH_2: null,
        certificateEndDate_TH_3: null,
        certificateTrainer2_PR_1: null,
        certificateTrainer2_PR_2: null,
        certificateTrainer2_PR_3: null,
        certificateTrainer2_TH_1: null,
        certificateTrainer2_TH_2: null,
        certificateTrainer2_TH_3: null,
        certificateTrainer_PR_1: null,
        certificateTrainer_PR_2: null,
        certificateTrainer_PR_3: null,
        certificateTrainer_TH_1: null,
        certificateTrainer_TH_2: null,
        certificateTrainer_TH_3: null,

        certificateEventLocation_PR_1: null,
        certificateEventLocation_PR_2: null,
        certificateEventLocation_PR_3: null,
        certificateEventLocation_TH_1: null,
        certificateEventLocation_TH_2: null,
        certificateEventLocation_TH_3: null,
      };
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/booking/" + booking.id)
        .then(function (response) {
          _this.edituser.firstname = response.data.participant.firstname.trim();
          _this.edituser.lastname = response.data.participant.lastname.trim();
          _this.edituser.personnelnumber =
            response.data.participant.personnelnumber;
          _this.edituser.location = response.data.participant.location;
          _this.edituser.company = response.data.participant.originalCompany;
          _this.edituser.email = response.data.participant.email;
          _this.edituser.language = response.data.participant.language;
          _this.edituser.tenantId = _this.customers.find(function (customer) {
            if (customer.id === response.data.participant.tenantId) {
              return customer;
            }
          });
          _this.edituser.userId = response.data.participant.id;
          _this.edituser.selectedStatus = response.data.selectedStatus;
          _this.edituser.certificateStartDate =
            response.data.certificateStartDate;
          _this.edituser.certificateEndDate = response.data.certificateEndDate;
          _this.edituser.certificateEventLocation =
            response.data.certificateEventLocation;
          _this.edituser.certificateEventNumber =
            response.data.certificateEventNumber;
          _this.edituser.certificateTrainer = response.data.certificateTrainer;
          _this.edituser.certificateTrainer2 =
            response.data.certificateTrainer2;
          _this.edituser.certificateStartDateOther =
            response.data.certificateStartDateOther;
          _this.edituser.certificateEndDateOther =
            response.data.certificateEndDateOther;
          _this.edituser.display = response.data.display;
          _this.edituser.eventStatus = response.data.eventStatus;
          _this.edituser.eventStatusOther = response.data.eventStatusOther;
          _this.edituser.certificateEventLocationOther =
            response.data.certificateEventLocationOther;
          _this.edituser.certificateTrainerOther =
            response.data.certificateTrainerOther;
          _this.edituser.certificateTrainer2Other =
            response.data.certificateTrainer2Other;
          _this.edituser.certificateEventTrainingCategoryNameEnglish =
            response.data.certificateEventTrainingCategoryNameEnglish;
          _this.edituser.certificateEventTrainingCategoryNameGerman =
            response.data.certificateEventTrainingCategoryNameGerman;
          _this.edituser.certificateEventTrainingCategoryNamePolish =
            response.data.certificateEventTrainingCategoryNamePolish;
          _this.edituser.certificateEventTrainingCategoryNameFrench =
            response.data.certificateEventTrainingCategoryNameFrench;
          _this.edituser.certificateEventTrainingCategoryNameHungarian =
            response.data.certificateEventTrainingCategoryNameHungarian;
          _this.edituser.certificateEventTrainingCategoryNameSpanish =
            response.data.certificateEventTrainingCategoryNameSpanish;
          _this.edituser.certificateEventTrainingCategoryNameRussian =
            response.data.certificateEventTrainingCategoryNameRussian;
          _this.edituser.certificateEventTrainingCategoryNameKazak =
            response.data.certificateEventTrainingCategoryNameKazak;
          _this.edituser.certificateEventTrainingCategoryNameItalian =
            response.data.certificateEventTrainingCategoryNameItalian;
          _this.edituser.certificateEventTrainingCategoryNameChina =
            response.data.certificateEventTrainingCategoryNameChina;

          _this.edituser.certificateTrainingNameEnglish =
            response.data.certificateTrainingNameEnglish;
          _this.edituser.certificateTrainingNameGerman =
            response.data.certificateTrainingNameGerman;
          _this.edituser.certificateTrainingNamePolish =
            response.data.certificateTrainingNamePolish;
          _this.edituser.certificateTrainingNameFrench =
            response.data.certificateTrainingNameFrench;
          _this.edituser.certificateTrainingNameHungarian =
            response.data.certificateTrainingNameHungarian;
          _this.edituser.certificateTrainingNameSpanish =
            response.data.certificateTrainingNameSpanish;
          _this.edituser.certificateTrainingNameRussian =
            response.data.certificateTrainingNameRussian;
          _this.edituser.certificateTrainingNameKazak =
            response.data.certificateTrainingNameKazak;
          _this.edituser.certificateTrainingNameItalian =
            response.data.certificateTrainingNameItalian;
          _this.edituser.certificateTrainingNameChina =
            response.data.certificateTrainingNameChina;
          _this.edituser.certificateEventTrainingCategoryNameOtherEnglish =
            response.data.certificateEventTrainingCategoryNameOtherEnglish;
          _this.edituser.certificateEventTrainingCategoryNameOtherGerman =
            response.data.certificateEventTrainingCategoryNameOtherGerman;
          _this.edituser.certificateEventTrainingCategoryNameOtherPolish =
            response.data.certificateEventTrainingCategoryNameOtherPolish;
          _this.edituser.certificateEventTrainingCategoryNameOtherFrench =
            response.data.certificateEventTrainingCategoryNameOtherFrench;
          _this.edituser.certificateEventTrainingCategoryNameOtherHungarian =
            response.data.certificateEventTrainingCategoryNameOtherHungarian;
          _this.edituser.certificateEventTrainingCategoryDescriptionEnglish =
            response.data.certificateEventTrainingCategoryDescriptionEnglish;
          _this.edituser.certificateEventTrainingCategoryDescriptionGerman =
            response.data.certificateEventTrainingCategoryDescriptionGerman;
          _this.edituser.certificateEventTrainingCategoryDescriptionPolish =
            response.data.certificateEventTrainingCategoryDescriptionPolish;
          _this.edituser.certificateEventTrainingCategoryDescriptionFrench =
            response.data.certificateEventTrainingCategoryDescriptionFrench;
          _this.edituser.certificateEventTrainingCategoryDescriptionHungarian =
            response.data.certificateEventTrainingCategoryDescriptionHungarian;
          _this.edituser.certificateEventTrainingCategoryDescriptionSpanish =
            response.data.certificateEventTrainingCategoryDescriptionSpanish;
          _this.edituser.certificateEventTrainingCategoryDescriptionRussian =
            response.data.certificateEventTrainingCategoryDescriptionRussian;
          _this.edituser.certificateEventTrainingCategoryDescriptionKazak =
            response.data.certificateEventTrainingCategoryDescriptionKazak;
          _this.edituser.certificateEventTrainingCategoryDescriptionItalian =
            response.data.certificateEventTrainingCategoryDescriptionItalian;
          _this.edituser.certificateEventTrainingCategoryDescriptionChina =
            response.data.certificateEventTrainingCategoryDescriptionChina;

          _this.edituser.certificateTrainingNameOtherEnglish =
            response.data.certificateTrainingNameOtherEnglish;
          _this.edituser.certificateTrainingNameOtherGerman =
            response.data.certificateTrainingNameOtherGerman;
          _this.edituser.certificateTrainingNameOtherPolish =
            response.data.certificateTrainingNameOtherPolish;
          _this.edituser.certificateTrainingNameOtherFrench =
            response.data.certificateTrainingNameOtherFrench;
          _this.edituser.certificateTrainingNameOtherHungarian =
            response.data.certificateTrainingNameOtherHungarian;
          _this.edituser.certificateTrainingDescriptionEnglish =
            response.data.certificateTrainingDescriptionEnglish;
          _this.edituser.certificateTrainingDescriptionGerman =
            response.data.certificateTrainingDescriptionGerman;
          _this.edituser.certificateTrainingDescriptionPolish =
            response.data.certificateTrainingDescriptionPolish;
          _this.edituser.certificateTrainingDescriptionFrench =
            response.data.certificateTrainingDescriptionFrench;
          _this.edituser.certificateTrainingDescriptionHungarian =
            response.data.certificateTrainingDescriptionHungarian;
          _this.edituser.certificateTrainingDescriptionSpanish =
            response.data.certificateTrainingDescriptionSpanish;
          _this.edituser.certificateTrainingDescriptionRussian =
            response.data.certificateTrainingDescriptionRussian;
          _this.edituser.certificateTrainingDescriptionKazak =
            response.data.certificateTrainingDescriptionKazak;
          _this.edituser.certificateTrainingDescriptionItalian =
            response.data.certificateTrainingDescriptionItalian;
          _this.edituser.certificateTrainingDescriptionChina =
            response.data.certificateTrainingDescriptionChina;

          let language = _this.$locale;
          if (language === "en") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameEnglish;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherEnglish;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionEnglish;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameEnglish;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherEnglish;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionEnglish;
            // _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber?_this.edituser.certificateEventNumber.replace("Vorg_", "GB_"):null;
            // _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther? _this.edituser.certificateEventNumberOther.replace("Vorg_", "GB_"):null;
          } else if (language === "de") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameGerman;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherGerman;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionGerman;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameGerman;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherGerman;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionGerman;
            //      _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber?_this.edituser.certificateEventNumber.replace("Vorg_", "DEU"):null;
            // _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther? _this.edituser.certificateEventNumberOther.replace("Vorg_", "DEU_"):null;
          } else if (language === "pl") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNamePolish;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherPolish;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionPolish;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNamePolish;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherPolish;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionPolish;
            //      _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "PL_") : null;
            //     _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "PL_"):null;
          } else if (language === "fr") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameFrench;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherFrench;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionFrench;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameFrench;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherFrench;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionFrench;
            //    _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "FRA_"):null;
            //                   _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "FRA_"):null;
          } else if (language === "hu") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameHungarian;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherHungarian;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionHungarian;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameHungarian;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherHungarian;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionHungarian;
            //     _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "HU_"):null;
            //  _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "HU_"):null;
          } else if (language === "es") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameSpanish;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherSpanish;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionSpanish;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameSpanish;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherSpanish;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionSpanish;
            //    _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "ES_"):null;
            //   _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "ES_"):null;
          } else if (language === "ru") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameRussian;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherRussian;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionRussian;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameRussian;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherRussian;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionRussian;
            //     _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "RU_"):null;
            //                                   _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "RU_"):null;
          } else if (language === "kk") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameKazak;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherKazak;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionKazak;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameKazak;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherKazak;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionKazak;
            //     _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "KZ_"):null;
            //    _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "KZ_"):null;
          } else if (language === "it") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameItalian;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherItalian;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionItalian;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameItalian;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherItalian;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionItalian;
            //      _this.edituser.certificateEventNumber=_this.edituser.certificateEventNumber ? _this.edituser.certificateEventNumber.replace("Vorg_", "IT_"):null;
            //                      _this.edituser.certificateEventNumberOther=_this.edituser.certificateEventNumberOther?_this.edituser.certificateEventNumberOther.replace("Vorg_", "IT_"):null;
          } else if (language === "zh") {
            _this.edituser.certificateEventTrainingCategoryName =
              _this.edituser.certificateEventTrainingCategoryNameChina;
            _this.edituser.certificateEventTrainingCategoryNameOther =
              _this.edituser.certificateEventTrainingCategoryNameOtherChina;
            _this.edituser.certificateEventTrainingCategoryDescription =
              _this.edituser.certificateEventTrainingCategoryDescriptionChina;
            _this.edituser.certificateTrainingName =
              _this.edituser.certificateTrainingNameChina;
            _this.edituser.certificateTrainingNameOther =
              _this.edituser.certificateTrainingNameOtherChina;
            _this.edituser.certificateTrainingDescription =
              _this.edituser.certificateTrainingDescriptionChina;
          }
          // prj code
          _this.edituser.certificateStartDate_PR_1 =
            response.data.certificateStartDate_PR_1;
          _this.edituser.certificateStartDate_PR_2 =
            response.data.certificateStartDate_PR_2;
          _this.edituser.certificateStartDate_PR_3 =
            response.data.certificateStartDate_PR_3;
          _this.edituser.certificateStartDate_TH_1 =
            response.data.certificateStartDate_TH_1;
          _this.edituser.certificateStartDate_TH_2 =
            response.data.certificateStartDate_TH_2;
          _this.edituser.certificateStartDate_TH_3 =
            response.data.certificateStartDate_TH_3;

          _this.edituser.certificateEndDate_PR_1 =
            response.data.certificateEndDate_PR_1;
          _this.edituser.certificateEndDate_PR_2 =
            response.data.certificateEndDate_PR_2;
          _this.edituser.certificateEndDate_PR_3 =
            response.data.certificateEndDate_PR_3;
          _this.edituser.certificateEndDate_TH_1 =
            response.data.certificateEndDate_TH_1;
          _this.edituser.certificateEndDate_TH_2 =
            response.data.certificateEndDate_TH_2;
          _this.edituser.certificateEndDate_TH_3 =
            response.data.certificateEndDate_TH_3;

          _this.edituser.certificateTrainer2_PR_1 =
            response.data.certificateTrainer2_PR_1;
          _this.edituser.certificateTrainer2_PR_2 =
            response.data.certificateTrainer2_PR_2;
          _this.edituser.certificateTrainer2_PR_3 =
            response.data.certificateTrainer2_PR_3;
          _this.edituser.certificateTrainer2_TH_1 =
            response.data.certificateTrainer2_TH_1;
          _this.edituser.certificateTrainer2_TH_2 =
            response.data.certificateTrainer2_TH_2;
          _this.edituser.certificateTrainer2_TH_3 =
            response.data.certificateTrainer2_TH_3;

          _this.edituser.certificateTrainer_PR_1 =
            response.data.certificateTrainer_PR_1;
          _this.edituser.certificateTrainer_PR_2 =
            response.data.certificateTrainer_PR_2;
          _this.edituser.certificateTrainer_PR_3 =
            response.data.certificateTrainer_PR_3;
          _this.edituser.certificateTrainer_TH_1 =
            response.data.certificateTrainer_TH_1;
          _this.edituser.certificateTrainer_TH_2 =
            response.data.certificateTrainer_TH_2;
          _this.edituser.certificateTrainer_TH_3 =
            response.data.certificateTrainer_TH_3;

          _this.edituser.certificateEventLocation_PR_1 =
            response.data.certificateEventLocation_PR_1;
          _this.edituser.certificateEventLocation_PR_2 =
            response.data.certificateEventLocation_PR_2;
          _this.edituser.certificateEventLocation_PR_3 =
            response.data.certificateEventLocation_PR_3;
          _this.edituser.certificateEventLocation_TH_1 =
            response.data.certificateEventLocation_TH_1;
          _this.edituser.certificateEventLocation_TH_2 =
            response.data.certificateEventLocation_TH_2;
          _this.edituser.certificateEventLocation_TH_3 =
            response.data.certificateEventLocation_TH_3;

          _this.edituser.display_PR_1 = response.data.display_PR_1;
          _this.edituser.display_PR_2 = response.data.display_PR_2;
          _this.edituser.display_PR_3 = response.data.display_PR_3;
          _this.edituser.display_TH_1 = response.data.display_TH_1;
          _this.edituser.display_TH_2 = response.data.display_TH_2;
          _this.edituser.display_TH_3 = response.data.display_TH_3;

          //prj code end
          _this.fetchBookings();
        })
        .catch(this.onError)
        .finally(this.onFinally);

      this.showModal = true;
    },

    afterCloseModal() {
      setTimeout(() => {
        window.scrollTo(this.scrollPositionX, this.scrollPositionY);
      }, 1000);
      this.showModal = false;
      this.edituser = {
        firstname: null,
        lastname: null,
        personnelnumber: null,
        location: null,
        company: null,
        email: null,
        tenantId: null,
        selectedStatus: null,
        certificateStartDate: null,
        certificateEndDate: null,
        certificateEventLocation: null,
        certificateEventNumber: null,
        certificateTrainer: null,
        certificateTrainer2: null,
        certificateStartDateOther: null,
        certificateEndDateOther: null,
        eventStatus: null,
        eventStatusOther: null,
        display: false,
        certificateEventLocationOther: null,
        certificateTrainerOther: null,
        certificateTrainer2Other: null,
        certificateTrainingNameEnglish: null,
        certificateTrainingNameGerman: null,
        certificateTrainingNamePolish: null,
        certificateTrainingNameFrench: null,
        certificateTrainingNameHungarian: null,
        certificateTrainingNameSpanish: null,
        certificateTrainingNameRussian: null,
        certificateTrainingNameKazak: null,
        certificateTrainingNameItalian: null,
        certificateTrainingNameChina: null,
        certificateTrainingNameOtherEnglish: null,
        certificateTrainingNameOtherGerman: null,
        certificateTrainingNameOtherPolish: null,
        certificateTrainingNameOtherFrench: null,
        certificateTrainingNameOtherHungarian: null,
        certificateTrainingNameOtherSpanish: null,
        certificateTrainingNameOtherRussian: null,
        certificateTrainingNameOtherKazak: null,
        certificateTrainingNameOtherItalian: null,
        certificateTrainingNameOtherChina: null,
        certificateTrainingName: null,
        certificateTrainingNameOther: null,
        certificateTrainingDescription: null,
        certificateTrainingDescriptionEnglish: null,
        certificateTrainingDescriptionGerman: null,
        certificateTrainingDescriptionPolish: null,
        certificateTrainingDescriptionFrench: null,
        certificateTrainingDescriptionHungarian: null,
        certificateTrainingDescriptionSpanish: null,
        certificateTrainingDescriptionRussian: null,
        certificateTrainingDescriptionKazak: null,
        certificateTrainingDescriptionItalian: null,
        certificateTrainingDescriptionChina: null,

        certificateEventTrainingCategoryNameEnglish: null,
        certificateEventTrainingCategoryNameGerman: null,
        certificateEventTrainingCategoryNamePolish: null,
        certificateEventTrainingCategoryNameFrench: null,
        certificateEventTrainingCategoryNameHungarian: null,
        certificateEventTrainingCategoryNameSpanish: null,
        certificateEventTrainingCategoryNameRussian: null,
        certificateEventTrainingCategoryNameKazak: null,
        certificateEventTrainingCategoryNameItalian: null,
        certificateEventTrainingCategoryNameChina: null,
        certificateEventTrainingCategoryNameOtherEnglish: null,
        certificateEventTrainingCategoryNameOtherGerman: null,
        certificateEventTrainingCategoryNameOtherPolish: null,
        certificateEventTrainingCategoryNameOtherFrench: null,
        certificateEventTrainingCategoryNameOtherHungarian: null,
        certificateEventTrainingCategoryNameOtherSpanish: null,
        certificateEventTrainingCategoryNameOtherRussian: null,
        certificateEventTrainingCategoryNameOtherKazak: null,
        certificateEventTrainingCategoryNameOtherItalian: null,
        certificateEventTrainingCategoryNameOtherChina: null,
        certificateEventTrainingCategoryName: null,
        certificateEventTrainingCategoryNameOther: null,
        certificateEventTrainingCategoryDescription: null,
        certificateEventTrainingCategoryDescriptionEnglish: null,
        certificateEventTrainingCategoryDescriptionGerman: null,
        certificateEventTrainingCategoryDescriptionPolish: null,
        certificateEventTrainingCategoryDescriptionFrench: null,
        certificateEventTrainingCategoryDescriptionHungarian: null,
        certificateEventTrainingCategoryDescriptionSpanish: null,
        certificateEventTrainingCategoryDescriptionRussian: null,
        certificateTrainingDescriptionKazak: null,
        certificateTrainingDescriptionItalian: null,
        certificateTrainingDescriptionChina: null,
      };
    },
    participants_previousPage() {
      this.participants_page = this.participants_page - 1;
      this.fetchTrainingEvents();
    },
    participants_nextPage() {
      this.participants_page = this.participants_page + 1;
      this.fetchTrainingEvents();
    },
    users_previousPage() {
      this.users_page = this.users_page - 1;
      this.fetchTrainingEvents();
    },
    users_nextPage() {
      this.users_page = this.users_page + 1;
      this.fetchTrainingEvents();
    },

    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.editingIndex = index;
      } else {
        this.editing = null;
        this.editingIndex = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    onError(err) {
      console.log(err);
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },

    fetchEditingTrainingEvent() {
      var _this = this;
      _this.seatOccupied = 0;
      _this.seatTenant = null;
      _this.seatNumber = null;
      _this.seatShare = [];
      _this.seatShareCustomers = [];
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/training/event/" + this.trainingEventId)
        .then(function (response) {
          _this.trainingEvent = response.data;
          if (response.data.salesListId) {
            _this.salesListId = response.data.salesListId;
            _this.getSalesList();
          } else {
            _this.fetchTrainers();
          }
          if (response.data.comment !== null) {
            _this.characterCountComments = response.data.comment.length;
          }

          _this.trainingEvent.trainingId =
            _this.trainingEvent.training != null
              ? _this.trainingEvent.training.id
              : null;
          _this.trainingEvent.eventTrainingCategoryId =
            _this.trainingEvent.trainingEventCategory != null
              ? _this.trainingEvent.trainingEventCategory.id
              : null;
          _this.trainingEvent.trainerId =
            _this.trainingEvent.trainer != null
              ? typeof _this.trainingEvent.trainer == "number"
                ? _this.trainingEvent.trainer
                : _this.trainingEvent.trainer.id
              : null;
          delete _this.trainingEvent.trainer;
          _this.trainingEvent.trainer2Id =
            _this.trainingEvent.trainer2 != null
              ? typeof _this.trainingEvent.trainer2 == "number"
                ? _this.trainingEvent.trainer2
                : _this.trainingEvent.trainer2.id
              : null;
          delete _this.trainingEvent.trainer2;
          _this.trainingEvent.translatorId =
            _this.trainingEvent.translator != null
              ? _this.trainingEvent.translator
              : null;
          delete _this.trainingEvent.translator;
          _this.trainingEvent.roomId =
            _this.trainingEvent.room != null
              ? parseInt(_this.trainingEvent.room.id)
              : null;
          _this.trainingEvent.selectedLocationId =
            _this.trainingEvent.room != null &&
            _this.trainingEvent.room.location != null
              ? _this.trainingEvent.room.location.id
              : null;
          if (_this.trainingEvent.selectedLocationId) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId,
              true,
              "rooms",
              "trainingEvent.roomId"
            );
          }
          delete _this.trainingEvent.room;
          _this.trainingEvent.customerId =
            _this.trainingEvent.customerBooking != null
              ? _this.trainingEvent.customerBooking.id
              : null;
          let tenantsShared = [];
          if (
            _this.trainingEvent.seatShare != null &&
            _this.trainingEvent.seatShare.length > 0
          ) {
            for (let i = 0; i < _this.trainingEvent.seatShare.length; i++) {
              _this.seatShare.push({
                tenant: _this.trainingEvent.seatShare[i].tenant,
                seatAlloted: parseInt(
                  _this.trainingEvent.seatShare[i].seatAlloted
                ),
                company: _this.trainingEvent.seatShare[i].company,
              });
              tenantsShared.push(_this.trainingEvent.seatShare[i].tenant.id);
            }
          }
          if (_this.trainingEvent.customerId !== null) {
            _this.customers.forEach((customer) => {
              if (
                customer.id !== _this.trainingEvent.customerId &&
                !tenantsShared.includes(customer.id)
              ) {
                _this.seatShareCustomers.push(customer);
              }
            });
          } else {
            _this.seatShareCustomers = _this.customers;
          }

          delete _this.trainingEvent.customerBooking;

          // Issue #95: Don't show Seconds in Start and End Time of Training Event Editing
          if (
            _this.trainingEvent.startTime &&
            _this.trainingEvent.startTime.length > 5
          ) {
            _this.trainingEvent.startTime =
              _this.trainingEvent.startTime.substring(0, 5);
          }
          if (
            _this.trainingEvent.endTime &&
            _this.trainingEvent.endTime.length > 5
          ) {
            _this.trainingEvent.endTime = _this.trainingEvent.endTime.substring(
              0,
              5
            );
          }

          // prj_code

          _this.trainingEvent.trainerId_PR_1 =
            _this.trainingEvent.trainerId_PR_1 != null
              ? _this.trainingEvent.trainerId_PR_1
              : null;
          _this.trainingEvent.trainerId_PR_2 =
            _this.trainingEvent.trainerId_PR_2 != null
              ? _this.trainingEvent.trainerId_PR_2
              : null;
          _this.trainingEvent.trainerId_PR_3 =
            _this.trainingEvent.trainerId_PR_3 != null
              ? _this.trainingEvent.trainerId_PR_3
              : null;
          _this.trainingEvent.trainerId_TH_1 =
            _this.trainingEvent.trainerId_TH_1 != null
              ? _this.trainingEvent.trainerId_TH_1
              : null;
          _this.trainingEvent.trainerId_TH_2 =
            _this.trainingEvent.trainerId_TH_2 != null
              ? _this.trainingEvent.trainerId_TH_2
              : null;
          _this.trainingEvent.trainerId_TH_3 =
            _this.trainingEvent.trainerId_TH_3 != null
              ? _this.trainingEvent.trainerId_TH_3
              : null;

          _this.trainingEvent.trainerId2_PR_1 =
            _this.trainingEvent.trainerId2_PR_1 != null
              ? _this.trainingEvent.trainerId2_PR_1
              : null;
          _this.trainingEvent.trainerId2_PR_2 =
            _this.trainingEvent.trainerId2_PR_2 != null
              ? _this.trainingEvent.trainerId2_PR_2
              : null;
          _this.trainingEvent.trainerId2_PR_3 =
            _this.trainingEvent.trainerId2_PR_3 != null
              ? _this.trainingEvent.trainerId2_PR_3
              : null;
          _this.trainingEvent.trainerId2_TH_1 =
            _this.trainingEvent.trainerId2_TH_1 != null
              ? _this.trainingEvent.trainerId2_TH_1
              : null;
          _this.trainingEvent.trainerId2_TH_2 =
            _this.trainingEvent.trainerId2_TH_2 != null
              ? _this.trainingEvent.trainerId2_TH_2
              : null;
          _this.trainingEvent.trainerId2_TH_3 =
            _this.trainingEvent.trainerId2_TH_3 != null
              ? _this.trainingEvent.trainerId2_TH_3
              : null;

          _this.trainingEvent.translatorId_PR_1 =
            _this.trainingEvent.translatorId_PR_1 != null
              ? _this.trainingEvent.translatorId_PR_1
              : null;
          _this.trainingEvent.translatorId_PR_2 =
            _this.trainingEvent.translatorId_PR_2 != null
              ? _this.trainingEvent.translatorId_PR_2
              : null;
          _this.trainingEvent.translatorId_PR_3 =
            _this.trainingEvent.translatorId_PR_3 != null
              ? _this.trainingEvent.translatorId_PR_3
              : null;
          _this.trainingEvent.translatorId_TH_1 =
            _this.trainingEvent.translatorId_TH_1 != null
              ? _this.trainingEvent.translatorId_TH_1
              : null;
          _this.trainingEvent.translatorId_TH_2 =
            _this.trainingEvent.translatorId_TH_2 != null
              ? _this.trainingEvent.translatorId_TH_2
              : null;
          _this.trainingEvent.translatorId_TH_3 =
            _this.trainingEvent.translatorId_TH_3 != null
              ? _this.trainingEvent.translatorId_TH_3
              : null;

          if (response.data.startDate) {
            _this.PR_ST = true;
          } else {
            _this.PR_ST = false;
          }

          if (response.data.startDate_PR_1) {
            _this.PR_1 = true;
          } else {
            _this.PR_1 = false;
          }
          if (response.data.startDate_PR_2) {
            _this.PR_2 = true;
          } else {
            _this.PR_2 = false;
          }
          if (response.data.startDate_PR_3) {
            _this.PR_3 = true;
          } else {
            _this.PR_3 = false;
          }
          if (response.data.startDate_TH_1) {
            _this.TH_1 = true;
          }
          if (response.data.startDate_TH_2) {
            _this.TH_2 = true;
          } else {
            _this.TH_2 = false;
          }
          if (response.data.startDate_TH_3) {
            _this.TH_3 = true;
          } else {
            _this.TH_3 = false;
          }
          //end
          _this.trainingEvent.selectedLocationId_PR_1 =
            _this.trainingEvent.roomId_PR_1 != null &&
            _this.trainingEvent.roomId_PR_1.location != null &&
            typeof _this.trainingEvent.roomId_PR_1.location == "object"
              ? parseInt(_this.trainingEvent.roomId_PR_1.location.id)
              : _this.trainingEvent.roomId_PR_1 != null &&
                _this.trainingEvent.roomId_PR_1.location != null
              ? _this.trainingEvent.roomId_PR_1.location
              : null;
          _this.trainingEvent.selectedLocationId_PR_2 =
            _this.trainingEvent.roomId_PR_2 != null &&
            _this.trainingEvent.roomId_PR_2.location != null &&
            typeof _this.trainingEvent.roomId_PR_2.location == "object"
              ? parseInt(_this.trainingEvent.roomId_PR_2.location.id)
              : _this.trainingEvent.roomId_PR_2 != null &&
                _this.trainingEvent.roomId_PR_2.location != null
              ? _this.trainingEvent.roomId_PR_2.location
              : null;
          _this.trainingEvent.selectedLocationId_PR_3 =
            _this.trainingEvent.roomId_PR_3 != null &&
            _this.trainingEvent.roomId_PR_3.location != null &&
            typeof _this.trainingEvent.roomId_PR_3.location == "object"
              ? parseInt(_this.trainingEvent.roomId_PR_3.location.id)
              : _this.trainingEvent.roomId_PR_3 != null &&
                _this.trainingEvent.roomId_PR_3.location != null
              ? _this.trainingEvent.roomId_PR_3.location
              : null;
          _this.trainingEvent.selectedLocationId_TH_1 =
            _this.trainingEvent.roomId_TH_1 != null &&
            _this.trainingEvent.roomId_TH_1.location != null &&
            typeof _this.trainingEvent.roomId_TH_1.location == "object"
              ? parseInt(_this.trainingEvent.roomId_TH_1.location.id)
              : _this.trainingEvent.roomId_TH_1 != null &&
                _this.trainingEvent.roomId_TH_1.location != null
              ? _this.trainingEvent.roomId_TH_1.location
              : null;
          _this.trainingEvent.selectedLocationId_TH_2 =
            _this.trainingEvent.roomId_TH_2 != null &&
            _this.trainingEvent.roomId_TH_2.location != null &&
            typeof _this.trainingEvent.roomId_TH_2.location == "object"
              ? parseInt(_this.trainingEvent.roomId_TH_2.location.id)
              : _this.trainingEvent.roomId_TH_2 != null &&
                _this.trainingEvent.roomId_TH_2.location != null
              ? _this.trainingEvent.roomId_TH_2.location
              : null;
          _this.trainingEvent.selectedLocationId_TH_3 =
            _this.trainingEvent.roomId_TH_3 != null &&
            _this.trainingEvent.roomId_TH_3.location != null &&
            typeof _this.trainingEvent.roomId_TH_3.location == "object"
              ? parseInt(_this.trainingEvent.roomId_TH_3.location.id)
              : _this.trainingEvent.roomId_TH_3 != null &&
                _this.trainingEvent.roomId_TH_3.location != null
              ? _this.trainingEvent.roomId_TH_3.location
              : null;
          if (_this.trainingEvent.selectedLocationId_PR_1) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_PR_1,
              true,
              "rooms_PR_1",
              "trainingEvent.roomId_PR_1"
            );
          }
          if (_this.trainingEvent.selectedLocationId_PR_2) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_PR_2,
              true,
              "rooms_PR_2",
              "trainingEvent.roomId_PR_2"
            );
          }
          if (_this.trainingEvent.selectedLocationId_PR_3) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_PR_3,
              true,
              "rooms_PR_3",
              "trainingEvent.roomId_PR_3"
            );
          }
          if (_this.trainingEvent.selectedLocationId_TH_1) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_TH_1,
              true,
              "rooms_TH_1",
              "trainingEvent.roomId_TH_1"
            );
          }
          if (_this.trainingEvent.selectedLocationId_TH_2) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_TH_2,
              true,
              "rooms_TH_2",
              "trainingEvent.roomId_TH_2"
            );
          }
          if (_this.trainingEvent.selectedLocationId_TH_3) {
            _this.fetchRooms(
              _this.trainingEvent.selectedLocationId_TH_3,
              true,
              "rooms_TH_3",
              "trainingEvent.roomId_TH_3"
            );
          }

          _this.trainingEvent.roomId_PR_1 =
            _this.trainingEvent.roomId_PR_1 != null
              ? parseInt(_this.trainingEvent.roomId_PR_1.id)
              : null;
          _this.trainingEvent.roomId_PR_2 =
            _this.trainingEvent.roomId_PR_2 != null
              ? parseInt(_this.trainingEvent.roomId_PR_2.id)
              : null;
          _this.trainingEvent.roomId_PR_3 =
            _this.trainingEvent.roomId_PR_3 != null
              ? parseInt(_this.trainingEvent.roomId_PR_3.id)
              : null;
          _this.trainingEvent.roomId_TH_1 =
            _this.trainingEvent.roomId_TH_1 != null
              ? parseInt(_this.trainingEvent.roomId_TH_1.id)
              : null;
          _this.trainingEvent.roomId_TH_2 =
            _this.trainingEvent.roomId_TH_2 != null
              ? parseInt(_this.trainingEvent.roomId_TH_2.id)
              : null;
          _this.trainingEvent.roomId_TH_3 =
            _this.trainingEvent.roomId_TH_3 != null
              ? parseInt(_this.trainingEvent.roomId_TH_3.id)
              : null;

          if (
            _this.trainingEvent.startTime_PR_1 &&
            _this.trainingEvent.startTime_PR_1.length > 5
          ) {
            _this.trainingEvent.startTime_PR_1 =
              _this.trainingEvent.startTime_PR_1.substring(0, 5);
          }

          if (
            _this.trainingEvent.startTime_PR_2 &&
            _this.trainingEvent.startTime_PR_2.length > 5
          ) {
            _this.trainingEvent.startTime_PR_2 =
              _this.trainingEvent.startTime_PR_2.substring(0, 5);
          }

          if (
            _this.trainingEvent.startTime_PR_3 &&
            _this.trainingEvent.startTime_PR_3.length > 5
          ) {
            _this.trainingEvent.startTime_PR_3 =
              _this.trainingEvent.startTime_PR_3.substring(0, 5);
          }

          if (
            _this.trainingEvent.startTime_TH_1 &&
            _this.trainingEvent.startTime_TH_1.length > 5
          ) {
            _this.trainingEvent.startTime_TH_1 =
              _this.trainingEvent.startTime_TH_1.substring(0, 5);
          }

          if (
            _this.trainingEvent.startTime_TH_2 &&
            _this.trainingEvent.startTime_TH_2.length > 5
          ) {
            _this.trainingEvent.startTime_TH_2 =
              _this.trainingEvent.startTime_TH_2.substring(0, 5);
          }

          if (
            _this.trainingEvent.startTime_TH_3 &&
            _this.trainingEvent.startTime_TH_3.length > 5
          ) {
            _this.trainingEvent.startTime_TH_3 =
              _this.trainingEvent.startTime_TH_3.substring(0, 5);
          }

          if (
            _this.trainingEvent.endTime_PR_1 &&
            _this.trainingEvent.endTime_PR_1.length > 5
          ) {
            _this.trainingEvent.endTime_PR_1 =
              _this.trainingEvent.endTime_PR_1.substring(0, 5);
          }
          if (
            _this.trainingEvent.endTime_PR_2 &&
            _this.trainingEvent.endTime_PR_2.length > 5
          ) {
            _this.trainingEvent.endTime_PR_2 =
              _this.trainingEvent.endTime_PR_2.substring(0, 5);
          }
          if (
            _this.trainingEvent.endTime_PR_3 &&
            _this.trainingEvent.endTime_PR_3.length > 5
          ) {
            _this.trainingEvent.endTime_PR_3 =
              _this.trainingEvent.endTime_PR_3.substring(0, 5);
          }

          if (
            _this.trainingEvent.endTime_TH_1 &&
            _this.trainingEvent.endTime_TH_1.length > 5
          ) {
            _this.trainingEvent.endTime_TH_1 =
              _this.trainingEvent.endTime_TH_1.substring(0, 5);
          }

          if (
            _this.trainingEvent.endTime_TH_2 &&
            _this.trainingEvent.endTime_TH_2.length > 5
          ) {
            _this.trainingEvent.endTime_TH_2 =
              _this.trainingEvent.endTime_TH_2.substring(0, 5);
          }

          if (
            _this.trainingEvent.endTime_TH_3 &&
            _this.trainingEvent.endTime_TH_3.length > 5
          ) {
            _this.trainingEvent.endTime_TH_3 =
              _this.trainingEvent.endTime_TH_3.substring(0, 5);
          }

          //_this.fetchRooms();
          _this.fetchBookings();
          _this.fetchUsers();

          if (_this.trainingEvent.eventTrainingCategoryId) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.trainingEvent, "trainingId", null);
          }
          if (_this.trainingEvent.trainingId) {
            _this.trainingCategoryDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.trainingEvent, "eventTrainingCategoryId", null);
          }
          // code for draft events and cancel events date show if not added

          if (
            _this.trainingEvent.eventflag == "2" ||
            _this.trainingEvent.eventflag == "1"
          ) {
            if (
              _this.trainingEvent.examType == "ORAL" ||
              _this.trainingEvent.examType == "THEORETICAL" ||
              _this.trainingEvent.examType == "ORAL_AND_THEORETICAL"
            ) {
              _this.PR_ST = true;
            } else {
              _this.PR_ST = false;
            }

            if (_this.trainingEvent.examType == "ORAL_ORAL_AND_THEORETICAL") {
              _this.PR_1 = true;
              _this.PR_2 = true;
              _this.TH_1 = true;
            }

            if (_this.trainingEvent.examType == "ORAL_ORAL_AND_ORAL") {
              _this.PR_1 = true;
              _this.PR_2 = true;
              _this.PR_3 = true;
            }

            if (
              _this.trainingEvent.examType == "THEORETICAL_THEORETICAL_AND_ORAL"
            ) {
              _this.PR_1 = true;
              _this.TH_1 = true;
              _this.TH_2 = true;
            }

            if (
              _this.trainingEvent.examType ==
              "THEORETICAL_THEORETICAL_AND_THEROTICAL"
            ) {
              _this.TH_3 = true;
              _this.TH_1 = true;
              _this.TH_2 = true;
            }

            if (_this.trainingEvent.examType == "THEORETICAL_THEORETICAL") {
              _this.TH_1 = true;
              _this.TH_2 = true;
            }

            if (_this.trainingEvent.examType == "ORAL_ORAL") {
              _this.PR_1 = true;
              _this.PR_2 = true;
            }
          }
          let language = _this.$locale;

          _this.trainingEvent.onlinelink_PR_1 =
            _this.trainingEvent.onlinelink_PR_1 != null
              ? _this.trainingEvent.onlinelink_PR_1
              : null;
          _this.trainingEvent.onlinelink_PR_2 =
            _this.trainingEvent.onlinelink_PR_2 != null
              ? _this.trainingEvent.onlinelink_PR_2
              : null;
          _this.trainingEvent.onlinelink_PR_3 =
            _this.trainingEvent.onlinelink_PR_3 != null
              ? _this.trainingEvent.onlinelink_PR_3
              : null;

          _this.trainingEvent.onlinelink_TH_1 =
            _this.trainingEvent.onlinelink_TH_1 != null
              ? _this.trainingEvent.onlinelink_TH_1
              : null;
          _this.trainingEvent.onlinelink_TH_2 =
            _this.trainingEvent.onlinelink_TH_2 != null
              ? _this.trainingEvent.onlinelink_TH_2
              : null;
          _this.trainingEvent.onlinelink_TH_3 =
            _this.trainingEvent.onlinelink_TH_3 != null
              ? _this.trainingEvent.onlinelink_TH_3
              : null;

          if (_this.trainingEvent.documentChangeMsg) {
            _this.documentChangeDisplay = true;
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchTrainingRequest() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/training/request/" + this.trainingRequestId)
        .then(function (response) {
          _this.trainingEvent.customerNumber = response.data.customerNumber;
          _this.trainingEvent.vehicleType = response.data.vehicle;
          _this.$set(
            _this.trainingEvent,
            "trainingId",
            response.data.training != null ? response.data.training.id : null
          );
          _this.$set(
            _this.trainingEvent,
            "eventTrainingCategoryId",
            response.data.eventCategory != null
              ? response.data.eventCategory.id
              : null
          );
          _this.trainingEvent.minParticipants = 1;
          _this.trainingEvent.maxParticipants =
            response.data.participantsAmount;
          _this.trainingEvent.language = response.data.language;
          if (response.data.trainers) {
            _this.trainers = response.data.trainers;
          } else {
            this.fetchTrainers();
          }
          _this.fetchCustomers();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    getSalesList() {
      if (this.$route.query.salesListId != null) {
        this.salesListId = parseInt(this.$route.query.salesListId);
      }
      var _this = this;
      this.$axios
        .get("/api/saleslist/" + this.salesListId)
        .then(function (response) {
          _this.trainingEvent.trainingRequestId = response.data.trainingRequest;
          _this.trainingEvent.eventNumber = response.data.eventNumber;
          if (
            response.data.internalDocuments &&
            _this.trainingEvent.internalDocuments.length == 0
          ) {
            _this.trainingEvent.internalDocuments =
              response.data.internalDocuments;
          }
          _this.trainingEvent.trainingId =
            response.data.trainingSales != null
              ? response.data.trainingSales.id
              : null;
          _this.trainingEvent.eventTrainingCategoryId =
            response.data.eventTrainingCategory != null
              ? response.data.eventTrainingCategory.id
              : null;

          if (
            response.data.vehicleType != null &&
            _this.trainingEvent.vehicleType == null
          ) {
            _this.trainingEvent.vehicleType = response.data.vehicleType;
          }

          _this.trainingEvent.serviceOrderNumber =
            response.data.serviceOrder != null
              ? response.data.serviceOrder
              : null;
          if (response.data.projectText) {
            _this.trainingEvent.project =
              response.data.projectText != null
                ? response.data.projectText
                : null;
          }

          if (response.data.project) {
            _this.trainingEvent.project =
              response.data.project != null
                ? response.data.project.designations["en"]
                : null;
          }
          _this.trainingDisabled = true;
          _this.trainingCategoryDisabled = true;

          _this.disableEventNumber = true;

          _this.trainingEvent.customerNumber = response.data.customer;

          if (_this.trainingEvent.eventTrainingCategoryId) {
            _this.showCategory = true;
            _this.$set(_this.trainingEvent, "trainingId", null);
          } else if (_this.trainingEvent.trainingId) {
            _this.showCategory = false;
            _this.$set(_this.trainingEvent, "eventTrainingCategoryId", null);
          }
          if (response.data.remarks && !_this.trainingEvent.comment) {
            _this.characterCountComments = response.data.remarks.length;
            _this.trainingEvent.comment = response.data.remarks;
          }

          _this.fetchTrainers();

          _this.fetchCustomers();
        })
        .catch(this.onError);
    },

    fetchTrainings() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/training/trainings")
        .then(function (response) {
          let trainings = response.data;

          if (trainings.length > 0) {
            trainings = trainings.filter((training) => {
              const designationMap = training.designationsMap;
              const localeDesignation = designationMap?.[_this.$locale];
              // Keep only if both designationsMap and locale-specific designation exist and are non-null
              return designationMap && localeDesignation;
            });
          }

          for (let i = 0; i < trainings.length; i++) {
            const training = trainings[i];
            if (training.trainingflag == "1") {
              training.text =
                training.designationsMap[_this.$locale] + _this.$t("archived");
            } else if (
              training.designationsMap &&
              training.designationsMap[_this.$locale]
            ) {
              training.text = training.designationsMap[_this.$locale];
            }
          }
          for (let index = 0; index < trainings.length; index++) {
            const training = trainings[index];
            if (training.designationsMap[_this.$locale]) {
              _this.trainings.push(training);
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
      this.$axios
        .get("/api/eventTrainingCategory")
        .then(function (response) {
          _this.trainingEventCategories = response.data.content;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    fetchTrainers() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/trainer")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleTrainerAndPush(element);
            } else {
              _this.trainers.push(element);
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSingleTrainerAndPush(trainerId) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/" + trainerId)
        .then(function (response) {
          const element = response.data;
          _this.trainers.push(element);
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    async fetchTrainersTrainingRequest() {
      var _this = this;
      this.fetchEditingTrainingRequest();
    },
    fetchEditingTrainingRequest() {
      var _this = this;
      this.$axios
        .get("/api/training/request/" + _this.trainingEvent.trainingRequestId)
        .then(function (response) {
          if (response.data.trainers != null) {
            for (let i = 0; i < response.data.trainers.length; i++) {
              if (response.data.trainers[i] && response.data.trainers[i].id) {
                _this.trainers.push(response.data.trainers[i]);
              }
            }
          } else {
            _this.fetchTrainers();
          }
        })
        .catch(this.onError); // Moved `.catch` to the correct position
    },

    fetchSingleTrainerAndPush(trainerId) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/" + trainerId)
        .then(function (response) {
          const element = response.data;
          _this.trainers.push(element);
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchCustomers() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/tenant/customers/all")
        .then(function (response) {
          _this.customers = response.data;
          if (_this.$external && _this.customers.length == 1) {
            _this.trainingEvent.customerId = _this.customers[0].id;
          }
          if (_this.trainingEvent.customerNumber != null) {
            for (var i = 0; i < _this.customers.length; i++) {
              if (_this.customers[i].debitor) {
                if (
                  _this.trainingEvent.customerNumber.trim().toLowerCase() ==
                  _this.customers[i].debitor.trim().toLowerCase()
                ) {
                  _this.trainingEvent.customerId = _this.customers[i].id;
                }
              }
              if (
                _this.trainingEvent.customerNumber.trim().toLowerCase() ==
                  _this.customers[i].name.trim().toLowerCase() &&
                !_this.trainingEvent.customerId
              ) {
                _this.trainingEvent.customerId = _this.customers[i].id;
              }
            }
            //if( _this.trainingEvent.customerId)
            // {
            //    _this.customerDisabled = true;
            //}
          }
          _this.seatShareCustomers = _this.customers;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchTranslators() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/translator")
        .then(function (response) {
          _this.translators = response.data;
          for (let i = 0; i < _this.translators.length; i++) {
            const translator = _this.translators[i];
            for (let p = 0; p < translator.languages.length; p++) {
              const language = translator.languages[p];
              translator.languages[p] = _this.$languages[language];
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchBookings() {
      if (!this.$rights.includes("VIEW_BOOKINGS")) {
        return;
      }
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/booking/event/" + this.trainingEvent.id, {
          params: {
            search: _this.participants_search,
            sort: _this.participants_sort,
            order: _this.participants_order ? "ASC" : "DESC",
            page: _this.participants_page - 1,
            size: _this.participants_ElementPerPage,
          },
        })
        .then(function (response) {
          _this.bookings = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchBookingsEdit() {
      if (!this.$rights.includes("VIEW_BOOKINGS")) {
        return;
      }
      var _this = this;
      progressIndicator.hidden = false;
      this.$axios
        .get("/api/booking/event/" + this.trainingEvent.id, {
          params: {
            search: _this.participants_search,
            sort: _this.participants_sort,
            order: _this.participants_order ? "ASC" : "DESC",
            page: _this.participants_page - 1,
            size: _this.participants_ElementPerPage,
          },
        })
        .then(function (response) {
          _this.bookings = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchLocations() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/location/fetchAllLocations")
        .then(function (response) {
          _this.locations = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchUsers() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/external", {
          params: {
            search: _this.users_search,
            sort: _this.users_sort,
            order: _this.users_order ? "ASC" : "DESC",
            page: _this.users_page - 1,
            size: _this.users_ElementPerPage,
          },
        })
        .then(function (response) {
          _this.users = response.data.content;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchRooms(value, clearCurrentRoom = false, rowDataKey, clearId) {
      var _this = this;
      if (value == null) return;
      if (clearCurrentRoom) _this.$set(_this, clearId, null);
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/room/location/id/" + value)
        .then(function (response) {
          //rowData = response.data.content;
          // Ensure Vue's reactivity
          _this.$set(_this, rowDataKey, response.data.content);
          _this[rowDataKey] = [...response.data.content];
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    saveTrainingEvent() {
      var _this = this;
      this.trainingEvent.rooms = this.rooms;
      var trainingEvent = {};
      //trainingEvent = Object.assign(trainingEvent, this.trainingEvent);
      let eventFlagCode =
        _this.eventStatus === "cancelled"
          ? "1"
          : _this.eventStatus === "drafted"
          ? "2"
          : "0";
      let updatedTrainingEvent = Object.assign({}, _this.trainingEvent, {
        eventflag: eventFlagCode,
      });
      trainingEvent = Object.assign(trainingEvent, updatedTrainingEvent);

      if (this.salesListId) {
        trainingEvent.salesListId = this.salesListId;
      }

      if (trainingEvent && trainingEvent.tenant && trainingEvent.tenant.id) {
        let tenantId = trainingEvent.tenant.id;

        // Creating a new object with only the 'id' property
        let tenantObject = { id: tenantId };
        trainingEvent.tenant = tenantObject;
      }
      trainingEvent.trainingEventCategory = null;
      trainingEvent.rooms = null;

      trainingEvent.bookings = [];

      if (eventFlagCode === "0" || eventFlagCode === "1") {
        if (this.$isStringEmptyOrNull(trainingEvent.eventNumber)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("eventNumber") })
          );
          return;
        }

        if (!trainingEvent.examType) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("examType") })
          );
          return;
        }
        if (this.$isStringEmptyOrNull(trainingEvent.language)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("language") })
          );
          return;
        }
        if (trainingEvent.eventNumber !== null) {
          trainingEvent.eventNumber = trainingEvent.eventNumber.trim();
        }
        // Validation for empty fields
        if (this.PR_ST) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.endDate)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (!trainingEvent.trainerId) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime ||
            !this.isValidTime(trainingEvent.startTime) ||
            !trainingEvent.startTime.includes(":") ||
            isNaN(trainingEvent.startTime.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (
            !trainingEvent.endTime ||
            !this.isValidTime(trainingEvent.endTime) ||
            !trainingEvent.endTime.includes(":") ||
            isNaN(trainingEvent.endTime.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate) > new Date(trainingEvent.endDate)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId != null &&
            (trainingEvent.roomId == null || trainingEvent.roomId == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlineLink == null ||
              trainingEvent.onlineLink == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_1) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_1) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_1 ||
            !this.isValidTime(trainingEvent.startTime_PR_1) ||
            !trainingEvent.startTime_PR_1.includes(":") ||
            isNaN(trainingEvent.startTime_PR_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_1 ||
            !this.isValidTime(trainingEvent.endTime_PR_1) ||
            !trainingEvent.endTime_PR_1.includes(":") ||
            isNaN(trainingEvent.endTime_PR_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_PR_1) >
            new Date(trainingEvent.endDate_PR_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_pr1") })
            );
            return false;
          }

          // new added

          if (
            trainingEvent.selectedLocationId_PR_1 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_1 != null &&
            (trainingEvent.roomId_PR_1 == null ||
              trainingEvent.roomId_PR_1 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_1 == null ||
              trainingEvent.onlinelink_PR_1 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_2) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr2") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_2) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer2") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_2 ||
            !this.isValidTime(trainingEvent.startTime_PR_2) ||
            !trainingEvent.startTime_PR_2.includes(":") ||
            isNaN(trainingEvent.startTime_PR_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_2 ||
            !this.isValidTime(trainingEvent.endTime_PR_2) ||
            !trainingEvent.endTime_PR_2.includes(":") ||
            isNaN(trainingEvent.endTime_PR_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_PR_2) >
            new Date(trainingEvent.endDate_PR_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_pr2") })
            );
            return false;
          }

          // new added
          if (
            trainingEvent.selectedLocationId_PR_2 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_2 != null &&
            (trainingEvent.roomId_PR_2 == null ||
              trainingEvent.roomId_PR_2 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_2 == null ||
              trainingEvent.onlinelink_PR_2 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_3) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr3") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_3) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer3") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_3 ||
            !this.isValidTime(trainingEvent.startTime_PR_3) ||
            !trainingEvent.startTime_PR_3.includes(":") ||
            isNaN(trainingEvent.startTime_PR_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_3 ||
            !this.isValidTime(trainingEvent.endTime_PR_3) ||
            !trainingEvent.endTime_PR_3.includes(":") ||
            isNaN(trainingEvent.endTime_PR_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_PR_3) >
            new Date(trainingEvent.endDate_PR_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_pr3") })
            );
            return false;
          }

          // new added
          if (
            trainingEvent.selectedLocationId_PR_3 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_3 != null &&
            (trainingEvent.roomId_PR_3 == null ||
              trainingEvent.roomId_PR_3 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_3 == null ||
              trainingEvent.onlinelink_PR_3 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_1) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_1) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_1 ||
            !this.isValidTime(trainingEvent.startTime_TH_1) ||
            !trainingEvent.startTime_TH_1.includes(":") ||
            isNaN(trainingEvent.startTime_TH_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_1 ||
            !this.isValidTime(trainingEvent.endTime_TH_1) ||
            !trainingEvent.endTime_TH_1.includes(":") ||
            isNaN(trainingEvent.endTime_TH_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_1) >
            new Date(trainingEvent.endDate_TH_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_th1") })
            );
            return false;
          }

          // new added
          if (
            trainingEvent.selectedLocationId_TH_1 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_1 != null &&
            (trainingEvent.roomId_TH_1 == null ||
              trainingEvent.roomId_TH_1 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_1 == null ||
              trainingEvent.onlinelink_TH_1 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_2) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th2") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_2) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_2 ||
            !this.isValidTime(trainingEvent.startTime_TH_2) ||
            !trainingEvent.startTime_TH_2.includes(":") ||
            isNaN(trainingEvent.startTime_TH_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_2 ||
            !this.isValidTime(trainingEvent.endTime_TH_2) ||
            !trainingEvent.endTime_TH_2.includes(":") ||
            isNaN(trainingEvent.endTime_TH_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_2) >
            new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            new Date(trainingEvent.startDate_TH_2) >
            new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_th2") })
            );
            return false;
          }

          // new added
          if (
            trainingEvent.selectedLocationId_TH_2 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_2 != null &&
            (trainingEvent.roomId_TH_2 == null ||
              trainingEvent.roomId_TH_2 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_2 == null ||
              trainingEvent.onlinelink_TH_2 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_3) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th3") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_3) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_3 ||
            !this.isValidTime(trainingEvent.startTime_TH_3) ||
            !trainingEvent.startTime_TH_3.includes(":") ||
            isNaN(trainingEvent.startTime_TH_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_3 ||
            !this.isValidTime(trainingEvent.endTime_TH_3) ||
            !trainingEvent.endTime_TH_3.includes(":") ||
            isNaN(trainingEvent.endTime_TH_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_3) >
            new Date(trainingEvent.endDate_TH_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date_th3") })
            );
            return false;
          }

          // new added
          if (
            trainingEvent.selectedLocationId_TH_3 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_3 != null &&
            (trainingEvent.roomId_TH_3 == null ||
              trainingEvent.roomId_TH_3 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_3 == null ||
              trainingEvent.onlinelink_TH_3 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.$isStringEmptyOrNull(trainingEvent.status)) {
          this.$noty.error(this.$t("empty_value", { name: this.$t("status") }));
          return;
        }

        if (
          !trainingEvent.trainingId &&
          !trainingEvent.eventTrainingCategoryId
        ) {
          this.$noty.error(this.$t("event_training_category_or_training"));
          return;
        }

        // if (!trainingEvent.vehicleType) {
        //   this.$noty.error(
        //     this.$t("empty_value", { name: this.$t("vehicleType") })
        //   );
        //   return;
        // }

        if (trainingEvent.trainingId !== null) {
          if (!trainingEvent.eventType) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("training_event_type") })
            );
            return;
          }
        }

        if (trainingEvent.eventTrainingCategoryId != null) {
          if (!trainingEvent.eventType) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("training_event_type") })
            );
            return;
          }
        }

        if (
          trainingEvent.minParticipants === undefined ||
          trainingEvent.minParticipants === ""
        ) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("minParticipants") })
          );
          return;
        }

        if (
          trainingEvent.maxParticipants === undefined ||
          trainingEvent.maxParticipants === ""
        ) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("maxParticipants") })
          );
          return;
        }

        if (
          this.trainingEvent.status === "CLOSED" &&
          this.trainingEvent.customerId == null
        ) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("customer") })
          );
          return;
        }

        // Try Parse Values
        try {
          if (isNaN(trainingEvent.minParticipants)) {
            trainingEvent.minParticipants = parseInt(
              trainingEvent.minParticipants
            );
          }
        } catch (error) {
          console.error(error);
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }
        try {
          if (isNaN(trainingEvent.maxParticipants)) {
            trainingEvent.maxParticipants = parseInt(
              trainingEvent.maxParticipants
            );
          }
        } catch (error) {
          console.error(error);
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }

        if (Number(trainingEvent.minParticipants) < 0) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }
        if (Number(trainingEvent.maxParticipants) < 0) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("maxParticipants") })
          );
          return;
        }

        if (
          Number(trainingEvent.minParticipants) >
          Number(trainingEvent.maxParticipants)
        ) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("maxParticipants") })
          );
          return;
        }
      }
      if (eventFlagCode === "2") {
        if (this.PR_ST) {
          if (
            trainingEvent.startTime &&
            (!this.isValidTime(trainingEvent.startTime) ||
              !trainingEvent.startTime.includes(":") ||
              isNaN(trainingEvent.startTime.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (
            trainingEvent.endTime &&
            (!this.isValidTime(trainingEvent.endTime) ||
              !trainingEvent.endTime.includes(":") ||
              isNaN(trainingEvent.endTime.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (
            trainingEvent.startDate &&
            trainingEvent.endDate &&
            new Date(trainingEvent.startDate) > new Date(trainingEvent.endDate)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_1) {
          if (
            trainingEvent.startTime_PR_1 &&
            (!this.isValidTime(trainingEvent.startTime_PR_1) ||
              !trainingEvent.startTime_PR_1.includes(":") ||
              isNaN(trainingEvent.startTime_PR_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_1 &&
            (!this.isValidTime(trainingEvent.endTime_PR_1) ||
              !trainingEvent.endTime_PR_1.includes(":") ||
              isNaN(trainingEvent.endTime_PR_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_1 &&
            trainingEvent.endDate_PR_1 &&
            new Date(trainingEvent.startDate_PR_1) >
              new Date(trainingEvent.endDate_PR_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_2) {
          if (
            trainingEvent.startTime_PR_2 &&
            (!this.isValidTime(trainingEvent.startTime_PR_2) ||
              !trainingEvent.startTime_PR_2.includes(":") ||
              isNaN(trainingEvent.startTime_PR_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_2 &&
            (!this.isValidTime(trainingEvent.endTime_PR_2) ||
              !trainingEvent.endTime_PR_2.includes(":") ||
              isNaN(trainingEvent.endTime_PR_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_2 &&
            trainingEvent.endDate_PR_2 &&
            new Date(trainingEvent.startDate_PR_2) >
              new Date(trainingEvent.endDate_PR_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_3) {
          if (
            trainingEvent.startTime_PR_3 &&
            (!this.isValidTime(trainingEvent.startTime_PR_3) ||
              !trainingEvent.startTime_PR_3.includes(":") ||
              isNaN(trainingEvent.startTime_PR_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_3 &&
            (!this.isValidTime(trainingEvent.endTime_PR_3) ||
              !trainingEvent.endTime_PR_3.includes(":") ||
              isNaN(trainingEvent.endTime_PR_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_3 &&
            trainingEvent.endDate_PR_3 &&
            new Date(trainingEvent.startDate_PR_3) >
              new Date(trainingEvent.endDate_PR_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_1) {
          if (
            trainingEvent.startTime_TH_1 &&
            (!this.isValidTime(trainingEvent.startTime_TH_1) ||
              !trainingEvent.startTime_TH_1.includes(":") ||
              isNaN(trainingEvent.startTime_TH_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_1 &&
            (!this.isValidTime(trainingEvent.endTime_TH_1) ||
              !trainingEvent.endTime_TH_1.includes(":") ||
              isNaN(trainingEvent.endTime_TH_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_1) >
            new Date(trainingEvent.endDate_TH_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_2) {
          if (
            trainingEvent.startTime_TH_2 &&
            (!this.isValidTime(trainingEvent.startTime_TH_2) ||
              !trainingEvent.startTime_TH_2.includes(":") ||
              isNaN(trainingEvent.startTime_TH_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_2 &&
            (!this.isValidTime(trainingEvent.endTime_TH_2) ||
              !trainingEvent.endTime_TH_2.includes(":") ||
              isNaN(trainingEvent.endTime_TH_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (
            trainingEvent.startDate_TH_2 &&
            trainingEvent.endDate_TH_2 &&
            new Date(trainingEvent.startDate_TH_2) >
              new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_3) {
          if (
            trainingEvent.startTime_TH_3 &&
            (!this.isValidTime(trainingEvent.startTime_TH_3) ||
              !trainingEvent.startTime_TH_3.includes(":") ||
              isNaN(trainingEvent.startTime_TH_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_3 &&
            (!this.isValidTime(trainingEvent.startTime_TH_3) ||
              !trainingEvent.endTime_TH_3.includes(":") ||
              isNaN(trainingEvent.endTime_TH_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (
            trainingEvent.startDate_TH_3 &&
            trainingEvent.endDate_TH_3 &&
            new Date(trainingEvent.startDate_TH_3) >
              new Date(trainingEvent.endDate_TH_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }
      }
      delete trainingEvent.training;

      if (
        trainingEvent.examType == "ORAL" ||
        trainingEvent.examType == "THEORETICAL" ||
        trainingEvent.examType == "ORAL_AND_THEORETICAL"
      ) {
        trainingEvent.selectedLocationId_PR_1 = null;
        trainingEvent.selectedLocationId_PR_2 = null;
        trainingEvent.selectedLocationId_PR_3 = null;
        trainingEvent.selectedLocationId_TH_1 = null;
        trainingEvent.selectedLocationId_TH_2 = null;
        trainingEvent.selectedLocationId_TH_3 = null;
        trainingEvent.startDate_PR_1 = null;
        trainingEvent.startDate_PR_2 = null;
        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_1 = null;
        trainingEvent.startDate_TH_2 = null;
        trainingEvent.startDate_TH_3 = null;
        trainingEvent.endDate_PR_1 = null;
        trainingEvent.endDate_PR_2 = null;
        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_1 = null;
        trainingEvent.endDate_TH_2 = null;
        trainingEvent.endDate_TH_3 = null;
        trainingEvent.onlinelink_PR_1 = null;
        trainingEvent.onlinelink_PR_2 = null;
        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_1 = null;
        trainingEvent.onlinelink_TH_2 = null;
        trainingEvent.onlinelink_TH_3 = null;
        trainingEvent.startTime_PR_1 = null;
        trainingEvent.startTime_PR_2 = null;
        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_1 = null;
        trainingEvent.startTime_TH_2 = null;
        trainingEvent.startTime_TH_3 = null;
        trainingEvent.endTime_PR_1 = null;
        trainingEvent.endTime_PR_2 = null;
        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_1 = null;
        trainingEvent.endTime_TH_2 = null;
        trainingEvent.endTime_TH_3 = null;
        trainingEvent.trainerId_PR_1 = null;
        trainingEvent.trainerId_PR_2 = null;
        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_1 = null;
        trainingEvent.trainerId_TH_2 = null;
        trainingEvent.trainerId_TH_3 = null;
        trainingEvent.trainerId2_PR_1 = null;
        trainingEvent.trainerId2_PR_2 = null;
        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_1 = null;
        trainingEvent.trainerId2_TH_2 = null;
        trainingEvent.trainerId2_TH_3 = null;
        trainingEvent.translatorId_PR_1 = null;
        trainingEvent.translatorId_PR_2 = null;
        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_1 = null;
        trainingEvent.translatorId_TH_2 = null;
        trainingEvent.translatorId_TH_3 = null;
        trainingEvent.roomId_PR_1 = null;
        trainingEvent.roomId_PR_2 = null;
        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_1 = null;
        trainingEvent.roomId_TH_2 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "ORAL_THEORETICAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlinelink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;
        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_PR_2 = null;
        trainingEvent.selectedLocationId_PR_3 = null;

        trainingEvent.selectedLocationId_TH_2 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_PR_2 = null;
        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_2 = null;
        trainingEvent.startDate_TH_3 = null;
        trainingEvent.endDate_PR_2 = null;
        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_2 = null;
        trainingEvent.endDate_TH_3 = null;
        trainingEvent.onlinelink_PR_2 = null;
        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_2 = null;
        trainingEvent.onlinelink_TH_3 = null;
        trainingEvent.startTime_PR_2 = null;
        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_2 = null;
        trainingEvent.startTime_TH_3 = null;
        trainingEvent.endTime_PR_2 = null;
        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_2 = null;
        trainingEvent.endTime_TH_3 = null;
        trainingEvent.trainerId_PR_2 = null;
        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_2 = null;
        trainingEvent.trainerId_TH_3 = null;
        trainingEvent.trainerId2_PR_2 = null;
        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_2 = null;
        trainingEvent.trainerId2_TH_3 = null;
        trainingEvent.translatorId_PR_2 = null;
        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_2 = null;
        trainingEvent.translatorId_TH_3 = null;
        trainingEvent.roomId_PR_2 = null;
        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_2 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "ORAL_ORAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlineLink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;
        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_PR_3 = null;
        trainingEvent.selectedLocationId_TH_1 = null;
        trainingEvent.selectedLocationId_TH_2 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_1 = null;
        trainingEvent.startDate_TH_2 = null;
        trainingEvent.startDate_TH_3 = null;

        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_1 = null;
        trainingEvent.endDate_TH_2 = null;
        trainingEvent.endDate_TH_3 = null;

        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_1 = null;
        trainingEvent.onlinelink_TH_2 = null;
        trainingEvent.onlinelink_TH_3 = null;

        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_1 = null;
        trainingEvent.startTime_TH_2 = null;
        trainingEvent.startTime_TH_3 = null;

        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_1 = null;
        trainingEvent.endTime_TH_2 = null;
        trainingEvent.endTime_TH_3 = null;

        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_1 = null;
        trainingEvent.trainerId_TH_2 = null;
        trainingEvent.trainerId_TH_3 = null;

        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_1 = null;
        trainingEvent.trainerId2_TH_2 = null;
        trainingEvent.trainerId2_TH_3 = null;

        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_1 = null;
        trainingEvent.translatorId_TH_2 = null;
        trainingEvent.translatorId_TH_3 = null;

        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_1 = null;
        trainingEvent.roomId_TH_2 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "THEORETICAL_THEORETICAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlineLink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;
        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_PR_1 = null;
        trainingEvent.selectedLocationId_PR_2 = null;
        trainingEvent.selectedLocationId_PR_3 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_PR_1 = null;
        trainingEvent.startDate_PR_2 = null;
        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_3 = null;

        trainingEvent.endDate_PR_1 = null;
        trainingEvent.endDate_PR_2 = null;
        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_3 = null;

        trainingEvent.onlinelink_PR_1 = null;
        trainingEvent.onlinelink_PR_2 = null;
        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_3 = null;

        trainingEvent.startTime_PR_1 = null;
        trainingEvent.startTime_PR_2 = null;
        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_3 = null;

        trainingEvent.endTime_PR_1 = null;
        trainingEvent.endTime_PR_2 = null;
        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_3 = null;

        trainingEvent.trainerId_PR_1 = null;
        trainingEvent.trainerId_PR_2 = null;
        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_3 = null;

        trainingEvent.trainerId2_PR_1 = null;
        trainingEvent.trainerId2_PR_2 = null;
        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_3 = null;

        trainingEvent.translatorId_PR_1 = null;
        trainingEvent.translatorId_PR_2 = null;
        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_3 = null;

        trainingEvent.roomId_PR_1 = null;
        trainingEvent.roomId_PR_2 = null;
        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "ORAL_ORAL_AND_THEORETICAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlineLink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;
        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_PR_3 = null;
        trainingEvent.selectedLocationId_TH_2 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_2 = null;
        trainingEvent.startDate_TH_3 = null;

        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_2 = null;
        trainingEvent.endDate_TH_3 = null;

        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_2 = null;
        trainingEvent.onlinelink_TH_3 = null;

        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_2 = null;
        trainingEvent.startTime_TH_3 = null;

        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_2 = null;
        trainingEvent.endTime_TH_3 = null;

        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_2 = null;
        trainingEvent.trainerId_TH_3 = null;

        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_2 = null;
        trainingEvent.trainerId2_TH_3 = null;

        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_2 = null;
        trainingEvent.translatorId_TH_3 = null;

        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_2 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "ORAL_ORAL_AND_ORAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlinelink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;

        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_TH_1 = null;
        trainingEvent.selectedLocationId_TH_2 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_TH_1 = null;
        trainingEvent.startDate_TH_2 = null;
        trainingEvent.startDate_TH_3 = null;

        trainingEvent.endDate_TH_1 = null;
        trainingEvent.endDate_TH_2 = null;
        trainingEvent.endDate_TH_3 = null;

        trainingEvent.onlinelink_TH_1 = null;
        trainingEvent.onlinelink_TH_2 = null;
        trainingEvent.onlinelink_TH_3 = null;

        trainingEvent.startTime_TH_1 = null;
        trainingEvent.startTime_TH_2 = null;
        trainingEvent.startTime_TH_3 = null;

        trainingEvent.endTime_TH_1 = null;
        trainingEvent.endTime_TH_2 = null;
        trainingEvent.endTime_TH_3 = null;

        trainingEvent.trainerId_TH_1 = null;
        trainingEvent.trainerId_TH_2 = null;
        trainingEvent.trainerId_TH_3 = null;

        trainingEvent.trainerId2_TH_1 = null;
        trainingEvent.trainerId2_TH_2 = null;
        trainingEvent.trainerId2_TH_3 = null;

        trainingEvent.translatorId_TH_1 = null;
        trainingEvent.translatorId_TH_2 = null;
        trainingEvent.translatorId_TH_3 = null;

        trainingEvent.roomId_TH_1 = null;
        trainingEvent.roomId_TH_2 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (trainingEvent.examType == "THEORETICAL_THEORETICAL_AND_ORAL") {
        trainingEvent.startDate = null;
        trainingEvent.selectedLocationId = null;
        trainingEvent.endDate = null;
        trainingEvent.onlineLink = null;
        trainingEvent.trainer2Id = null;
        trainingEvent.trainerId = null;
        trainingEvent.translatorId = null;
        trainingEvent.roomId = null;
        trainingEvent.startTime = null;
        trainingEvent.endTime = null;

        trainingEvent.selectedLocationId_PR_2 = null;
        trainingEvent.selectedLocationId_PR_3 = null;
        trainingEvent.selectedLocationId_TH_3 = null;

        trainingEvent.startDate_PR_2 = null;
        trainingEvent.startDate_PR_3 = null;
        trainingEvent.startDate_TH_3 = null;

        trainingEvent.endDate_PR_2 = null;
        trainingEvent.endDate_PR_3 = null;
        trainingEvent.endDate_TH_3 = null;

        trainingEvent.onlinelink_PR_2 = null;
        trainingEvent.onlinelink_PR_3 = null;
        trainingEvent.onlinelink_TH_3 = null;

        trainingEvent.startTime_PR_2 = null;
        trainingEvent.startTime_PR_3 = null;
        trainingEvent.startTime_TH_3 = null;

        trainingEvent.endTime_PR_2 = null;
        trainingEvent.endTime_PR_3 = null;
        trainingEvent.endTime_TH_3 = null;

        trainingEvent.trainerId_PR_2 = null;
        trainingEvent.trainerId_PR_3 = null;
        trainingEvent.trainerId_TH_3 = null;

        trainingEvent.trainerId2_PR_2 = null;
        trainingEvent.trainerId2_PR_3 = null;
        trainingEvent.trainerId2_TH_3 = null;

        trainingEvent.translatorId_PR_2 = null;
        trainingEvent.translatorId_PR_3 = null;
        trainingEvent.translatorId_TH_3 = null;

        trainingEvent.roomId_PR_2 = null;
        trainingEvent.roomId_PR_3 = null;
        trainingEvent.roomId_TH_3 = null;
      } else if (
        trainingEvent.examType == "THEORETICAL_THEORETICAL_AND_THEROTICAL"
      ) {
        trainingEvent.selectedLocationId_PR_1 = null;
        trainingEvent.selectedLocationId_PR_2 = null;
        trainingEvent.selectedLocationId_PR_3 = null;

        trainingEvent.startDate_PR_1 = null;
        trainingEvent.startDate_PR_2 = null;
        trainingEvent.startDate_PR_3 = null;

        trainingEvent.endDate_PR_1 = null;
        trainingEvent.endDate_PR_2 = null;
        trainingEvent.endDate_PR_3 = null;

        trainingEvent.onlinelink_PR_1 = null;
        trainingEvent.onlinelink_PR_2 = null;
        trainingEvent.onlinelink_PR_3 = null;

        trainingEvent.startTime_PR_1 = null;
        trainingEvent.startTime_PR_2 = null;
        trainingEvent.startTime_PR_3 = null;

        trainingEvent.endTime_PR_1 = null;
        trainingEvent.endTime_PR_2 = null;
        trainingEvent.endTime_PR_3 = null;

        trainingEvent.trainerId_PR_1 = null;
        trainingEvent.trainerId_PR_2 = null;
        trainingEvent.trainerId_PR_3 = null;

        trainingEvent.trainerId2_PR_1 = null;
        trainingEvent.trainerId2_PR_2 = null;
        trainingEvent.trainerId2_PR_3 = null;

        trainingEvent.translatorId_PR_1 = null;
        trainingEvent.translatorId_PR_2 = null;
        trainingEvent.translatorId_PR_3 = null;

        trainingEvent.roomId_PR_1 = null;
        trainingEvent.roomId_PR_2 = null;
        trainingEvent.roomId_PR_3 = null;
      }

      if (this.characterCountComments > 6000) {
        this.$noty.error(
          this.$t("character_exceeded", { name: this.$t("comment") })
        );
        return;
      }

      if (this.editMode) {
        // Edit Training

        delete trainingEvent.locationFormatted;

        delete trainingEvent.roomFormatted;

        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .put("/api/training/event/" + this.trainingEventId, trainingEvent)
          .then(function (response) {
            _this.incrementCounter("update");
            if (!response.data.documentChangeMsg) {
              _this.$noty.success(
                _this.$t("trainingEvent_edited", {
                  name: response.data.designation,
                })
              );
            } else {
              _this.documentChangeDisplay = true;
              _this.$noty.success(
                _this.$t("trainingEvent_edited", {
                  name: response.data.designation,
                })
              );

              //  _this.$noty.success(
              //     _this.$t("trainingEvent_edited_with_document")
              //   );

              _this.trainingEvent = {};
              _this.fetchEditingTrainingEvent();
            }
          })
          .catch((response) => {
            if (_this.trainingEvent.comment) {
              _this.characterCountComments = _this.trainingEvent.comment.length;
            }
            this.onError(response);
          })
          .finally(() => {
            // this.trainingEvent = {};
            //  this.fetchEditingTrainingEvent();
            this.onFinally();
          });
      } else {
        // Create new Training

        let url =
          this.trainingRequestId == null
            ? "/api/training/event"
            : "/api/training/event/training-request/" + this.trainingRequestId;

        url =
          this.salesListId == null
            ? "/api/training/event"
            : "/api/training/event/sales-list/" + this.salesListId;
        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .post(url, trainingEvent)
          .then(function (response) {
            _this.incrementCounter("create");
            _this.trainingEventId = response.data.id;
            _this.editMode = true;
            _this.fetchEditingTrainingEvent();
            _this.$noty.success(
              _this.$t("trainingEvent_saved", {
                name: response.data.designation,
              })
            );
            _this.$router.push("/training-events");
          })
          .catch(this.onError)
          .finally(() => {
            this.onFinally();
          });
      }
    },

    activeOrInactiveTrainingEvent(eventFlagCode) {
      var _this = this;
      this.trainingEvent.rooms = this.rooms;
      var trainingEvent = {};
      trainingEvent = Object.assign(trainingEvent, this.trainingEvent);
      this.trainingEventId = trainingEvent.id;
      const updatedTrainingEvent = Object.assign({}, this.trainingEvent, {
        eventflag: eventFlagCode,
      });
      trainingEvent = Object.assign(trainingEvent, updatedTrainingEvent);
      trainingEvent.trainingEventCategory = null;
      trainingEvent.rooms = null;
      if (this.salesListId) {
        trainingEvent.salesListId = this.salesListId;
      }
      // console.log(eventFlagCode); return;
      if (eventFlagCode === "0") {
        if (this.$isStringEmptyOrNull(trainingEvent.eventNumber)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("eventNumber") })
          );
          return;
        }

        if (this.$isStringEmptyOrNull(trainingEvent.examType)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("examType") })
          );
          return;
        }

        if (trainingEvent.eventNumber !== null) {
          trainingEvent.eventNumber = trainingEvent.eventNumber.trim();
        }
        // Validation for empty fields
        if (this.PR_ST) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.endDate)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (!trainingEvent.trainerId) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime ||
            !this.isValidTime(trainingEvent.startTime) ||
            !trainingEvent.startTime.includes(":") ||
            isNaN(trainingEvent.startTime.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (
            !trainingEvent.endTime ||
            !this.isValidTime(trainingEvent.endTime) ||
            !trainingEvent.endTime.includes(":") ||
            isNaN(trainingEvent.endTime.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate) > new Date(trainingEvent.endDate)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId != null &&
            (trainingEvent.roomId == null || trainingEvent.roomId == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlineLink == null ||
              trainingEvent.onlineLink == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_1) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_1) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_1 ||
            !this.isValidTime(trainingEvent.startTime_PR_1) ||
            !trainingEvent.startTime_PR_1.includes(":") ||
            isNaN(trainingEvent.startTime_PR_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_1 ||
            !this.isValidTime(trainingEvent.endTime_PR_1) ||
            !trainingEvent.endTime_PR_1.includes(":") ||
            isNaN(trainingEvent.endTime_PR_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_1 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_1 != null &&
            (trainingEvent.roomId_PR_1 == null ||
              trainingEvent.roomId_PR_1 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_1 == null ||
              trainingEvent.onlinelink_PR_1 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_2) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr2") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_2) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer2") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_2 ||
            !this.isValidTime(trainingEvent.startTime_PR_2) ||
            !trainingEvent.startTime_PR_2.includes(":") ||
            isNaN(trainingEvent.startTime_PR_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_2 ||
            !this.isValidTime(trainingEvent.endTime_PR_2) ||
            !trainingEvent.endTime_PR_2.includes(":") ||
            isNaN(trainingEvent.endTime_PR_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_PR_2) >
            new Date(trainingEvent.endDate_PR_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId_PR_2 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_2 != null &&
            (trainingEvent.roomId_PR_2 == null ||
              trainingEvent.roomId_PR_2 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_2 == null ||
              trainingEvent.onlinelink_PR_2 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.PR_3) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_pr3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_pr3") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_PR_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (!trainingEvent.trainerId_PR_3) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer3") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_PR_3 ||
            !this.isValidTime(trainingEvent.startTime_PR_3) ||
            !trainingEvent.startTime_PR_3.includes(":") ||
            isNaN(trainingEvent.startTime_PR_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_PR_3 ||
            !this.isValidTime(trainingEvent.endTime_PR_3) ||
            !trainingEvent.endTime_PR_3.includes(":") ||
            isNaN(trainingEvent.endTime_PR_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_PR_3) >
            new Date(trainingEvent.endDate_PR_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId_PR_3 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_PR_3 != null &&
            (trainingEvent.roomId_PR_3 == null ||
              trainingEvent.roomId_PR_3 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_PR_3 == null ||
              trainingEvent.onlinelink_PR_3 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_1) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th1") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_1)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_1) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_1 ||
            !this.isValidTime(trainingEvent.startTime_TH_1) ||
            !trainingEvent.startTime_TH_1.includes(":") ||
            isNaN(trainingEvent.startTime_TH_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_1 ||
            !this.isValidTime(trainingEvent.endTime_TH_1) ||
            !trainingEvent.endTime_TH_1.includes(":") ||
            isNaN(trainingEvent.endTime_TH_1.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_1) >
            new Date(trainingEvent.endDate_TH_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId_TH_1 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_1 != null &&
            (trainingEvent.roomId_TH_1 == null ||
              trainingEvent.roomId_TH_1 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_1 == null ||
              trainingEvent.onlinelink_TH_1 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_2) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th2") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_2)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_2) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_2 ||
            !this.isValidTime(trainingEvent.startTime_TH_2) ||
            !trainingEvent.startTime_TH_2.includes(":") ||
            isNaN(trainingEvent.startTime_TH_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_2 ||
            !this.isValidTime(trainingEvent.endTime_TH_2) ||
            !trainingEvent.endTime_TH_2.includes(":") ||
            isNaN(trainingEvent.endTime_TH_2.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_2) >
            new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            new Date(trainingEvent.startDate_TH_2) >
            new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId_TH_2 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_2 != null &&
            (trainingEvent.roomId_TH_2 == null ||
              trainingEvent.roomId_TH_2 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_2 == null ||
              trainingEvent.onlinelink_TH_2 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.TH_3) {
          if (this.$isStringEmptyOrNull(trainingEvent.startDate_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_date_th3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endDate_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_date_th3") })
            );
            return;
          }

          if (this.$isStringEmptyOrNull(trainingEvent.startTime_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (this.$isStringEmptyOrNull(trainingEvent.endTime_TH_3)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (!trainingEvent.trainerId_TH_3) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("trainer") })
            );
            return;
          }

          if (
            !trainingEvent.startTime_TH_3 ||
            !this.isValidTime(trainingEvent.startTime_TH_3) ||
            !trainingEvent.startTime_TH_3.includes(":") ||
            isNaN(trainingEvent.startTime_TH_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (
            !trainingEvent.endTime_TH_3 ||
            !this.isValidTime(trainingEvent.endTime_TH_3) ||
            !trainingEvent.endTime_TH_3.includes(":") ||
            isNaN(trainingEvent.endTime_TH_3.replace(":", ""))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_3) >
            new Date(trainingEvent.endDate_TH_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }

          if (
            trainingEvent.selectedLocationId_TH_3 == null &&
            trainingEvent.eventType != "VIRTUAL" &&
            trainingEvent.eventType != "VIDEO"
          ) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("location") })
            );
            return;
          }

          if (
            trainingEvent.selectedLocationId_TH_3 != null &&
            (trainingEvent.roomId_TH_3 == null ||
              trainingEvent.roomId_TH_3 == "")
          ) {
            this.$noty.error(this.$t("empty_room_but_location"));
            return;
          }

          if (
            trainingEvent.eventType == "VIRTUAL" ||
            trainingEvent.eventType == "VIDEO"
          ) {
            if (
              trainingEvent.onlinelink_TH_3 == null ||
              trainingEvent.onlinelink_TH_3 == ""
            ) {
              this.$noty.error(
                this.$t("empty_value_for_virtual", {
                  name: this.$t("onlineLink"),
                })
              );
              return;
            }
          }
        }

        if (this.$isStringEmptyOrNull(trainingEvent.language)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("language") })
          );
          return;
        }
        if (this.$isStringEmptyOrNull(trainingEvent.status)) {
          this.$noty.error(this.$t("empty_value", { name: this.$t("status") }));
          return;
        }

        if (
          !trainingEvent.trainingId &&
          !trainingEvent.eventTrainingCategoryId
        ) {
          this.$noty.error(this.$t("event_training_category_or_training"));
          return;
        }
        // if (!trainingEvent.vehicleType) {
        //   this.$noty.error(
        //     this.$t("empty_value", { name: this.$t("vehicleType") })
        //   );
        //   return;
        // }
        if (trainingEvent.trainingId !== null) {
          if (!trainingEvent.eventType) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("training_event_type") })
            );
            return;
          }
        }
        if (trainingEvent.eventTrainingCategoryId != null) {
          if (this.$isStringEmptyOrNull(trainingEvent.eventType)) {
            this.$noty.error(
              this.$t("empty_value", { name: this.$t("training_event_type") })
            );
            return;
          }
        }

        if (
          trainingEvent.minParticipants === undefined ||
          trainingEvent.minParticipants === ""
        ) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("minParticipants") })
          );
          return;
        }

        if (
          trainingEvent.maxParticipants === undefined ||
          trainingEvent.maxParticipants === ""
        ) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("maxParticipants") })
          );
          return;
        }

        // Try Parse Values
        try {
          if (isNaN(trainingEvent.minParticipants)) {
            trainingEvent.minParticipants = parseInt(
              trainingEvent.minParticipants
            );
          }
        } catch (error) {
          console.error(error);
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }
        try {
          if (isNaN(trainingEvent.maxParticipants)) {
            trainingEvent.maxParticipants = parseInt(
              trainingEvent.maxParticipants
            );
          }
        } catch (error) {
          console.error(error);
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }

        if (trainingEvent.minParticipants < 0) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("minParticipants") })
          );
          return;
        }
        if (trainingEvent.maxParticipants < 0) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("maxParticipants") })
          );
          return;
        }
        if (trainingEvent.minParticipants > trainingEvent.maxParticipants) {
          this.$noty.error(
            this.$t("invalid_value", { name: this.$t("maxParticipants") })
          );
          return;
        }
      }

      if (eventFlagCode === "1" || eventFlagCode === "2") {
        if (this.PR_ST) {
          if (
            trainingEvent.startTime &&
            (!this.isValidTime(trainingEvent.startTime) ||
              !trainingEvent.startTime.includes(":") ||
              isNaN(trainingEvent.startTime.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time") })
            );
            return;
          }
          if (
            trainingEvent.endTime &&
            (!this.isValidTime(trainingEvent.endTime) ||
              !trainingEvent.endTime.includes(":") ||
              isNaN(trainingEvent.endTime.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time") })
            );
            return;
          }

          if (
            trainingEvent.startDate &&
            trainingEvent.endDate &&
            new Date(trainingEvent.startDate) > new Date(trainingEvent.endDate)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_1) {
          if (
            trainingEvent.startTime_PR_1 &&
            (!this.isValidTime(trainingEvent.startTime_PR_1) ||
              !trainingEvent.startTime_PR_1.includes(":") ||
              isNaN(trainingEvent.startTime_PR_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr1") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_1 &&
            (!this.isValidTime(trainingEvent.endTime_PR_1) ||
              !trainingEvent.endTime_PR_1.includes(":") ||
              isNaN(trainingEvent.endTime_PR_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr1") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_1 &&
            trainingEvent.endDate_PR_1 &&
            new Date(trainingEvent.startDate_PR_1) >
              new Date(trainingEvent.endDate_PR_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_2) {
          if (
            trainingEvent.startTime_PR_2 &&
            (!this.isValidTime(trainingEvent.startTime_PR_2) ||
              !trainingEvent.startTime_PR_2.includes(":") ||
              isNaN(trainingEvent.startTime_PR_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr2") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_2 &&
            (!this.isValidTime(trainingEvent.endTime_PR_2) ||
              !trainingEvent.endTime_PR_2.includes(":") ||
              isNaN(trainingEvent.endTime_PR_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr2") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_2 &&
            trainingEvent.endDate_PR_2 &&
            new Date(trainingEvent.startDate_PR_2) >
              new Date(trainingEvent.endDate_PR_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.PR_3) {
          if (
            trainingEvent.startTime_PR_3 &&
            (!this.isValidTime(trainingEvent.startTime_PR_3) ||
              !trainingEvent.startTime_PR_3.includes(":") ||
              isNaN(trainingEvent.startTime_PR_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_pr3") })
            );
            return;
          }
          if (
            trainingEvent.endTime_PR_3 &&
            (!this.isValidTime(trainingEvent.endTime_PR_3) ||
              !trainingEvent.endTime_PR_3.includes(":") ||
              isNaN(trainingEvent.endTime_PR_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_pr3") })
            );
            return;
          }

          if (
            trainingEvent.startDate_PR_3 &&
            trainingEvent.endDate_PR_3 &&
            new Date(trainingEvent.startDate_PR_3) >
              new Date(trainingEvent.endDate_PR_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_1) {
          if (
            trainingEvent.startTime_TH_1 &&
            (!this.isValidTime(trainingEvent.startTime_TH_1) ||
              !trainingEvent.startTime_TH_1.includes(":") ||
              isNaN(trainingEvent.startTime_TH_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th1") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_1 &&
            (!this.isValidTime(trainingEvent.endTime_TH_1) ||
              !trainingEvent.endTime_TH_1.includes(":") ||
              isNaN(trainingEvent.endTime_TH_1.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th1") })
            );
            return;
          }

          if (
            new Date(trainingEvent.startDate_TH_1) >
            new Date(trainingEvent.endDate_TH_1)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_2) {
          if (
            trainingEvent.startTime_TH_2 &&
            (!this.isValidTime(trainingEvent.startTime_TH_2) ||
              !trainingEvent.startTime_TH_2.includes(":") ||
              isNaN(trainingEvent.startTime_TH_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th2") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_2 &&
            (!this.isValidTime(trainingEvent.endTime_TH_2) ||
              !trainingEvent.endTime_TH_2.includes(":") ||
              isNaN(trainingEvent.endTime_TH_2.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th2") })
            );
            return;
          }

          if (
            trainingEvent.startDate_TH_2 &&
            trainingEvent.endDate_TH_2 &&
            new Date(trainingEvent.startDate_TH_2) >
              new Date(trainingEvent.endDate_TH_2)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }

        if (this.TH_3) {
          if (
            trainingEvent.startTime_TH_3 &&
            (!this.isValidTime(trainingEvent.startTime_TH_3) ||
              !trainingEvent.startTime_TH_3.includes(":") ||
              isNaN(trainingEvent.startTime_TH_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("begin_time_th3") })
            );
            return;
          }
          if (
            trainingEvent.endTime_TH_3 &&
            (!this.isValidTime(trainingEvent.startTime_TH_3) ||
              !trainingEvent.endTime_TH_3.includes(":") ||
              isNaN(trainingEvent.endTime_TH_3.replace(":", "")))
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("end_time_th3") })
            );
            return;
          }

          if (
            trainingEvent.startDate_TH_3 &&
            trainingEvent.endDate_TH_3 &&
            new Date(trainingEvent.startDate_TH_3) >
              new Date(trainingEvent.endDate_TH_3)
          ) {
            this.$noty.error(
              this.$t("invalid_value", { name: this.$t("date") })
            );
            return false;
          }
        }
      }

      delete trainingEvent.training;

      if (this.editMode) {
        // Edit Training
        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .put("/api/training/event/" + this.trainingEventId, trainingEvent)
          .then(function (response) {
            if (eventFlagCode === "0") {
              _this.incrementCounter("update");
              _this.$noty.success(
                _this.$t("trainingEvent_activated", {
                  name: response.data.designation,
                })
              );
              _this.$router.push("/training-events");
            } else if (eventFlagCode === "1") {
              _this.incrementCounter(_this.trainingEventId);
              _this.$noty.success(
                _this.$t("trainingEvent_cancelled", {
                  name: response.data.designation,
                })
              );
              _this.$router.push({
                path: "/inactive-events",
                query: { eventStatus: "cancelled" },
              });
            } else if (eventFlagCode === "2") {
              _this.incrementCounter(_this.trainingEventId);
              _this.$noty.success(
                _this.$t("trainingEvent_drafted", {
                  name: response.data.designation,
                })
              );
              _this.$router.push({
                path: "/inactive-events",
                query: { eventStatus: "drafted" },
              });
            }
          })
          .catch(this.onError)
          .finally(this.onFinally);
      } else {
        // Create new Training
        let url =
          this.trainingRequestId == null
            ? "/api/training/event"
            : "/api/training/event/training-request/" + this.trainingRequestId;

        url =
          this.salesListId == null
            ? "/api/training/event"
            : "/api/training/event/sales-list/" + this.salesListId;

        progressIndicator.hidden = false;
        showLoadingCircle(true);
        this.$axios
          .post(url, trainingEvent)
          .then(function (response) {
            // _this.incrementCounter();
            if (eventFlagCode === "0") {
              _this.incrementCounter("update");
              _this.$noty.success(
                _this.$t("trainingEvent_activated", {
                  name: response.data.designation,
                })
              );
              _this.$router.push("/training-events");
            } else if (eventFlagCode === "1") {
              _this.incrementCounter(response.data.id);
              _this.$noty.success(
                _this.$t("trainingEvent_cancelled", {
                  name: response.data.designation,
                })
              );
              _this.$router.push({
                path: "/inactive-events",
                query: { eventStatus: "cancelled" },
              });
            } else if (eventFlagCode === "2") {
              _this.incrementCounter(response.data.id);
              _this.$noty.success(
                _this.$t("trainingEvent_drafted", {
                  name: response.data.designation,
                })
              );
              _this.$router.push({
                path: "/inactive-events",
                query: { eventStatus: "drafted" },
              });
            }
            _this.trainingEventId = response.data.id;
            _this.editMode = true;
            _this.fetchEditingTrainingEvent();
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },

    deleteTrainingEvent() {
      if (this.trainingEventId == null) {
        console.error("You are not editing an existing trainingEvent.");
        return;
      }

      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .delete("/api/training/event/" + this.trainingEventId)
        .then(function (response) {
          _this.incrementCounter(_this.trainingEventId);
          _this.$noty.success(
            _this.$t("trainingEvent_deleted", {
              name: _this.trainingEvent.designation,
            })
          );
          _this.$router.push("/training-events");
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    onFinally() {
      showLoadingCircle(false);
    },

    showCertificate(bookingId) {
      if (this.$user != null && this.$user.external) {
        this.$noty.error(this.$t("certificate_download_not_allowed"));
        return;
      }
      var win = window.open(
        "/api/booking/" + bookingId + "/certificate",
        "_blank"
      );
      win.focus();
    },
    showPreview() {
      if (this.$user != null && this.$user.external) {
        this.$noty.error(this.$t("certificate_download_not_allowed"));
        return;
      }
      var win = window.open(
        "/api/booking/" + this.trainingEventId + "/previewcertificate",
        "_blank"
      );
      win.focus();
    },

    createParticipantsList() {
      if (this.$user != null && this.$user.external) {
        this.$noty.error(this.$t("participant_list_download_not_allowed"));
        return;
      }
      var win = window.open(
        "/api/training/event/" + this.trainingEventId + "/participantslist",
        "_blank"
      );
      win.focus();
    },

    sendMail(booking) {
      if (booking.invitationsSent == 0) {
        this.firstTimeInvitation = true;
      } else {
        this.firstTimeInvitation = false;
      }
      this.sendMailAgainBooking = booking;
      this.openSendMailAgainDialog = true;
    },

    sendMailForOnlineFeedBack(booking) {
      // if (booking.feedbackSent == 0) {
      //   this.sendMailToParticipantForOnlineFeedBack(booking);
      //   return;
      // }
      if (booking.feedbackSent == 0) {
        this.firstTimeFeedback = true;
      } else {
        this.firstTimeFeedback = false;
      }
      this.sendMailAgainFeedBackBooking = booking;
      this.openSendMailAgainFeedBackDialog = true;
    },

    sendMailToParticipantForOnlineFeedBack(booking) {
      if (booking == null) return;

      var _this = this;
      this.openSendMailAgainFeedBackDialog = false;
      this.sendMailAgainFeedBackBooking = null;

      booking.feedBackSendingLoading = true;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/booking/" + booking.id + "/feedback/mail")
        .then(function (response) {
          _this.$noty.success(
            _this.$t("invitation_sent", { name: booking.participant.fullname })
          );
          booking.feedBackSendingLoading = false;
          booking.feedbackSent++;
        })
        .catch(this.onError)
        .finally(() => {
          showLoadingCircle(false);
          booking.feedBackSendingLoading = false;
        });
    },

    sendMailToParticipant(booking) {
      if (booking == null) return;

      var _this = this;
      this.openSendMailAgainDialog = false;
      this.sendMailAgainBooking = null;

      booking.invitationSendingLoading = true;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/booking/" + booking.id + "/mail")
        .then(function (response) {
          _this.$noty.success(
            _this.$t("invitation_sent", { name: booking.participant.fullname })
          );
          booking.invitationSendingLoading = false;
          booking.invitationsSent++;
        })
        .catch(this.onError)
        .finally(() => {
          showLoadingCircle(false);
          booking.invitationSendingLoading = false;
        });
    },

    sendBlankMail() {
      var _this = this;
      const dto = {
        trainingEventId: this.trainingEventId,
        email: this.customEmail,
      };
      const email = this.customEmail;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .post("/api/booking/mail/blank", dto)
        .then(function (response) {
          _this.$noty.success(_this.$t("invitation_sent", { name: email }));
          _this.openSendMailCustomDialog = false;
        })
        .catch(this.onError)
        .finally(() => {
          showLoadingCircle(false);
        });
    },

    deleteBooking(booking) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .delete("/api/booking/" + booking.id)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("booking_deleted", { name: booking.participant.fullname })
          );
          _this.fetchBookings();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    // Stuff for Adding new Participants
    isUserAlreadyParticipant(userId) {
      for (let i = 0; i < this.bookings.length; i++) {
        const booking = this.bookings[i];
        if (booking.participant.id == userId) return true;
      }
      return false;
    },

    addParticipant() {
      var _this = this;
      this.adduser.trainingEventId = this.trainingEvent.id;
      if (this.$isStringEmptyOrNull(this.adduser.firstname)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("firstname") })
        );
        return;
      }
      if (this.$isStringEmptyOrNull(this.adduser.lastname)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("lastname") }));
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.adduser.email && !emailRegex.test(this.adduser.email)) {
        this.$noty.error(this.$t("invalid_value", { name: this.$t("email") }));
        return;
      }
      const username =
        this.adduser.firstname.trim() + " " + this.adduser.lastname.trim();
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .post("/api/booking/", this.adduser)
        .then(function (response) {
          _this.trainingEventId = _this.trainingEvent.id;

          _this.adduser = {
            firstname: null,
            lastname: null,
            personnelnumber: null,
            location: null,
            company: null,
            email: null,
            tenantId: null,
          };

          document.getElementById("add_participant_firstname").focus();

          _this.fetchBookings();
          _this.fetchUsers();
          _this.fetchEditingTrainingEvent();
          _this.$noty.success(
            _this.$t("participant_added", { name: username })
          );
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    editParticipant() {
      var _this = this;
      this.edituser.trainingEventId = this.trainingEvent.id;
      this.edituser.id = this.currentBookingID;
      if (!this.edituser.firstname) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("firstname") })
        );
        return;
      }
      if (!this.edituser.lastname) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("lastname") }));
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.edituser.email && !emailRegex.test(this.edituser.email)) {
        this.$noty.error(this.$t("invalid_value", { name: this.$t("email") }));
        return;
      }
      const username =
        this.edituser.firstname.trim() + " " + this.edituser.lastname.trim();
      let language = _this.$locale;
      if (language === "en") {
        _this.edituser.certificateEventTrainingCategoryNameEnglish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherEnglish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionEnglish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameEnglish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherEnglish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionEnglish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "de") {
        _this.edituser.certificateEventTrainingCategoryNameGerman =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherGerman =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionGerman =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameGerman =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherGerman =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionGerman =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "pl") {
        _this.edituser.certificateEventTrainingCategoryNamePolish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherPolish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionPolish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNamePolish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherPolish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionPolish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "fr") {
        _this.edituser.certificateEventTrainingCategoryNameFrench =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherFrench =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionFrench =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameFrench =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherFrench =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionFrench =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "hu") {
        _this.edituser.certificateEventTrainingCategoryNameHungarian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherHungarian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionHungarian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameHungarian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherHungarian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionHungarian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "es") {
        _this.edituser.certificateEventTrainingCategoryNameSpanish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherSpanish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionSpanish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameSpanish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherSpanish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionSpanish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "ru") {
        _this.edituser.certificateEventTrainingCategoryNameRussian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherRussian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionRussian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameRussian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherRussian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionRussian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "kk") {
        _this.edituser.certificateEventTrainingCategoryNameKazak =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherKazak =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionKazak =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameKazak =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherKazak =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionKazak =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "it") {
        _this.edituser.certificateEventTrainingCategoryNameItalian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherItalian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionItalian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameItalian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherItalian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionItalian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "zh") {
        _this.edituser.certificateEventTrainingCategoryNameChina =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherChina =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionChina =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameChina =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherChina =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionChina =
          _this.edituser.certificateTrainingDescription;
      }
      if (
        typeof this.edituser.tenantId === "object" &&
        this.edituser.tenantId !== null
      ) {
        this.edituser.tenantId = this.edituser.tenantId.id;
      }

      let request = {
        certificateStartDate_PR_1: this.edituser.certificateStartDate_PR_1,
        certificateStartDate_PR_2: this.edituser.certificateStartDate_PR_2,
        certificateStartDate_PR_3: this.edituser.certificateStartDate_PR_3,
        certificateStartDate_TH_1: this.edituser.certificateStartDate_TH_1,
        certificateStartDate_TH_2: this.edituser.certificateStartDate_TH_2,
        certificateStartDate_TH_3: this.edituser.certificateStartDate_TH_3,
        certificateEndDate_PR_1: this.edituser.certificateEndDate_PR_1,
        certificateEndDate_PR_2: this.edituser.certificateEndDate_PR_2,
        certificateEndDate_PR_3: this.edituser.certificateEndDate_PR_3,
        certificateEndDate_TH_1: this.edituser.certificateEndDate_TH_1,
        certificateEndDate_TH_2: this.edituser.certificateEndDate_TH_2,
        certificateEndDate_TH_3: this.edituser.certificateEndDate_TH_3,
        certificateTrainer2_PR_1: this.edituser.certificateTrainer2_PR_1,
        certificateTrainer2_PR_2: this.edituser.certificateTrainer2_PR_2,
        certificateTrainer2_PR_3: this.edituser.certificateTrainer2_PR_3,
        certificateTrainer2_TH_1: this.edituser.certificateTrainer2_TH_1,
        certificateTrainer2_TH_2: this.edituser.certificateTrainer2_TH_2,
        certificateTrainer2_TH_3: this.edituser.certificateTrainer2_TH_3,
        certificateTrainer_PR_1: this.edituser.certificateTrainer_PR_1,
        certificateTrainer_PR_2: this.edituser.certificateTrainer_PR_2,
        certificateTrainer_PR_3: this.edituser.certificateTrainer_PR_3,
        certificateTrainer_TH_1: this.edituser.certificateTrainer_TH_1,
        certificateTrainer_TH_2: this.edituser.certificateTrainer_TH_2,
        certificateTrainer_TH_3: this.edituser.certificateTrainer_TH_3,
        certificateEventLocation_PR_1:
          this.edituser.certificateEventLocation_PR_1,
        certificateEventLocation_PR_2:
          this.edituser.certificateEventLocation_PR_2,
        certificateEventLocation_PR_3:
          this.edituser.certificateEventLocation_PR_3,
        certificateEventLocation_TH_1:
          this.edituser.certificateEventLocation_TH_1,
        certificateEventLocation_TH_2:
          this.edituser.certificateEventLocation_TH_2,
        certificateEventLocation_TH_3:
          this.edituser.certificateEventLocation_TH_3,
        firstname: this.edituser.firstname.trim(),
        lastname: this.edituser.lastname.trim(),
        personnelnumber: this.edituser.personnelnumber,
        location: this.edituser.location,
        company: this.edituser.company,
        email: this.edituser.email,
        tenantId: this.edituser.tenantId,
        selectedStatus: this.edituser.selectedStatus,
        trainingEventId: this.edituser.trainingEventId,
        id: this.edituser.id,
        userId: this.edituser.userId,
        language: this.edituser.language,
        certificateStartDate: this.edituser.certificateStartDate,
        certificateEndDate: this.edituser.certificateEndDate,
        certificateEventLocation: this.edituser.certificateEventLocation,
        certificateEventNumber: this.edituser.certificateEventNumber,
        certificateTrainer: this.edituser.certificateTrainer,
        certificateTrainer2: this.edituser.certificateTrainer2,
        certificateStartDateOther: this.edituser.certificateStartDateOther,
        certificateEndDateOther: this.edituser.certificateEndDateOther,
        eventStatus: this.edituser.eventStatus,
        eventStatusOther: this.edituser.eventStatusOther,
        display: this.edituser.display,
        certificateEventLocationOther:
          this.edituser.certificateEventLocationOther,
        certificateEventNumberOther: this.edituser.certificateEventNumberOther,
        certificateTrainerOther: this.edituser.certificateTrainerOther,
        certificateTrainer2Other: this.edituser.certificateTrainer2Other,
        certificateTrainingNameEnglish:
          this.edituser.certificateTrainingNameEnglish,
        certificateTrainingNameGerman:
          this.edituser.certificateTrainingNameGerman,
        certificateTrainingNamePolish:
          this.edituser.certificateTrainingNamePolish,
        certificateTrainingNameFrench:
          this.edituser.certificateTrainingNameFrench,
        certificateTrainingNameHungarian:
          this.edituser.certificateTrainingNameHungarian,
        certificateTrainingNameSpanish:
          this.edituser.certificateTrainingNameSpanish,
        certificateTrainingNameRussian:
          this.edituser.certificateTrainingNameRussian,
        certificateTrainingNameKazak:
          this.edituser.certificateTrainingNameKazak,
        certificateTrainingNameItalian:
          this.edituser.certificateTrainingNameItalian,
        certificateTrainingNameChina:
          this.edituser.certificateTrainingNameChina,

        certificateTrainingNameOtherEnglish:
          this.edituser.certificateTrainingNameOtherEnglish,
        certificateTrainingNameOtherGerman:
          this.edituser.certificateTrainingNameOtherGerman,
        certificateTrainingNameOtherPolish:
          this.edituser.certificateTrainingNameOtherPolish,
        certificateTrainingNameOtherFrench:
          this.edituser.certificateTrainingNameOtherFrench,
        certificateTrainingNameOtherHungarian:
          this.edituser.certificateTrainingNameOtherHungarian,
        certificateTrainingNameOtherSpanish:
          this.edituser.certificateTrainingNameOtherSpanish,
        certificateTrainingNameOtherRussian:
          this.edituser.certificateTrainingNameOtherRussian,
        certificateTrainingNameOtherKazak:
          this.edituser.certificateTrainingNameOtherKazak,
        certificateTrainingNameOtherItalian:
          this.edituser.certificateTrainingNameOtherItalian,
        certificateTrainingNameOtherChina:
          this.edituser.certificateTrainingNameOtherChina,

        certificateTrainingDescriptionEnglish:
          this.edituser.certificateTrainingDescriptionEnglish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionEnglish,
                false
              )
            : null,
        certificateTrainingDescriptionGerman:
          this.edituser.certificateTrainingDescriptionGerman !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionGerman,
                false
              )
            : null,
        certificateTrainingDescriptionPolish:
          this.edituser.certificateTrainingDescriptionPolish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionPolish,
                false
              )
            : null,
        certificateTrainingDescriptionFrench:
          this.edituser.certificateTrainingDescriptionFrench !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionFrench,
                false
              )
            : null,
        certificateTrainingDescriptionHungarian:
          this.edituser.certificateTrainingDescriptionHungarian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionHungarian,
                false
              )
            : null,
        certificateTrainingDescriptionSpanish:
          this.edituser.certificateTrainingDescriptionSpanish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionSpanish,
                false
              )
            : null,
        certificateTrainingDescriptionRussian:
          this.edituser.certificateTrainingDescriptionRussian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionRussian,
                false
              )
            : null,
        certificateTrainingDescriptionKazak:
          this.edituser.certificateTrainingDescriptionKazak !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionKazak,
                false
              )
            : null,
        certificateTrainingDescriptionItalian:
          this.edituser.certificateTrainingDescriptionItalian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionItalian,
                false
              )
            : null,
        certificateTrainingDescriptionChina:
          this.edituser.certificateTrainingDescriptionChina !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionChina,
                false
              )
            : null,

        certificateEventTrainingCategoryNameEnglish:
          this.edituser.certificateEventTrainingCategoryNameEnglish,
        certificateEventTrainingCategoryNameGerman:
          this.edituser.certificateEventTrainingCategoryNameGerman,
        certificateEventTrainingCategoryNamePolish:
          this.edituser.certificateEventTrainingCategoryNamePolish,
        certificateEventTrainingCategoryNameFrench:
          this.edituser.certificateEventTrainingCategoryNameFrench,
        certificateEventTrainingCategoryNameHungarian:
          this.edituser.certificateEventTrainingCategoryNameHungarian,
        certificateEventTrainingCategoryNameSpanish:
          this.edituser.certificateEventTrainingCategoryNameSpanish,
        certificateEventTrainingCategoryNameRussian:
          this.edituser.certificateEventTrainingCategoryNameRussian,
        certificateEventTrainingCategoryNameKazak:
          this.edituser.certificateEventTrainingCategoryNameKazak,
        certificateEventTrainingCategoryNameItalian:
          this.edituser.certificateEventTrainingCategoryNameItalian,
        certificateEventTrainingCategoryNameChina:
          this.edituser.certificateEventTrainingCategoryNameChina,

        certificateEventTrainingCategoryNameOtherEnglish:
          this.edituser.certificateEventTrainingCategoryNameOtherEnglish,
        certificateEventTrainingCategoryNameOtherGerman:
          this.edituser.certificateEventTrainingCategoryNameOtherGerman,
        certificateEventTrainingCategoryNameOtherPolish:
          this.edituser.certificateEventTrainingCategoryNameOtherPolish,
        certificateEventTrainingCategoryNameOtherFrench:
          this.edituser.certificateEventTrainingCategoryNameOtherFrench,
        certificateEventTrainingCategoryNameOtherHungarian:
          this.edituser.certificateEventTrainingCategoryNameOtherHungarian,
        certificateEventTrainingCategoryNameOtherSpanish:
          this.edituser.certificateTrainingNameOtherSpanish,
        certificateEventTrainingCategoryNameOtherRussian:
          this.edituser.certificateEventTrainingCategoryNameOtherRussian,
        certificateEventTrainingCategoryNameOtherKazak:
          this.edituser.certificateEventTrainingCategoryNameOtherKazak,
        certificateEventTrainingCategoryNameOtherItalian:
          this.edituser.certificateEventTrainingCategoryNameOtherItalian,
        certificateEventTrainingCategoryNameOtherChina:
          this.edituser.certificateEventTrainingCategoryNameOtherChina,
        certificateEventTrainingCategoryDescriptionEnglish:
          this.edituser.certificateEventTrainingCategoryDescriptionEnglish !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionEnglish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionGerman:
          this.edituser.certificateEventTrainingCategoryDescriptionGerman !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionGerman,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionPolish:
          this.edituser.certificateEventTrainingCategoryDescriptionPolish !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionPolish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionFrench:
          this.edituser.certificateEventTrainingCategoryDescriptionFrench !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionFrench,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionHungarian:
          this.edituser.certificateEventTrainingCategoryDescriptionHungarian !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionHungarian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionSpanish:
          this.edituser.certificateEventTrainingCategoryDescriptionSpanish !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionSpanish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionRussian:
          this.edituser.certificateEventTrainingCategoryDescriptionRussian !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionRussian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionKazak:
          this.edituser.certificateEventTrainingCategoryDescriptionKazak !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionKazak,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionItalian:
          this.edituser.certificateEventTrainingCategoryDescriptionItalian !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionItalian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionChina:
          this.edituser.certificateEventTrainingCategoryDescriptionChina !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionChina,
                false
              )
            : null,

        display_PR_1: this.edituser.display_PR_1,
        display_PR_2: this.edituser.display_PR_2,
        display_PR_3: this.edituser.display_PR_3,
        display_TH_1: this.edituser.display_TH_1,
        display_TH_2: this.edituser.display_TH_2,
        display_TH_3: this.edituser.display_TH_3,
      };
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      let currentBookingId = parseInt(this.currentBookingID, 10);
      this.$axios
        .put("/api/booking/updateBooking/" + currentBookingId, request)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("participant_edited", { name: username })
          );
          _this.edituser = {
            firstname: null,
            lastname: null,
            personnelnumber: null,
            location: null,
            company: null,
            email: null,
            tenantId: null,
            selectedStatus: null,
            certificateStartDate: null,
            certificateEndDate: null,
            certificateEventLocation: null,
            certificateEventNumber: null,
            certificateTrainer: null,
            certificateTrainer2: null,
            certificateStartDateOther: null,
            certificateEndDateOther: null,
            display: null,
            eventStatus: null,
            eventStatusOther: null,
            certificateEventLocationOther: null,
            certificateEventNumberOther: null,
            certificateTrainerOther: null,
            certificateTrainer2Other: null,
            certificateTrainingNameEnglish: null,
            certificateTrainingNameGerman: null,
            certificateTrainingNamePolish: null,
            certificateTrainingNameFrench: null,
            certificateTrainingNameHungarian: null,
            certificateTrainingNameSpanish: null,
            certificateTrainingNameRussian: null,
            certificateTrainingNameKazak: null,
            certificateTrainingNameItalian: null,
            certificateTrainingNameChina: null,

            certificateTrainingNameOtherEnglish: null,
            certificateTrainingNameOtherGerman: null,
            certificateTrainingNameOtherPolish: null,
            certificateTrainingNameOtherFrench: null,
            certificateTrainingNameOtherHungarian: null,
            certificateTrainingNameOtherSpanish: null,
            certificateTrainingNameOtherRussian: null,
            certificateTrainingNameOtherKazak: null,
            certificateTrainingNameOtherItalian: null,
            certificateTrainingNameOtherChina: null,

            certificateTrainingName: null,
            certificateTrainingNameOther: null,
            certificateTrainingDescription: null,
            certificateTrainingDescriptionEnglish: null,
            certificateTrainingDescriptionGerman: null,
            certificateTrainingDescriptionPolish: null,
            certificateTrainingDescriptionFrench: null,
            certificateTrainingDescriptionHungarian: null,
            certificateTrainingDescriptionSpanish: null,
            certificateTrainingDescriptionRussian: null,
            certificateTrainingDescriptionKazak: null,
            certificateTrainingDescriptionItalian: null,
            certificateTrainingDescriptionChina: null,

            certificateEventTrainingCategoryNameEnglish: null,
            certificateEventTrainingCategoryNameGerman: null,
            certificateEventTrainingCategoryNamePolish: null,
            certificateEventTrainingCategoryNameFrench: null,
            certificateEventTrainingCategoryNameHungarian: null,
            certificateEventTrainingCategoryNameSpanish: null,
            certificateEventTrainingCategoryNameRussian: null,
            certificateEventTrainingCategoryNameKazak: null,
            certificateEventTrainingCategoryNameItalian: null,
            certificateEventTrainingCategoryNameChina: null,

            certificateEventTrainingCategoryNameOtherEnglish: null,
            certificateEventTrainingCategoryNameOtherGerman: null,
            certificateEventTrainingCategoryNameOtherPolish: null,
            certificateEventTrainingCategoryNameOtherFrench: null,
            certificateEventTrainingCategoryNameOtherHungarian: null,
            certificateEventTrainingCategoryNameOtherSpanish: null,
            certificateEventTrainingCategoryNameOtherRussian: null,
            certificateEventTrainingCategoryNameOtherKazak: null,
            certificateEventTrainingCategoryNameOtherItalian: null,
            certificateEventTrainingCategoryNameOtherChina: null,

            certificateEventTrainingCategorygName: null,
            certificateEventTrainingCategoryNameOther: null,
            certificateEventTrainingCategoryDescription: null,
            certificateEventTrainingCategoryDescriptionEnglish: null,
            certificateEventTrainingCategoryDescriptionGerman: null,
            certificateEventTrainingCategoryDescriptionPolish: null,
            certificateEventTrainingCategoryDescriptionFrench: null,
            certificateEventTrainingCategoryDescriptionHungarian: null,
            certificateEventTrainingCategoryDescriptionSpanish: null,
            certificateEventTrainingCategoryDescriptionRussian: null,
            certificateEventTrainingCategoryDescriptionKazak: null,
            certificateEventTrainingCategoryDescriptionItalian: null,
            certificateEventTrainingCategoryDescriptionChina: null,
          };
          _this.fetchBookingsEdit();
        })
        .catch(this.onError)
        .finally(this.onFinally);

      this.showModal = false;

      setTimeout(() => {
        window.scrollTo(this.scrollPositionX, this.scrollPositionY);
        //  _this.fetchBookings();
        _this.fetchUsers();
      }, 1000);
      document.getElementById("edit_participant_firstname").focus();
    },

    editParticipantForAll() {
      var _this = this;
      this.edituser.trainingEventId = this.trainingEvent.id;
      this.edituser.id = this.currentBookingID;
      const username =
        this.edituser.firstname.trim() + " " + this.edituser.lastname.trim();
      let language = _this.$locale;
      if (language === "en") {
        _this.edituser.certificateEventTrainingCategoryNameEnglish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherEnglish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionEnglish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameEnglish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherEnglish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionEnglish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "de") {
        _this.edituser.certificateEventTrainingCategoryNameGerman =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherGerman =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionGerman =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameGerman =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherGerman =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionGerman =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "pl") {
        _this.edituser.certificateEventTrainingCategoryNamePolish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherPolish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionPolish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNamePolish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherPolish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionPolish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "fr") {
        _this.edituser.certificateEventTrainingCategoryNameFrench =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherFrench =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionFrench =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameFrench =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherFrench =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionFrench =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "hu") {
        _this.edituser.certificateEventTrainingCategoryNameHungarian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherHungarian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionHungarian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameHungarian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherHungarian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionHungarian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "es") {
        _this.edituser.certificateEventTrainingCategoryNameSpanish =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherSpanish =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionSpanish =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameSpanish =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherSpanish =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionSpanish =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "ru") {
        _this.edituser.certificateEventTrainingCategoryNameRussian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherRussian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionRussian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameRussian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherRussian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionRussian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "kk") {
        _this.edituser.certificateEventTrainingCategoryNameKazak =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherKazak =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionKazak =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameKazak =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherKazak =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionKazak =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "it") {
        _this.edituser.certificateEventTrainingCategoryNameItalian =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherItalian =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionItalian =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameItalian =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherItalian =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionItalian =
          _this.edituser.certificateTrainingDescription;
      } else if (language === "zh") {
        _this.edituser.certificateEventTrainingCategoryNameChina =
          _this.edituser.certificateEventTrainingCategoryName;
        _this.edituser.certificateEventTrainingCategoryNameOtherChina =
          _this.edituser.certificateEventTrainingCategoryNameOther;
        _this.edituser.certificateEventTrainingCategoryDescriptionChina =
          _this.edituser.certificateEventTrainingCategoryDescription;
        _this.edituser.certificateTrainingNameChina =
          _this.edituser.certificateTrainingName;
        _this.edituser.certificateTrainingNameOtherChina =
          _this.edituser.certificateTrainingNameOther;
        _this.edituser.certificateTrainingDescriptionChina =
          _this.edituser.certificateTrainingDescription;
      }
      if (
        typeof this.edituser.tenantId === "object" &&
        this.edituser.tenantId !== null
      ) {
        this.edituser.tenantId = this.edituser.tenantId.id;
      }
      let request = {
        certificateStartDate_PR_1: this.edituser.certificateStartDate_PR_1,
        certificateStartDate_PR_2: this.edituser.certificateStartDate_PR_2,
        certificateStartDate_PR_3: this.edituser.certificateStartDate_PR_3,
        certificateStartDate_TH_1: this.edituser.certificateStartDate_TH_1,
        certificateStartDate_TH_2: this.edituser.certificateStartDate_TH_2,
        certificateStartDate_TH_3: this.edituser.certificateStartDate_TH_3,
        certificateEndDate_PR_1: this.edituser.certificateEndDate_PR_1,
        certificateEndDate_PR_2: this.edituser.certificateEndDate_PR_2,
        certificateEndDate_PR_3: this.edituser.certificateEndDate_PR_3,
        certificateEndDate_TH_1: this.edituser.certificateEndDate_TH_1,
        certificateEndDate_TH_2: this.edituser.certificateEndDate_TH_2,
        certificateEndDate_TH_3: this.edituser.certificateEndDate_TH_3,
        certificateTrainer2_PR_1: this.edituser.certificateTrainer2_PR_1,
        certificateTrainer2_PR_2: this.edituser.certificateTrainer2_PR_2,
        certificateTrainer2_PR_3: this.edituser.certificateTrainer2_PR_3,
        certificateTrainer2_TH_1: this.edituser.certificateTrainer2_TH_1,
        certificateTrainer2_TH_2: this.edituser.certificateTrainer2_TH_2,
        certificateTrainer2_TH_3: this.edituser.certificateTrainer2_TH_3,
        certificateTrainer_PR_1: this.edituser.certificateTrainer_PR_1,
        certificateTrainer_PR_2: this.edituser.certificateTrainer_PR_2,
        certificateTrainer_PR_3: this.edituser.certificateTrainer_PR_3,
        certificateTrainer_TH_1: this.edituser.certificateTrainer_TH_1,
        certificateTrainer_TH_2: this.edituser.certificateTrainer_TH_2,
        certificateTrainer_TH_3: this.edituser.certificateTrainer_TH_3,
        certificateEventLocation_PR_1:
          this.edituser.certificateEventLocation_PR_1,
        certificateEventLocation_PR_2:
          this.edituser.certificateEventLocation_PR_2,
        certificateEventLocation_PR_3:
          this.edituser.certificateEventLocation_PR_3,
        certificateEventLocation_TH_1:
          this.edituser.certificateEventLocation_TH_1,
        certificateEventLocation_TH_2:
          this.edituser.certificateEventLocation_TH_2,
        certificateEventLocation_TH_3:
          this.edituser.certificateEventLocation_TH_3,
        firstname: this.edituser.firstname.trim(),
        lastname: this.edituser.lastname.trim(),
        personnelnumber: this.edituser.personnelnumber,
        location: this.edituser.location,
        company: this.edituser.company,
        email: this.edituser.email,
        tenantId: this.edituser.tenantId,
        selectedStatus: this.edituser.selectedStatus,
        trainingEventId: this.edituser.trainingEventId,
        id: this.edituser.id,
        userId: this.edituser.userId,
        language: this.edituser.language,
        certificateStartDate: this.edituser.certificateStartDate,
        certificateEndDate: this.edituser.certificateEndDate,
        certificateEventLocation: this.edituser.certificateEventLocation,
        certificateEventNumber: this.edituser.certificateEventNumber,
        certificateTrainer: this.edituser.certificateTrainer,
        certificateTrainer2: this.edituser.certificateTrainer2,
        certificateStartDateOther: this.edituser.certificateStartDateOther,
        certificateEndDateOther: this.edituser.certificateEndDateOther,
        eventStatus: this.edituser.eventStatus,
        eventStatusOther: this.edituser.eventStatusOther,
        display: this.edituser.display,
        certificateEventLocationOther:
          this.edituser.certificateEventLocationOther,
        certificateEventNumberOther: this.edituser.certificateEventNumberOther,
        certificateTrainerOther: this.edituser.certificateTrainerOther,
        certificateTrainer2Other: this.edituser.certificateTrainer2Other,
        certificateTrainingNameEnglish:
          this.edituser.certificateTrainingNameEnglish,
        certificateTrainingNameGerman:
          this.edituser.certificateTrainingNameGerman,
        certificateTrainingNamePolish:
          this.edituser.certificateTrainingNamePolish,
        certificateTrainingNameFrench:
          this.edituser.certificateTrainingNameFrench,
        certificateTrainingNameHungarian:
          this.edituser.certificateTrainingNameHungarian,
        certificateTrainingNameSpanish:
          this.edituser.certificateTrainingNameSpanish,
        certificateTrainingNameRussian:
          this.edituser.certificateTrainingNameRussian,
        certificateTrainingNameKazak:
          this.edituser.certificateTrainingNameKazak,
        certificateTrainingNameItalian:
          this.edituser.certificateTrainingNameItalian,
        certificateTrainingNameChina:
          this.edituser.certificateTrainingNameChina,

        certificateTrainingNameOtherEnglish:
          this.edituser.certificateTrainingNameOtherEnglish,
        certificateTrainingNameOtherGerman:
          this.edituser.certificateTrainingNameOtherGerman,
        certificateTrainingNameOtherPolish:
          this.edituser.certificateTrainingNameOtherPolish,
        certificateTrainingNameOtherFrench:
          this.edituser.certificateTrainingNameOtherFrench,
        certificateTrainingNameOtherHungarian:
          this.edituser.certificateTrainingNameOtherHungarian,
        certificateTrainingNameOtherSpanish:
          this.edituser.certificateTrainingNameOtherSpanish,
        certificateTrainingNameOtherRussian:
          this.edituser.certificateTrainingNameOtherRussian,
        certificateTrainingNameOtherKazak:
          this.edituser.certificateTrainingNameOtherKazak,
        certificateTrainingNameOtherItalian:
          this.edituser.certificateTrainingNameOtherItalian,
        certificateTrainingNameOtherChina:
          this.edituser.certificateTrainingNameOtherChina,

        certificateTrainingDescriptionEnglish:
          this.edituser.certificateTrainingDescriptionEnglish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionEnglish,
                false
              )
            : null,
        certificateTrainingDescriptionGerman:
          this.edituser.certificateTrainingDescriptionGerman !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionGerman,
                false
              )
            : null,
        certificateTrainingDescriptionPolish:
          this.edituser.certificateTrainingDescriptionPolish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionPolish,
                false
              )
            : null,
        certificateTrainingDescriptionFrench:
          this.edituser.certificateTrainingDescriptionFrench !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionFrench,
                false
              )
            : null,
        certificateTrainingDescriptionHungarian:
          this.edituser.certificateTrainingDescriptionHungarian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionHungarian,
                false
              )
            : null,
        certificateTrainingDescriptionSpanish:
          this.edituser.certificateTrainingDescriptionSpanish !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionSpanish,
                false
              )
            : null,
        certificateTrainingDescriptionRussian:
          this.edituser.certificateTrainingDescriptionRussian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionRussian,
                false
              )
            : null,
        certificateTrainingDescriptionKazak:
          this.edituser.certificateTrainingDescriptionKazak !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionKazak,
                false
              )
            : null,
        certificateTrainingDescriptionItalian:
          this.edituser.certificateTrainingDescriptionItalian !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionItalian,
                false
              )
            : null,
        certificateTrainingDescriptionChina:
          this.edituser.certificateTrainingDescriptionChina !== null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionChina,
                false
              )
            : null,

        certificateEventTrainingCategoryNameEnglish:
          this.edituser.certificateEventTrainingCategoryNameEnglish,
        certificateEventTrainingCategoryNameGerman:
          this.edituser.certificateEventTrainingCategoryNameGerman,
        certificateEventTrainingCategoryNamePolish:
          this.edituser.certificateEventTrainingCategoryNamePolish,
        certificateEventTrainingCategoryNameFrench:
          this.edituser.certificateEventTrainingCategoryNameFrench,
        certificateEventTrainingCategoryNameHungarian:
          this.edituser.certificateEventTrainingCategoryNameHungarian,
        certificateEventTrainingCategoryNameSpanish:
          this.edituser.certificateEventTrainingCategoryNameSpanish,
        certificateEventTrainingCategoryNameRussian:
          this.edituser.certificateEventTrainingCategoryNameRussian,
        certificateEventTrainingCategoryNameKazak:
          this.edituser.certificateEventTrainingCategoryNameKazak,
        certificateEventTrainingCategoryNameItalian:
          this.edituser.certificateEventTrainingCategoryNameItalian,
        certificateEventTrainingCategoryNameChina:
          this.edituser.certificateEventTrainingCategoryNameChina,

        certificateEventTrainingCategoryNameOtherEnglish:
          this.edituser.certificateEventTrainingCategoryNameOtherEnglish,
        certificateEventTrainingCategoryNameOtherGerman:
          this.edituser.certificateEventTrainingCategoryNameOtherGerman,
        certificateEventTrainingCategoryNameOtherPolish:
          this.edituser.certificateEventTrainingCategoryNameOtherPolish,
        certificateEventTrainingCategoryNameOtherFrench:
          this.edituser.certificateEventTrainingCategoryNameOtherFrench,
        certificateEventTrainingCategoryNameOtherHungarian:
          this.edituser.certificateEventTrainingCategoryNameOtherHungarian,
        certificateEventTrainingCategoryNameOtherSpanish:
          this.edituser.certificateEventTrainingCategoryNameOtherSpanish,
        certificateEventTrainingCategoryNameOtherRussian:
          this.edituser.certificateEventTrainingCategoryNameOtherRussian,
        certificateEventTrainingCategoryNameOtherKazak:
          this.edituser.certificateEventTrainingCategoryNameOtherKazak,
        certificateEventTrainingCategoryNameOtherItalian:
          this.edituser.certificateEventTrainingCategoryNameOtherItalian,
        certificateEventTrainingCategoryNameOtherChina:
          this.edituser.certificateEventTrainingCategoryNameOtherChina,

        certificateEventTrainingCategoryDescriptionEnglish:
          this.edituser.certificateEventTrainingCategoryDescriptionEnglish !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionEnglish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionGerman:
          this.edituser.certificateEventTrainingCategoryDescriptionGerman !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionGerman,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionPolish:
          this.edituser.certificateEventTrainingCategoryDescriptionPolish !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionPolish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionFrench:
          this.edituser.certificateEventTrainingCategoryDescriptionFrench !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionFrench,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionHungarian:
          this.edituser.certificateEventTrainingCategoryDescriptionHungarian !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionHungarian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionSpanish:
          this.edituser.certificateEventTrainingCategoryDescriptionSpanish !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionSpanish,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionRussian:
          this.edituser.certificateEventTrainingCategoryDescriptionRussian !==
          null
            ? this.$convertHtml(
                this.edituser
                  .certificateEventTrainingCategoryDescriptionRussian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionKazak:
          this.edituser.certificateEventTrainingCategoryDescriptionKazak !==
          null
            ? this.$convertHtml(
                this.edituser.certificateEventTrainingCategoryDescriptionKazak,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionItalian:
          this.edituser.certificateEventTrainingCategoryDescriptionItalian !==
          null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionItalian,
                false
              )
            : null,
        certificateEventTrainingCategoryDescriptionChina:
          this.edituser.certificateEventTrainingCategoryDescriptionChina !==
          null
            ? this.$convertHtml(
                this.edituser.certificateTrainingDescriptionChina,
                false
              )
            : null,
      };
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      let currentEventId = parseInt(this.edituser.trainingEventId, 10);
      this.$axios
        .put("/api/booking/updateBooking/events/" + currentEventId, request)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("participant_edited", { name: username })
          );
          _this.edituser = {
            firstname: null,
            lastname: null,
            personnelnumber: null,
            location: null,
            company: null,
            email: null,
            tenantId: null,
            selectedStatus: null,
            certificateStartDate: null,
            certificateEndDate: null,
            certificateEventLocation: null,
            certificateEventNumber: null,
            certificateTrainer: null,
            certificateTrainer2: null,
            certificateStartDateOther: null,
            certificateEndDateOther: null,
            display: null,
            eventStatus: null,
            eventStatusOther: null,
            certificateEventLocationOther: null,
            certificateEventNumberOther: null,
            certificateTrainerOther: null,
            certificateTrainer2Other: null,
            certificateTrainingNameEnglish: null,
            certificateTrainingNameGerman: null,
            certificateTrainingNamePolish: null,
            certificateTrainingNameFrench: null,
            certificateTrainingNameHungarian: null,
            certificateTrainingNameSpanish: null,
            certificateTrainingNameRussian: null,
            certificateTrainingNameKazak: null,
            certificateTrainingNameItalian: null,
            certificateTrainingNameChina: null,

            certificateTrainingNameOtherEnglish: null,
            certificateTrainingNameOtherGerman: null,
            certificateTrainingNameOtherPolish: null,
            certificateTrainingNameOtherFrench: null,
            certificateTrainingNameOtherHungarian: null,
            certificateTrainingNameOtherSpanish: null,
            certificateTrainingNameOtherRussian: null,
            certificateTrainingNameOtherKazak: null,
            certificateTrainingNameOtherItalian: null,
            certificateTrainingNameOtherChina: null,

            certificateTrainingName: null,
            certificateTrainingNameOther: null,
            certificateTrainingDescription: null,
            certificateTrainingDescriptionEnglish: null,
            certificateTrainingDescriptionGerman: null,
            certificateTrainingDescriptionPolish: null,
            certificateTrainingDescriptionFrench: null,
            certificateTrainingDescriptionHungarian: null,
            certificateTrainingDescriptionSpanish: null,
            certificateTrainingDescriptionRussian: null,
            certificateTrainingDescriptionKazak: null,
            certificateTrainingDescriptionItalian: null,
            certificateTrainingDescriptionChina: null,

            certificateEventTrainingCategoryNameEnglish: null,
            certificateEventTrainingCategoryNameGerman: null,
            certificateEventTrainingCategoryNamePolish: null,
            certificateEventTrainingCategoryNameFrench: null,
            certificateEventTrainingCategoryNameHungarian: null,
            certificateEventTrainingCategoryNameSpanish: null,
            certificateEventTrainingCategoryNameRussian: null,
            certificateEventTrainingCategoryNameKazak: null,
            certificateEventTrainingCategoryNameItalian: null,
            certificateEventTrainingCategoryNameChina: null,
            certificateEventTrainingCategoryNameOtherEnglish: null,
            certificateEventTrainingCategoryNameOtherGerman: null,
            certificateEventTrainingCategoryNameOtherPolish: null,
            certificateEventTrainingCategoryNameOtherFrench: null,
            certificateEventTrainingCategoryNameOtherHungarian: null,
            certificateEventTrainingCategoryNameOtherSpanish: null,
            certificateEventTrainingCategoryNameOtherRussian: null,
            certificateEventTrainingCategoryNameOtherKazak: null,
            certificateEventTrainingCategoryNameOtherItalian: null,
            certificateEventTrainingCategoryNameOtherChina: null,

            certificateEventTrainingCategoryName: null,
            certificateEventTrainingCategoryNameOther: null,
            certificateEventTrainingCategoryDescription: null,
            certificateEventTrainingCategoryDescriptionEnglish: null,
            certificateEventTrainingCategoryDescriptionGerman: null,
            certificateEventTrainingCategoryDescriptionPolish: null,
            certificateEventTrainingCategoryDescriptionFrench: null,
            certificateEventTrainingCategoryDescriptionHungarian: null,
            certificateEventTrainingCategoryDescriptionSpanish: null,
            certificateEventTrainingCategoryDescriptionRussian: null,
            certificateEventTrainingCategoryDescriptionKazak: null,
            certificateEventTrainingCategoryDescriptionItalian: null,
            certificateEventTrainingCategoryDescriptionChina: null,
          };
          _this.fetchBookingsEdit();
        })
        .catch(this.onError)
        .finally(this.onFinally);

      this.showModal = false;

      setTimeout(() => {
        window.scrollTo(this.scrollPositionX, this.scrollPositionY);
        // _this.fetchBookings();
        _this.fetchUsers();
      }, 1000);
      document.getElementById("edit_participant_firstname").focus();
    },

    /**
     * Old Method to add directly one user to Event
     */
    addParticipantWithUser(user) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .post("/api/booking/user", {
          userId: user.id,
          trainingEventId: this.trainingEvent.id,
          invitationsSent: 0,
        })
        .then(function (response) {
          _this.$noty.success(
            _this.$t("participant_added", { name: user.fullname })
          );
          _this.fetchBookings();
          _this.fetchUsers();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    /**
     * Searchs for a user by the given ID and type (allowed types are trainers, translators)
     */
    getArrayElementById(arrayName, id) {
      if (id == null) return null;
      for (let i = 0; i < this[arrayName].length; i++) {
        const user = this[arrayName][i];
        if (user.id == id) return user;
      }
      return {};
    },

    getShareMailText() {
      return this.$t("share_mail_content", { link: window.location.href });
    },

    setDateTimeColumns(value) {
      if (!this.editMode) {
        this.trainingEvent.startDate = null;
        this.trainingEvent.selectedLocationId = null;
        this.trainingEvent.endDate = null;
        this.trainingEvent.onlineLink = null;
        this.trainingEvent.trainer2Id = null;
        this.trainingEvent.trainerId = null;
        this.trainingEvent.translatorId = null;
        this.trainingEvent.roomId = null;
        this.trainingEvent.startTime = null;
        this.trainingEvent.endTime = null;

        this.trainingEvent.selectedLocationId_PR_1 = null;
        this.trainingEvent.selectedLocationId_PR_2 = null;
        this.trainingEvent.selectedLocationId_PR_3 = null;
        this.trainingEvent.selectedLocationId_TH_1 = null;
        this.trainingEvent.selectedLocationId_TH_2 = null;
        this.trainingEvent.selectedLocationId_TH_3 = null;
        this.trainingEvent.startDate_PR_1 = null;
        this.trainingEvent.startDate_PR_2 = null;
        this.trainingEvent.startDate_PR_3 = null;
        this.trainingEvent.startDate_TH_1 = null;
        this.trainingEvent.startDate_TH_2 = null;
        this.trainingEvent.startDate_TH_3 = null;
        this.trainingEvent.endDate_PR_1 = null;
        this.trainingEvent.endDate_PR_2 = null;
        this.trainingEvent.endDate_PR_3 = null;
        this.trainingEvent.endDate_TH_1 = null;
        this.trainingEvent.endDate_TH_2 = null;
        this.trainingEvent.endDate_TH_3 = null;
        this.trainingEvent.onlinelink_PR_1 = null;
        this.trainingEvent.onlinelink_PR_2 = null;
        this.trainingEvent.onlinelink_PR_3 = null;
        this.trainingEvent.onlinelink_TH_1 = null;
        this.trainingEvent.onlinelink_TH_2 = null;
        this.trainingEvent.onlinelink_TH_3 = null;
        this.trainingEvent.startTime_PR_1 = null;
        this.trainingEvent.startTime_PR_2 = null;
        this.trainingEvent.startTime_PR_3 = null;
        this.trainingEvent.startTime_TH_1 = null;
        this.trainingEvent.startTime_TH_2 = null;
        this.trainingEvent.startTime_TH_3 = null;
        this.trainingEvent.endTime_PR_1 = null;
        this.trainingEvent.endTime_PR_2 = null;
        this.trainingEvent.endTime_PR_3 = null;
        this.trainingEvent.endTime_TH_1 = null;
        this.trainingEvent.endTime_TH_2 = null;
        this.trainingEvent.endTime_TH_3 = null;
        this.trainingEvent.trainerId_PR_1 = null;
        this.trainingEvent.trainerId_PR_2 = null;
        this.trainingEvent.trainerId_PR_3 = null;
        this.trainingEvent.trainerId_TH_1 = null;
        this.trainingEvent.trainerId_TH_2 = null;
        this.trainingEvent.trainerId_TH_3 = null;
        this.trainingEvent.trainerId2_PR_1 = null;
        this.trainingEvent.trainerId2_PR_2 = null;
        this.trainingEvent.trainerId2_PR_3 = null;
        this.trainingEvent.trainerId2_TH_1 = null;
        this.trainingEvent.trainerId2_TH_2 = null;
        this.trainingEvent.trainerId2_TH_3 = null;
        this.trainingEvent.translatorId_PR_1 = null;
        this.trainingEvent.translatorId_PR_2 = null;
        this.trainingEvent.translatorId_PR_3 = null;
        this.trainingEvent.translatorId_TH_1 = null;
        this.trainingEvent.translatorId_TH_2 = null;
        this.trainingEvent.translatorId_TH_3 = null;
        this.trainingEvent.roomId_PR_1 = null;
        this.trainingEvent.roomId_PR_2 = null;
        this.trainingEvent.roomId_PR_3 = null;
        this.trainingEvent.roomId_TH_1 = null;
        this.trainingEvent.roomId_TH_2 = null;
        this.trainingEvent.roomId_TH_3 = null;
      } else {
        if (
          value == "ORAL" ||
          value == "THEORETICAL" ||
          value == "ORAL_AND_THEORETICAL"
        ) {
          this.trainingEvent.selectedLocationId_PR_1 = null;
          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.selectedLocationId_TH_1 = null;
          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;
          this.trainingEvent.startDate_PR_1 = null;
          this.trainingEvent.startDate_PR_2 = null;
          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_1 = null;
          this.trainingEvent.startDate_TH_2 = null;
          this.trainingEvent.startDate_TH_3 = null;
          this.trainingEvent.endDate_PR_1 = null;
          this.trainingEvent.endDate_PR_2 = null;
          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_1 = null;
          this.trainingEvent.endDate_TH_2 = null;
          this.trainingEvent.endDate_TH_3 = null;
          this.trainingEvent.onlinelink_PR_1 = null;
          this.trainingEvent.onlinelink_PR_2 = null;
          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_1 = null;
          this.trainingEvent.onlinelink_TH_2 = null;
          this.trainingEvent.onlinelink_TH_3 = null;
          this.trainingEvent.startTime_PR_1 = null;
          this.trainingEvent.startTime_PR_2 = null;
          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_1 = null;
          this.trainingEvent.startTime_TH_2 = null;
          this.trainingEvent.startTime_TH_3 = null;
          this.trainingEvent.endTime_PR_1 = null;
          this.trainingEvent.endTime_PR_2 = null;
          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_1 = null;
          this.trainingEvent.endTime_TH_2 = null;
          this.trainingEvent.endTime_TH_3 = null;
          this.trainingEvent.trainerId_PR_1 = null;
          this.trainingEvent.trainerId_PR_2 = null;
          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_1 = null;
          this.trainingEvent.trainerId_TH_2 = null;
          this.trainingEvent.trainerId_TH_3 = null;
          this.trainingEvent.trainerId2_PR_1 = null;
          this.trainingEvent.trainerId2_PR_2 = null;
          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_1 = null;
          this.trainingEvent.trainerId2_TH_2 = null;
          this.trainingEvent.trainerId2_TH_3 = null;
          this.trainingEvent.translatorId_PR_1 = null;
          this.trainingEvent.translatorId_PR_2 = null;
          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_1 = null;
          this.trainingEvent.translatorId_TH_2 = null;
          this.trainingEvent.translatorId_TH_3 = null;
          this.trainingEvent.roomId_PR_1 = null;
          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_1 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "ORAL_THEORETICAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;

          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_PR_2 = null;
          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_2 = null;
          this.trainingEvent.startDate_TH_3 = null;
          this.trainingEvent.endDate_PR_2 = null;
          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_2 = null;
          this.trainingEvent.endDate_TH_3 = null;
          this.trainingEvent.onlinelink_PR_2 = null;
          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_2 = null;
          this.trainingEvent.onlinelink_TH_3 = null;
          this.trainingEvent.startTime_PR_2 = null;
          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_2 = null;
          this.trainingEvent.startTime_TH_3 = null;
          this.trainingEvent.endTime_PR_2 = null;
          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_2 = null;
          this.trainingEvent.endTime_TH_3 = null;
          this.trainingEvent.trainerId_PR_2 = null;
          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_2 = null;
          this.trainingEvent.trainerId_TH_3 = null;
          this.trainingEvent.trainerId2_PR_2 = null;
          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_2 = null;
          this.trainingEvent.trainerId2_TH_3 = null;
          this.trainingEvent.translatorId_PR_2 = null;
          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_2 = null;
          this.trainingEvent.translatorId_TH_3 = null;
          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "ORAL_ORAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.selectedLocationId_TH_1 = null;
          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_1 = null;
          this.trainingEvent.startDate_TH_2 = null;
          this.trainingEvent.startDate_TH_3 = null;

          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_1 = null;
          this.trainingEvent.endDate_TH_2 = null;
          this.trainingEvent.endDate_TH_3 = null;

          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_1 = null;
          this.trainingEvent.onlinelink_TH_2 = null;
          this.trainingEvent.onlinelink_TH_3 = null;

          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_1 = null;
          this.trainingEvent.startTime_TH_2 = null;
          this.trainingEvent.startTime_TH_3 = null;

          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_1 = null;
          this.trainingEvent.endTime_TH_2 = null;
          this.trainingEvent.endTime_TH_3 = null;

          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_1 = null;
          this.trainingEvent.trainerId_TH_2 = null;
          this.trainingEvent.trainerId_TH_3 = null;

          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_1 = null;
          this.trainingEvent.trainerId2_TH_2 = null;
          this.trainingEvent.trainerId2_TH_3 = null;

          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_1 = null;
          this.trainingEvent.translatorId_TH_2 = null;
          this.trainingEvent.translatorId_TH_3 = null;

          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_1 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "THEORETICAL_THEORETICAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_1 = null;
          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_PR_1 = null;
          this.trainingEvent.startDate_PR_2 = null;
          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_3 = null;

          this.trainingEvent.endDate_PR_1 = null;
          this.trainingEvent.endDate_PR_2 = null;
          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_3 = null;

          this.trainingEvent.onlinelink_PR_1 = null;
          this.trainingEvent.onlinelink_PR_2 = null;
          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_3 = null;

          this.trainingEvent.startTime_PR_1 = null;
          this.trainingEvent.startTime_PR_2 = null;
          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_3 = null;

          this.trainingEvent.endTime_PR_1 = null;
          this.trainingEvent.endTime_PR_2 = null;
          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_3 = null;

          this.trainingEvent.trainerId_PR_1 = null;
          this.trainingEvent.trainerId_PR_2 = null;
          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_3 = null;

          this.trainingEvent.trainerId2_PR_1 = null;
          this.trainingEvent.trainerId2_PR_2 = null;
          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_3 = null;

          this.trainingEvent.translatorId_PR_1 = null;
          this.trainingEvent.translatorId_PR_2 = null;
          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_3 = null;

          this.trainingEvent.roomId_PR_1 = null;
          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "ORAL_ORAL_AND_THEORETICAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_2 = null;
          this.trainingEvent.startDate_TH_3 = null;

          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_2 = null;
          this.trainingEvent.endDate_TH_3 = null;

          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_2 = null;
          this.trainingEvent.onlinelink_TH_3 = null;

          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_2 = null;
          this.trainingEvent.startTime_TH_3 = null;

          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_2 = null;
          this.trainingEvent.endTime_TH_3 = null;

          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_2 = null;
          this.trainingEvent.trainerId_TH_3 = null;

          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_2 = null;
          this.trainingEvent.trainerId2_TH_3 = null;

          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_2 = null;
          this.trainingEvent.translatorId_TH_3 = null;

          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "ORAL_ORAL_AND_ORAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;

          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_TH_1 = null;
          this.trainingEvent.selectedLocationId_TH_2 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_TH_1 = null;
          this.trainingEvent.startDate_TH_2 = null;
          this.trainingEvent.startDate_TH_3 = null;

          this.trainingEvent.endDate_TH_1 = null;
          this.trainingEvent.endDate_TH_2 = null;
          this.trainingEvent.endDate_TH_3 = null;

          this.trainingEvent.onlinelink_TH_1 = null;
          this.trainingEvent.onlinelink_TH_2 = null;
          this.trainingEvent.onlinelink_TH_3 = null;

          this.trainingEvent.startTime_TH_1 = null;
          this.trainingEvent.startTime_TH_2 = null;
          this.trainingEvent.startTime_TH_3 = null;

          this.trainingEvent.endTime_TH_1 = null;
          this.trainingEvent.endTime_TH_2 = null;
          this.trainingEvent.endTime_TH_3 = null;

          this.trainingEvent.trainerId_TH_1 = null;
          this.trainingEvent.trainerId_TH_2 = null;
          this.trainingEvent.trainerId_TH_3 = null;

          this.trainingEvent.trainerId2_TH_1 = null;
          this.trainingEvent.trainerId2_TH_2 = null;
          this.trainingEvent.trainerId2_TH_3 = null;

          this.trainingEvent.translatorId_TH_1 = null;
          this.trainingEvent.translatorId_TH_2 = null;
          this.trainingEvent.translatorId_TH_3 = null;

          this.trainingEvent.roomId_TH_1 = null;
          this.trainingEvent.roomId_TH_2 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "THEORETICAL_THEORETICAL_AND_ORAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;
          this.trainingEvent.selectedLocationId_TH_3 = null;

          this.trainingEvent.startDate_PR_2 = null;
          this.trainingEvent.startDate_PR_3 = null;
          this.trainingEvent.startDate_TH_3 = null;

          this.trainingEvent.endDate_PR_2 = null;
          this.trainingEvent.endDate_PR_3 = null;
          this.trainingEvent.endDate_TH_3 = null;

          this.trainingEvent.onlinelink_PR_2 = null;
          this.trainingEvent.onlinelink_PR_3 = null;
          this.trainingEvent.onlinelink_TH_3 = null;

          this.trainingEvent.startTime_PR_2 = null;
          this.trainingEvent.startTime_PR_3 = null;
          this.trainingEvent.startTime_TH_3 = null;

          this.trainingEvent.endTime_PR_2 = null;
          this.trainingEvent.endTime_PR_3 = null;
          this.trainingEvent.endTime_TH_3 = null;

          this.trainingEvent.trainerId_PR_2 = null;
          this.trainingEvent.trainerId_PR_3 = null;
          this.trainingEvent.trainerId_TH_3 = null;

          this.trainingEvent.trainerId2_PR_2 = null;
          this.trainingEvent.trainerId2_PR_3 = null;
          this.trainingEvent.trainerId2_TH_3 = null;

          this.trainingEvent.translatorId_PR_2 = null;
          this.trainingEvent.translatorId_PR_3 = null;
          this.trainingEvent.translatorId_TH_3 = null;

          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
          this.trainingEvent.roomId_TH_3 = null;
        } else if (value == "THEORETICAL_THEORETICAL_AND_THEROTICAL") {
          this.trainingEvent.startDate = null;
          this.trainingEvent.selectedLocationId = null;
          this.trainingEvent.endDate = null;
          this.trainingEvent.onlineLink = null;
          this.trainingEvent.trainer2Id = null;
          this.trainingEvent.trainerId = null;
          this.trainingEvent.translatorId = null;
          this.trainingEvent.roomId = null;
          this.trainingEvent.startTime = null;
          this.trainingEvent.endTime = null;

          this.trainingEvent.selectedLocationId_PR_1 = null;
          this.trainingEvent.selectedLocationId_PR_2 = null;
          this.trainingEvent.selectedLocationId_PR_3 = null;

          this.trainingEvent.startDate_PR_1 = null;
          this.trainingEvent.startDate_PR_2 = null;
          this.trainingEvent.startDate_PR_3 = null;

          this.trainingEvent.endDate_PR_1 = null;
          this.trainingEvent.endDate_PR_2 = null;
          this.trainingEvent.endDate_PR_3 = null;

          this.trainingEvent.onlinelink_PR_1 = null;
          this.trainingEvent.onlinelink_PR_2 = null;
          this.trainingEvent.onlinelink_PR_3 = null;

          this.trainingEvent.startTime_PR_1 = null;
          this.trainingEvent.startTime_PR_2 = null;
          this.trainingEvent.startTime_PR_3 = null;

          this.trainingEvent.endTime_PR_1 = null;
          this.trainingEvent.endTime_PR_2 = null;
          this.trainingEvent.endTime_PR_3 = null;

          this.trainingEvent.trainerId_PR_1 = null;
          this.trainingEvent.trainerId_PR_2 = null;
          this.trainingEvent.trainerId_PR_3 = null;

          this.trainingEvent.trainerId2_PR_1 = null;
          this.trainingEvent.trainerId2_PR_2 = null;
          this.trainingEvent.trainerId2_PR_3 = null;

          this.trainingEvent.translatorId_PR_1 = null;
          this.trainingEvent.translatorId_PR_2 = null;
          this.trainingEvent.translatorId_PR_3 = null;

          this.trainingEvent.roomId_PR_1 = null;
          this.trainingEvent.roomId_PR_2 = null;
          this.trainingEvent.roomId_PR_3 = null;
        }
      }

      if (value == "ORAL") {
        this.PR_ST = true;
        this.PR_1 = false;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = false;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "THEORETICAL") {
        this.PR_ST = true;
        this.PR_1 = false;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = false;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "ORAL_AND_THEORETICAL") {
        this.PR_ST = true;
        this.PR_1 = false;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = false;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "ORAL_THEORETICAL") {
        this.PR_ST = false;
        this.PR_1 = true;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = true;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "THEORETICAL_THEORETICAL") {
        this.PR_ST = false;
        this.PR_1 = false;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = true;
        this.TH_2 = true;
        this.TH_3 = false;
      } else if (value == "ORAL_ORAL") {
        this.PR_ST = false;
        this.PR_1 = true;
        this.PR_2 = true;
        this.PR_3 = false;
        this.TH_1 = false;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "ORAL_ORAL_AND_THEORETICAL") {
        this.PR_ST = false;
        this.PR_1 = true;
        this.PR_2 = true;
        this.PR_3 = false;
        this.TH_1 = true;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "ORAL_ORAL_AND_ORAL") {
        this.PR_ST = false;
        this.PR_1 = true;
        this.PR_2 = true;
        this.PR_3 = true;
        this.TH_1 = false;
        this.TH_2 = false;
        this.TH_3 = false;
      } else if (value == "THEORETICAL_THEORETICAL_AND_ORAL") {
        this.PR_ST = false;
        this.PR_1 = true;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = true;
        this.TH_2 = true;
        this.TH_3 = false;
      } else if (value == "THEORETICAL_THEORETICAL_AND_THEROTICAL") {
        this.PR_ST = false;
        this.PR_1 = false;
        this.PR_2 = false;
        this.PR_3 = false;
        this.TH_1 = true;
        this.TH_2 = true;
        this.TH_3 = true;
      }
    },

    disableTraining() {
      if (this.trainingEvent.eventTrainingCategoryId) {
        this.trainingDisabled = true;
        this.showCategory = true;
        this.traningEvent.trainingId = null;
      } else {
        this.trainingDisabled = false;
      }
    },
    disableTrainingEventCategory() {
      if (this.trainingEvent.trainingId) {
        this.trainingCategoryDisabled = true;
        this.trainingEvent.eventTrainingCategoryId = null;
        this.showCategory = false;
      } else {
        this.trainingCategoryDisabled = false;
      }
    },
    calculateDateDifference(date1_new, date2_new) {
      if (date1_new && date2_new) {
        const date1 = new Date(date1_new);
        const date2 = new Date(date2_new);
        const timeDifference = date2 - date1; // This will be in milliseconds
        const differenceInDays = timeDifference / (1000 * 60 * 60 * 24);
        if (differenceInDays < 0) {
          this.$noty.error(this.$t("invalid_value", { name: this.$t("date") }));
          return;
        }
        return (
          differenceInDays +
          1 +
          " " +
          this.$t(differenceInDays + 1 === 1 ? "day" : "days")
        );
      }
    },
  },
};
</script>
<!-- <style scoped>
.ndc_dialog {
  max-height: 100vh; /* or something like 90vh */
  overflow: visible !important;
}
.multiselect__tags {
    min-height: 60px !important;
}

</style> -->
